import { KeyZone } from '@libs/types/enum'
import type { VK, KK, LK, DVK, DefineDevice } from './define'
import {
  VirtualHE3SEWireless_24g,
  VirtualHE3SEWireless,
  VirtualNa87ProWired,
  VirtualMu68Pro,
  VirtualNd63,
  VirtualMu68Pro_Cyan,
  VirtualNd63_Cyan,
  VirtualMu68_ULTRA,
  VirtualPolar75,
  VirtualMars68ProWireless,
  VirtualMars68ProWireless_24g,
  VirtualMars68,
  VirtualMars68SE,
  VirtualMars68Pro,
  VirtualMars68Wireless_24g,
  VirtualMars68Wireless,
  VirtualMg68Lite,
  VirtualMg68Max,
  VirtualMg68Pro,
  VirtualMg68SE,
  VirtualMg68,
  VirtualMg68Max_24g,
  VirtualMg75,
  VirtualMg75Pro,
  VirtualMer68Lite,
  VirtualMer68,
  VirtualMer68SE,
  VirtualMer68Pro,
  VirtualHe6Ultra,
  VirtualHe6Ultra_24g,
  VirtualMg68Plus,
  VirtualMg75Max,
  VirtualMG68ACE,
  VirtualMG68ACE_W,
  VirtualMG68ACE_W_24g,
  VirtualMars75,
  VirtualND68Pro,
  VirtualND68,
  VirtualND63Max,
  VirtualND63Ultra,
  VirtualMer68Max,
  VirtualMars75Pro,
  VirtualIrokFe87V2,
  VirtualIrokFe87V2IMC,
  VirtualIrokFe87V2_24g,
  VirtualIrokFe87V2C18,
  VirtualRA68,
  VirtualIrokFe87V2IMC_24g,
  VirtualMG63,
  VirtualRA68_1,
  VirtualFE87V2_MuYan,
  VirtualMG68ACE_UpPlus,
  VirtualMG75V2C12,
  VirtualMer68SE_JT,
} from './define'

// Define the KeyDefine interface
export interface KeyDefine {
  Keys: Map<DefineDevice, KK>
  LKeys: Map<DefineDevice, LK>
  DVKs: Map<DefineDevice, DVK>
  VirtualKey: VK
  HID: VK
  Text: string
  Disable: boolean
  Zone?: KeyZone
}

export const defaultVK: VK = 0 as VK
export const FNVK: VK = 0xfa as VK

export const keys: KeyDefine[] = [
  {
    Text: 'm左键',
    Keys: new Map<DefineDevice, KK>([
      [VirtualHE3SEWireless_24g, 0x00 as KK],
      [VirtualHE3SEWireless, 0x00 as KK],
      [VirtualHe6Ultra, 0x00 as KK],
      [VirtualHe6Ultra_24g, 0x00 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x010001 as DVK],
      [VirtualHE3SEWireless, 0x010001 as DVK],
      [VirtualMars68, 0x0100f0 as DVK],
      [VirtualNa87ProWired, 0x7301 as DVK],
      [VirtualHe6Ultra, 0x00010100 as DVK],
      [VirtualMg75Max, 0x4100 as DVK],
      [VirtualMg68Plus, 0x4100 as DVK],
      [VirtualMars75Pro, 0x4100 as DVK],
      [VirtualRA68, 0x4100 as DVK],
      [VirtualMars75, 0x4100 as DVK],
      [VirtualND68Pro, 0x4100 as DVK],
      [VirtualND63Ultra, 0x4100 as DVK],
      [VirtualMer68Max, 0x4100 as DVK],
      [VirtualMer68SE_JT, 0x4100 as DVK],
      [VirtualIrokFe87V2, 0x0080 as DVK],
      [VirtualIrokFe87V2IMC, 0x0080 as DVK],
      [VirtualMG63, 0x070000f0 as DVK],
      [VirtualRA68_1, 0x070000f0 as DVK],
      [VirtualMG75V2C12, 0x070000f0 as DVK],
      [VirtualFE87V2_MuYan, 0x0001 as DVK],
    ]),
    VirtualKey: 0x01 as VK,
    HID: 0xf0 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm右键',
    Keys: new Map<DefineDevice, KK>([
      [VirtualHE3SEWireless_24g, 0x01 as KK],
      [VirtualHE3SEWireless, 0x01 as KK],
      [VirtualHe6Ultra, 0x01 as KK],
      [VirtualHe6Ultra_24g, 0x01 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x010002 as DVK],
      [VirtualHE3SEWireless, 0x010002 as DVK],
      [VirtualMars68, 0x0100f1 as DVK],
      [VirtualNa87ProWired, 0x7302 as DVK],
      [VirtualHe6Ultra, 0x00010200 as DVK],
      [VirtualMg75Max, 0x4200 as DVK],
      [VirtualMg68Plus, 0x4200 as DVK],
      [VirtualMars75, 0x4200 as DVK],
      [VirtualRA68, 0x4200 as DVK],
      [VirtualMars75Pro, 0x4200 as DVK],
      [VirtualND68Pro, 0x4200 as DVK],
      [VirtualND63Ultra, 0x4200 as DVK],
      [VirtualMer68Max, 0x4200 as DVK],
      [VirtualMer68SE_JT, 0x4200 as DVK],
      [VirtualIrokFe87V2, 0x0081 as DVK],
      [VirtualIrokFe87V2IMC, 0x0081 as DVK],
      [VirtualMG63, 0x070000f1 as DVK],
      [VirtualRA68_1, 0x070000f1 as DVK],
      [VirtualMG75V2C12, 0x070000f1 as DVK],
      [VirtualFE87V2_MuYan, 0x0002 as DVK],
    ]),
    VirtualKey: 0x02 as VK,
    HID: 0xf1 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm中键',
    Keys: new Map<DefineDevice, KK>([
      [VirtualHE3SEWireless_24g, 0x02 as KK],
      [VirtualHE3SEWireless, 0x02 as KK],
      [VirtualHe6Ultra, 0x02 as KK],
      [VirtualHe6Ultra_24g, 0x02 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x010004 as DVK],
      [VirtualHE3SEWireless, 0x010004 as DVK],
      [VirtualMars68, 0x0100f2 as DVK],
      [VirtualNa87ProWired, 0x7303 as DVK],
      [VirtualHe6Ultra, 0x00010400 as DVK],
      [VirtualMg75Max, 0x4300 as DVK],
      [VirtualMg68Plus, 0x4300 as DVK],
      [VirtualMars75, 0x4300 as DVK],
      [VirtualRA68, 0x4300 as DVK],
      [VirtualMars75Pro, 0x4300 as DVK],
      [VirtualND68Pro, 0x4300 as DVK],
      [VirtualND63Ultra, 0x4300 as DVK],
      [VirtualMer68Max, 0x4300 as DVK],
      [VirtualMer68SE_JT, 0x4300 as DVK],
      [VirtualIrokFe87V2, 0x0082 as DVK],
      [VirtualIrokFe87V2IMC, 0x0082 as DVK],
      [VirtualMG63, 0x070000f2 as DVK],
      [VirtualRA68_1, 0x070000f2 as DVK],
      [VirtualMG75V2C12, 0x070000f2 as DVK],
      [VirtualFE87V2_MuYan, 0x0004 as DVK],
    ]),
    VirtualKey: 0x04 as VK,
    HID: 0xf2 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm前进键',
    Keys: new Map<DefineDevice, KK>([
      [VirtualHE3SEWireless_24g, 0x04 as KK],
      [VirtualHE3SEWireless, 0x04 as KK],
      [VirtualHe6Ultra, 0x04 as KK],
      [VirtualHe6Ultra_24g, 0x04 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x010010 as DVK],
      [VirtualHE3SEWireless, 0x010010 as DVK],
      [VirtualMars68, 0x0100f4 as DVK],
      [VirtualHe6Ultra, 0x00011000 as DVK],
      [VirtualMg75Max, 0x4400 as DVK],
      [VirtualMg68Plus, 0x4400 as DVK],
      [VirtualMars75, 0x4400 as DVK],
      [VirtualRA68, 0x4400 as DVK],
      [VirtualMars75Pro, 0x4400 as DVK],
      [VirtualND68Pro, 0x4400 as DVK],
      [VirtualND63Ultra, 0x4400 as DVK],
      [VirtualMer68Max, 0x4400 as DVK],
      [VirtualMer68SE_JT, 0x4400 as DVK],
      [VirtualMG63, 0x070000f4 as DVK],
      [VirtualRA68_1, 0x070000f4 as DVK],
      [VirtualMG75V2C12, 0x070000f4 as DVK],
      [VirtualFE87V2_MuYan, 0x0010 as DVK],
    ]),
    VirtualKey: 0x05 as VK,
    HID: 0xf3 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm后退键',
    Keys: new Map<DefineDevice, KK>([
      [VirtualHE3SEWireless_24g, 0x03 as KK],
      [VirtualHE3SEWireless, 0x03 as KK],
      [VirtualHe6Ultra, 0x03 as KK],
      [VirtualHe6Ultra_24g, 0x03 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x010008 as DVK],
      [VirtualHE3SEWireless, 0x010008 as DVK],
      [VirtualMars68, 0x0100f3 as DVK],
      [VirtualHe6Ultra, 0x00010800 as DVK],
      [VirtualMg75Max, 0x4500 as DVK],
      [VirtualMg68Plus, 0x4500 as DVK],
      [VirtualMars75, 0x4500 as DVK],
      [VirtualRA68, 0x4500 as DVK],
      [VirtualMars75Pro, 0x4500 as DVK],
      [VirtualND68Pro, 0x4500 as DVK],
      [VirtualND63Ultra, 0x4500 as DVK],
      [VirtualMer68Max, 0x4500 as DVK],
      [VirtualMer68SE_JT, 0x4500 as DVK],
      [VirtualMG63, 0x070000f3 as DVK],
      [VirtualRA68_1, 0x070000f3 as DVK],
      [VirtualMG75V2C12, 0x070000f3 as DVK],
      [VirtualFE87V2_MuYan, 0x0008 as DVK],
    ]),
    VirtualKey: 0x06 as VK,
    HID: 0xf4 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: ' DPI+',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0553 as DVK],
      [VirtualHE3SEWireless, 0x0553 as DVK],
      [VirtualHe6Ultra, 0x00020200 as DVK],
    ]),
    VirtualKey: 0x98 as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: ' DPI-',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0554 as DVK],
      [VirtualHE3SEWireless, 0x0554 as DVK],
      [VirtualHe6Ultra, 0x00020300 as DVK],
    ]),
    VirtualKey: 0x99 as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'DPI Loop +',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0555 as DVK],
      [VirtualHE3SEWireless, 0x0555 as DVK],
    ]),
    VirtualKey: 0x9a as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'DPI Loop -',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0556 as DVK],
      [VirtualHE3SEWireless, 0x0556 as DVK],
    ]),
    VirtualKey: 0x9b as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm滚轮向上滚动',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7308 as DVK],
      [VirtualMars68, 0x0101f5 as DVK],
      [VirtualMg75Max, 0x4a01 as DVK],
      [VirtualMg68Plus, 0x4a01 as DVK],
      [VirtualMars75, 0x4a01 as DVK],
      [VirtualRA68, 0x4a01 as DVK],
      [VirtualMars75Pro, 0x4a01 as DVK],
      [VirtualND68Pro, 0x4a01 as DVK],
      [VirtualND63Ultra, 0x4a01 as DVK],
      [VirtualMer68Max, 0x4a01 as DVK],
      [VirtualMer68SE_JT, 0x4a01 as DVK],
      [VirtualIrokFe87V2, 0x0083 as DVK],
      [VirtualIrokFe87V2IMC, 0x0083 as DVK],
    ]),
    VirtualKey: 0x9c as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm滚轮向下滚动',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7309 as DVK],
      [VirtualMars68, 0x01fff5 as DVK],
      [VirtualMg75Max, 0x4b01 as DVK],
      [VirtualMg68Plus, 0x4b01 as DVK],
      [VirtualMars75, 0x4b01 as DVK],
      [VirtualRA68, 0x4b01 as DVK],
      [VirtualMars75Pro, 0x4b01 as DVK],
      [VirtualND68Pro, 0x4b01 as DVK],
      [VirtualND63Ultra, 0x4b01 as DVK],
      [VirtualMer68Max, 0x4b01 as DVK],
      [VirtualMer68SE_JT, 0x4b01 as DVK],
      [VirtualIrokFe87V2, 0x0084 as DVK],
      [VirtualIrokFe87V2IMC, 0x0084 as DVK],
    ]),
    VirtualKey: 0x9d as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm鼠标上移',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7306 as DVK],
      [VirtualMg75Max, 0x4800 as DVK],
      [VirtualMg68Plus, 0x4800 as DVK],
      [VirtualMars75, 0x4800 as DVK],
      [VirtualRA68, 0x4800 as DVK],
      [VirtualMars75Pro, 0x4800 as DVK],
      [VirtualND68Pro, 0x4800 as DVK],
      [VirtualND63Ultra, 0x4800 as DVK],
      [VirtualMer68Max, 0x4800 as DVK],
      [VirtualMer68SE_JT, 0x4800 as DVK],
      [VirtualIrokFe87V2, 0x0085 as DVK],
      [VirtualIrokFe87V2IMC, 0x0085 as DVK],
    ]),
    VirtualKey: 0x9e as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm鼠标下移',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7307 as DVK],
      [VirtualMg75Max, 0x4900 as DVK],
      [VirtualMg68Plus, 0x4900 as DVK],
      [VirtualMars75, 0x4900 as DVK],
      [VirtualRA68, 0x4900 as DVK],
      [VirtualMars75Pro, 0x4900 as DVK],
      [VirtualND68Pro, 0x4900 as DVK],
      [VirtualND63Ultra, 0x4900 as DVK],
      [VirtualMer68Max, 0x4900 as DVK],
      [VirtualMer68SE_JT, 0x4900 as DVK],
      [VirtualIrokFe87V2, 0x0086 as DVK],
      [VirtualIrokFe87V2IMC, 0x0086 as DVK],
    ]),
    VirtualKey: 0x9f as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm鼠标左移',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7304 as DVK],
      [VirtualMg75Max, 0x4600 as DVK],
      [VirtualMg68Plus, 0x4600 as DVK],
      [VirtualMars75, 0x4600 as DVK],
      [VirtualRA68, 0x4600 as DVK],
      [VirtualMars75Pro, 0x4600 as DVK],
      [VirtualND68Pro, 0x4600 as DVK],
      [VirtualND63Ultra, 0x4600 as DVK],
      [VirtualMer68Max, 0x4600 as DVK],
      [VirtualMer68SE_JT, 0x4600 as DVK],
      [VirtualIrokFe87V2, 0x0087 as DVK],
      [VirtualIrokFe87V2IMC, 0x0087 as DVK],
    ]),
    VirtualKey: 0x89 as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'm鼠标右移',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualNa87ProWired, 0x7305 as DVK],
      [VirtualMg75Max, 0x4700 as DVK],
      [VirtualMg68Plus, 0x4700 as DVK],
      [VirtualMars75, 0x4700 as DVK],
      [VirtualRA68, 0x4700 as DVK],
      [VirtualMars75Pro, 0x4700 as DVK],
      [VirtualND68Pro, 0x4700 as DVK],
      [VirtualND63Ultra, 0x4700 as DVK],
      [VirtualMer68Max, 0x4700 as DVK],
      [VirtualMer68SE_JT, 0x4700 as DVK],
      [VirtualIrokFe87V2, 0x0088 as DVK],
      [VirtualIrokFe87V2IMC, 0x0088 as DVK],
    ]),
    VirtualKey: 0x8a as VK,
    HID: 0x00 as VK,
    Disable: false,
    Zone: KeyZone.mouse,
  },
  {
    Text: 'backspace',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2a as KK],
      [VirtualFE87V2_MuYan, 0x2a as KK],
      [VirtualPolar75, 0x2a as KK],
      [VirtualMg75, 0x2a as KK],
      [VirtualMg75Pro, 0x2a as KK],
      [VirtualMer68, 0x2a as KK],
      [VirtualMer68Pro, 0x2a as KK],
      [VirtualMer68SE, 0x4f as KK],
      [VirtualMer68Lite, 0x4f as KK],
      [VirtualMu68Pro, 0x2a as KK],
      [VirtualMars68ProWireless, 0x4f as KK],
      [VirtualMars68ProWireless_24g, 0x4f as KK],
      [VirtualMars68, 0x4f as KK],
      [VirtualMg68Lite, 0x4f as KK],
      [VirtualMg68Max, 0x4f as KK],
      [VirtualMg68Max_24g, 0x4f as KK],
      [VirtualMg68Pro, 0x4f as KK],
      [VirtualMg68SE, 0x4f as KK],
      [VirtualMg68, 0x4f as KK],
      [VirtualND63Max, 0x4f as KK],
      [VirtualND68, 0x4f as KK],
      [VirtualMG68ACE_W, 0x4f as KK],
      [VirtualMG68ACE_W_24g, 0x4f as KK],
      [VirtualMG68ACE, 0x4f as KK],
      [VirtualMG68ACE_UpPlus, 0x4f as KK],
      [VirtualMars68Wireless_24g, 0x4f as KK],
      [VirtualMars68Wireless, 0x4f as KK],
      [VirtualMars68Pro, 0x4f as KK],
      [VirtualMars68SE, 0x4f as KK],
      [VirtualMu68Pro_Cyan, 0x2a as KK],
      [VirtualMu68_ULTRA, 0x2a as KK],
      [VirtualNd63, 0x2a as KK],
      [VirtualMG63, 0x2a as KK],
      [VirtualRA68_1, 0x2a as KK],
      [VirtualMG75V2C12, 0x2a as KK],
      [VirtualNd63_Cyan, 0x2a as KK],
      [VirtualMg68Plus, 0x010d as KK], // 新增
      [VirtualMg75Max, 0x010d as KK],
      [VirtualND68Pro, 0x010d as KK],
      [VirtualRA68, 0x010d as KK],
      [VirtualMer68Max, 0x010d as KK],
      [VirtualMer68SE_JT, 0x010d as KK],
      [VirtualND63Ultra, 0x010d as KK],
      [VirtualMars75, 0x010d as KK],
      [VirtualMars75Pro, 0x010d as KK], // 新增
      [VirtualIrokFe87V2, 0x1d as KK],
      [VirtualIrokFe87V2_24g, 0x1d as KK],
      [VirtualIrokFe87V2IMC, 0x1d as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1d as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x08 as VK,
    HID: 0x2a as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'TAB',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2b as KK],
      [VirtualFE87V2_MuYan, 0x2b as KK],
      [VirtualPolar75, 0x2b as KK],
      [VirtualMg75, 0x2b as KK],
      [VirtualMg75Pro, 0x2b as KK],
      [VirtualMer68, 0x2b as KK],
      [VirtualMer68Pro, 0x2b as KK],
      [VirtualMer68SE, 0x02 as KK],
      [VirtualMer68Lite, 0x02 as KK],
      [VirtualMu68Pro, 0x2b as KK],
      [VirtualMars68ProWireless, 0x02 as KK],
      [VirtualMars68ProWireless_24g, 0x02 as KK],
      [VirtualMars68, 0x02 as KK],
      [VirtualMg68Lite, 0x02 as KK],
      [VirtualMg68Max, 0x02 as KK],
      [VirtualMg68Max_24g, 0x02 as KK],
      [VirtualMg68Pro, 0x02 as KK],
      [VirtualMg68SE, 0x02 as KK],
      [VirtualMg68, 0x02 as KK],
      [VirtualND63Max, 0x02 as KK],
      [VirtualND68, 0x02 as KK],
      [VirtualMG68ACE_W, 0x02 as KK],
      [VirtualMG68ACE_W_24g, 0x02 as KK],
      [VirtualMG68ACE, 0x02 as KK],
      [VirtualMG68ACE_UpPlus, 0x02 as KK],
      [VirtualMars68Wireless_24g, 0x02 as KK],
      [VirtualMars68Wireless, 0x02 as KK],
      [VirtualMars68Pro, 0x02 as KK],
      [VirtualMars68SE, 0x02 as KK],
      [VirtualMu68Pro_Cyan, 0x2b as KK],
      [VirtualMu68_ULTRA, 0x2b as KK],
      [VirtualNd63, 0x2b as KK],
      [VirtualMG63, 0x2b as KK],
      [VirtualRA68_1, 0x2b as KK],
      [VirtualMG75V2C12, 0x2b as KK],
      [VirtualNd63_Cyan, 0x2b as KK],
      [VirtualMg68Plus, 0x0200 as KK], // 新增
      [VirtualMg75Max, 0x0200 as KK],
      [VirtualND68Pro, 0x0200 as KK],
      [VirtualRA68, 0x0200 as KK],
      [VirtualMer68Max, 0x0200 as KK],
      [VirtualMer68SE_JT, 0x0200 as KK],
      [VirtualND63Ultra, 0x0200 as KK],
      [VirtualMars75, 0x0200 as KK],
      [VirtualMars75Pro, 0x0200 as KK], // 新增
      [VirtualIrokFe87V2, 0x20 as KK],
      [VirtualIrokFe87V2_24g, 0x20 as KK],
      [VirtualIrokFe87V2IMC, 0x20 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x20 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x09 as VK,
    HID: 0x2b as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'ENTER',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x28 as KK],
      [VirtualFE87V2_MuYan, 0x28 as KK],
      [VirtualPolar75, 0x28 as KK],
      [VirtualMg75, 0x28 as KK],
      [VirtualMg75Pro, 0x28 as KK],
      [VirtualMer68, 0x28 as KK],
      [VirtualMer68Pro, 0x28 as KK],
      [VirtualMer68SE, 0x51 as KK],
      [VirtualMer68Lite, 0x51 as KK],
      [VirtualMu68Pro, 0x28 as KK],
      [VirtualMars68ProWireless, 0x51 as KK],
      [VirtualMars68ProWireless_24g, 0x51 as KK],
      [VirtualMars68, 0x51 as KK],
      [VirtualMg68Lite, 0x51 as KK],
      [VirtualMg68Max, 0x51 as KK],
      [VirtualMg68Max_24g, 0x51 as KK],
      [VirtualMg68Pro, 0x51 as KK],
      [VirtualMg68SE, 0x51 as KK],
      [VirtualMg68, 0x51 as KK],
      [VirtualND63Max, 0x51 as KK],
      [VirtualND68, 0x51 as KK],
      [VirtualMG68ACE_W, 0x51 as KK],
      [VirtualMG68ACE_W_24g, 0x51 as KK],
      [VirtualMG68ACE, 0x51 as KK],
      [VirtualMG68ACE_UpPlus, 0x51 as KK],
      [VirtualMars68Wireless_24g, 0x51 as KK],
      [VirtualMars68Wireless, 0x51 as KK],
      [VirtualMars68Pro, 0x51 as KK],
      [VirtualMars68SE, 0x51 as KK],
      [VirtualMu68Pro_Cyan, 0x28 as KK],
      [VirtualMu68_ULTRA, 0x28 as KK],
      [VirtualNd63, 0x28 as KK],
      [VirtualMG63, 0x28 as KK],
      [VirtualRA68_1, 0x28 as KK],
      [VirtualMG75V2C12, 0x28 as KK],
      [VirtualNd63_Cyan, 0x28 as KK],
      [VirtualMg68Plus, 0x030d as KK], // 新增
      [VirtualMg75Max, 0x030d as KK],
      [VirtualND68Pro, 0x030d as KK],
      [VirtualRA68, 0x030d as KK],
      [VirtualMer68Max, 0x030d as KK],
      [VirtualMer68SE_JT, 0x030d as KK],
      [VirtualND63Ultra, 0x030d as KK],
      [VirtualMars75, 0x030d as KK],
      [VirtualMars75Pro, 0x030d as KK], // 新增
      [VirtualIrokFe87V2, 0x3c as KK],
      [VirtualIrokFe87V2_24g, 0x3c as KK],
      [VirtualIrokFe87V2IMC, 0x3c as KK],
      [VirtualIrokFe87V2IMC_24g, 0x3c as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x0d as VK,
    HID: 0x28 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'PAUSE',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x48 as KK],
      [VirtualFE87V2_MuYan, 0x48 as KK],
      [VirtualIrokFe87V2, 0x0f as KK],
      [VirtualIrokFe87V2_24g, 0x0f as KK],
      [VirtualIrokFe87V2IMC, 0x0f as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0f as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x13 as VK,
    HID: 0x48 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'CAP',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x39 as KK],
      [VirtualFE87V2_MuYan, 0x39 as KK],
      [VirtualPolar75, 0x39 as KK],
      [VirtualMg75, 0x39 as KK],
      [VirtualMg75Pro, 0x39 as KK],
      [VirtualMer68, 0x39 as KK],
      [VirtualMer68Pro, 0x39 as KK],

      [VirtualMu68Pro, 0x39 as KK],
      [VirtualMars68ProWireless, 0x03 as KK],
      [VirtualMars68ProWireless_24g, 0x03 as KK],
      [VirtualMars68, 0x03 as KK],
      [VirtualMg68Lite, 0x03 as KK],
      [VirtualMg68Max, 0x03 as KK],
      [VirtualMg68Max_24g, 0x03 as KK],
      [VirtualMg68Pro, 0x03 as KK],
      [VirtualMg68SE, 0x03 as KK],
      [VirtualMg68, 0x03 as KK],
      [VirtualND63Max, 0x03 as KK],
      [VirtualND68, 0x03 as KK],
      [VirtualMG68ACE_W, 0x03 as KK],
      [VirtualMG68ACE_W_24g, 0x03 as KK],
      [VirtualMG68ACE, 0x03 as KK],
      [VirtualMG68ACE_UpPlus, 0x03 as KK],
      [VirtualMars68Wireless_24g, 0x03 as KK],
      [VirtualMars68Wireless, 0x03 as KK],
      [VirtualMars68Pro, 0x03 as KK],
      [VirtualMars68SE, 0x03 as KK],
      [VirtualMu68Pro_Cyan, 0x39 as KK],
      [VirtualMu68_ULTRA, 0x39 as KK],
      [VirtualNd63, 0x39 as KK],
      [VirtualMG63, 0x39 as KK],
      [VirtualRA68_1, 0x39 as KK],
      [VirtualMG75V2C12, 0x39 as KK],
      [VirtualNd63_Cyan, 0x39 as KK],

      [VirtualMer68SE, 0x03 as KK],
      [VirtualMer68Lite, 0x03 as KK],
      [VirtualMg68Plus, 0x0300 as KK], // 新增
      [VirtualMg75Max, 0x0300 as KK],
      [VirtualND68Pro, 0x0300 as KK],
      [VirtualRA68, 0x0300 as KK],
      [VirtualMer68Max, 0x0300 as KK],
      [VirtualMer68SE_JT, 0x0300 as KK],
      [VirtualND63Ultra, 0x0300 as KK],
      [VirtualMars75, 0x0300 as KK],
      [VirtualMars75Pro, 0x0300 as KK], // 新增
      [VirtualIrokFe87V2, 0x30 as KK],
      [VirtualIrokFe87V2_24g, 0x30 as KK],
      [VirtualIrokFe87V2IMC, 0x30 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x30 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x14 as VK,
    HID: 0x39 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'fn',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x01 as KK],
      [VirtualFE87V2_MuYan, 0x01 as KK],
      [VirtualPolar75, 0x01 as KK],
      [VirtualMg75, 0x01 as KK],
      [VirtualMg75Pro, 0x01 as KK],
      [VirtualMer68, 0x01 as KK],
      [VirtualMer68Pro, 0x01 as KK],

      [VirtualMu68Pro, 0x01 as KK],
      [VirtualMars68ProWireless, 0x41 as KK],
      [VirtualMars68ProWireless_24g, 0x41 as KK],
      [VirtualMars68, 0x41 as KK],
      [VirtualMg68Lite, 0x41 as KK],
      [VirtualMg68Max, 0x41 as KK],
      [VirtualMg68Max_24g, 0x41 as KK],
      [VirtualMg68Pro, 0x41 as KK],
      [VirtualMg68SE, 0x41 as KK],
      [VirtualMg68, 0x41 as KK],
      [VirtualND63Max, 0x41 as KK],
      [VirtualND68, 0x41 as KK],
      [VirtualMG68ACE_W, 0x41 as KK],
      [VirtualMG68ACE_W_24g, 0x41 as KK],
      [VirtualMG68ACE, 0x41 as KK],
      [VirtualMG68ACE_UpPlus, 0x41 as KK],
      [VirtualMars68Wireless_24g, 0x41 as KK],
      [VirtualMars68Wireless, 0x41 as KK],
      [VirtualMars68Pro, 0x41 as KK],
      [VirtualMars68SE, 0x41 as KK],
      [VirtualMu68Pro_Cyan, 0x01 as KK],
      [VirtualMu68_ULTRA, 0x01 as KK],
      [VirtualNd63, 0x01 as KK],
      [VirtualMG63, 0xff as KK],
      [VirtualRA68_1, 0xff as KK],
      [VirtualMG75V2C12, 0xff as KK],
      [VirtualNd63_Cyan, 0x01 as KK],

      [VirtualMer68SE, 0x41 as KK],
      [VirtualMer68Lite, 0x41 as KK],
      [VirtualMg68Plus, 0x050a as KK], // 新增
      [VirtualMg75Max, 0x050b as KK],
      [VirtualND68Pro, 0x050a as KK],
      [VirtualRA68, 0x050a as KK],
      [VirtualMer68Max, 0x050a as KK],
      [VirtualMer68SE_JT, 0x050a as KK],
      [VirtualND63Ultra, 0x050a as KK],
      [VirtualMars75, 0x050b as KK],
      [VirtualMars75Pro, 0x050b as KK], // 新增
      [VirtualIrokFe87V2, 0x55 as KK],
      [VirtualIrokFe87V2_24g, 0x55 as KK],
      [VirtualIrokFe87V2IMC, 0x55 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x55 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualMg68Plus, 0xf101 as DVK],
      [VirtualMg75Max, 0xf101 as DVK],
      [VirtualND68Pro, 0xf101 as DVK],
      [VirtualRA68, 0xf101 as DVK],
      [VirtualMer68Max, 0xf101 as DVK],
      [VirtualMer68SE_JT, 0xf101 as DVK],
      [VirtualND63Ultra, 0xf101 as DVK],
      [VirtualMars75, 0xf101 as DVK],
      [VirtualMars75Pro, 0xf101 as DVK], // 新增

      [VirtualNa87ProWired, 0xf001 as DVK],
      [VirtualMu68Pro, 0xf001 as DVK],
      [VirtualMu68Pro_Cyan, 0xf001 as DVK],
      [VirtualMu68_ULTRA, 0xf001 as DVK],
      [VirtualNd63, 0xf001 as DVK],
      [VirtualNd63_Cyan, 0xf001 as DVK],
      [VirtualPolar75, 0xf001 as DVK],
      [VirtualMg75, 0xf001 as DVK],
      [VirtualMg75Pro, 0xf001 as DVK],
      [VirtualMer68, 0xf001 as DVK],
      [VirtualMer68Pro, 0xf001 as DVK],

      [VirtualMG63, 0x20000000 as DVK],
      [VirtualRA68_1, 0x20000000 as DVK],
      [VirtualMG75V2C12, 0x20000000 as DVK],
    ]),
    VirtualKey: 0xfa as VK,
    HID: 0x01 as VK,
    Disable: true,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'ESC',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x29 as KK],
      [VirtualFE87V2_MuYan, 0x29 as KK],
      [VirtualPolar75, 0x29 as KK],
      [VirtualMg75, 0x29 as KK],
      [VirtualMg75Pro, 0x29 as KK],
      [VirtualMer68, 0x29 as KK],
      [VirtualMer68Pro, 0x29 as KK],
      [VirtualMu68Pro, 0x29 as KK],
      [VirtualMars68ProWireless, 0x01 as KK],
      [VirtualMars68ProWireless_24g, 0x01 as KK],
      [VirtualMars68, 0x01 as KK],
      [VirtualMg68Lite, 0x01 as KK],
      [VirtualMg68Max, 0x01 as KK],
      [VirtualMg68Max_24g, 0x01 as KK],
      [VirtualMg68Pro, 0x01 as KK],
      [VirtualMg68SE, 0x01 as KK],
      [VirtualMg68, 0x01 as KK],
      [VirtualND63Max, 0x01 as KK],
      [VirtualND68, 0x01 as KK],
      [VirtualMG68ACE_W, 0x01 as KK],
      [VirtualMG68ACE_W_24g, 0x01 as KK],
      [VirtualMG68ACE, 0x01 as KK],
      [VirtualMG68ACE_UpPlus, 0x01 as KK],
      [VirtualMars68Wireless_24g, 0x01 as KK],
      [VirtualMars68Wireless, 0x01 as KK],
      [VirtualMars68Pro, 0x01 as KK],
      [VirtualMars68SE, 0x01 as KK],
      [VirtualMu68Pro_Cyan, 0x29 as KK],
      [VirtualMu68_ULTRA, 0x29 as KK],
      [VirtualNd63, 0x29 as KK],
      [VirtualMG63, 0x29 as KK],
      [VirtualRA68_1, 0x29 as KK],
      [VirtualMG75V2C12, 0x29 as KK],
      [VirtualNd63_Cyan, 0x29 as KK],

      [VirtualMer68SE, 0x01 as KK],
      [VirtualMer68Lite, 0x01 as KK],
      [VirtualMg68Plus, 0x0100 as KK], // 新增
      [VirtualMg75Max, 0x0000 as KK],
      [VirtualND68Pro, 0x0100 as KK],
      [VirtualRA68, 0x0100 as KK],
      [VirtualMer68Max, 0x0100 as KK],
      [VirtualMer68SE_JT, 0x0100 as KK],
      [VirtualND63Ultra, 0x0100 as KK],
      [VirtualMars75, 0x0000 as KK],
      [VirtualMars75Pro, 0x0000 as KK], // 新增
      [VirtualIrokFe87V2, 0x00 as KK],
      [VirtualIrokFe87V2_24g, 0x00 as KK],
      [VirtualIrokFe87V2IMC, 0x00 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x00 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x1b as VK,
    HID: 0x29 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'SPACE',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2c as KK],
      [VirtualFE87V2_MuYan, 0x2c as KK],
      [VirtualPolar75, 0x2c as KK],
      [VirtualMg75, 0x2c as KK],
      [VirtualMg75Pro, 0x2c as KK],
      [VirtualMer68, 0x2c as KK],
      [VirtualMer68Pro, 0x2c as KK],
      [VirtualMu68Pro, 0x2c as KK],
      [VirtualMars68ProWireless, 0x29 as KK],
      [VirtualMars68ProWireless_24g, 0x29 as KK],
      [VirtualMars68, 0x29 as KK],
      [VirtualMg68Lite, 0x29 as KK],
      [VirtualMg68Max, 0x29 as KK],
      [VirtualMg68Max_24g, 0x29 as KK],
      [VirtualMg68Pro, 0x29 as KK],
      [VirtualMg68SE, 0x29 as KK],
      [VirtualMg68, 0x29 as KK],
      [VirtualND63Max, 0x29 as KK],
      [VirtualND68, 0x29 as KK],
      [VirtualMG68ACE_W, 0x29 as KK],
      [VirtualMG68ACE_W_24g, 0x29 as KK],
      [VirtualMG68ACE, 0x29 as KK],
      [VirtualMG68ACE_UpPlus, 0x29 as KK],
      [VirtualMars68Wireless_24g, 0x29 as KK],
      [VirtualMars68Wireless, 0x29 as KK],
      [VirtualMars68Pro, 0x29 as KK],
      [VirtualMars68SE, 0x29 as KK],
      [VirtualMu68Pro_Cyan, 0x2c as KK],
      [VirtualMu68_ULTRA, 0x2c as KK],
      [VirtualNd63, 0x2c as KK],
      [VirtualMG63, 0x2c as KK],
      [VirtualRA68_1, 0x2c as KK],
      [VirtualMG75V2C12, 0x2c as KK],
      [VirtualNd63_Cyan, 0x2c as KK],

      [VirtualMer68SE, 0x29 as KK],
      [VirtualMer68Lite, 0x29 as KK],
      [VirtualMg68Plus, 0x0506 as KK], // 新增
      [VirtualMg75Max, 0x0506 as KK],
      [VirtualND68Pro, 0x0506 as KK],
      [VirtualRA68, 0x0506 as KK],
      [VirtualMer68Max, 0x0506 as KK],
      [VirtualMer68SE_JT, 0x0506 as KK],
      [VirtualND63Ultra, 0x0506 as KK],
      [VirtualMars75, 0x0506 as KK],
      [VirtualMars75Pro, 0x0506 as KK],
      [VirtualIrokFe87V2, 0x53 as KK],
      [VirtualIrokFe87V2_24g, 0x53 as KK],
      [VirtualIrokFe87V2IMC, 0x53 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x53 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x20 as VK,
    HID: 0x2c as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'PGUP',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4b as KK],
      [VirtualFE87V2_MuYan, 0x4b as KK],
      [VirtualPolar75, 0x4b as KK],
      [VirtualMg75, 0x4b as KK],
      [VirtualMg75Pro, 0x4b as KK],
      [VirtualMer68, 0x4b as KK],
      [VirtualMer68Pro, 0x4b as KK],
      [VirtualMu68Pro, 0x4b as KK],
      [VirtualMars68ProWireless, 0x57 as KK],
      [VirtualMars68ProWireless_24g, 0x57 as KK],
      [VirtualMars68, 0x57 as KK],
      [VirtualMg68Lite, 0x57 as KK],
      [VirtualMg68Max, 0x57 as KK],
      [VirtualMg68Max_24g, 0x57 as KK],
      [VirtualMg68Pro, 0x57 as KK],
      [VirtualMg68SE, 0x57 as KK],
      [VirtualMg68, 0x57 as KK],
      [VirtualRA68_1, 0x4b as KK],
      [VirtualMG75V2C12, 0x4b as KK],
      [VirtualND68, 0x57 as KK],
      [VirtualMG68ACE_W, 0x57 as KK],
      [VirtualMG68ACE_W_24g, 0x57 as KK],
      [VirtualMG68ACE, 0x57 as KK],
      [VirtualMG68ACE_UpPlus, 0x57 as KK],
      [VirtualMars68Wireless_24g, 0x57 as KK],
      [VirtualMars68Wireless, 0x57 as KK],
      [VirtualMars68Pro, 0x57 as KK],
      [VirtualMars68SE, 0x57 as KK],
      [VirtualMu68Pro_Cyan, 0x4b as KK],
      [VirtualMu68_ULTRA, 0x4b as KK],

      [VirtualMer68SE, 0x57 as KK],
      [VirtualMer68Lite, 0x57 as KK],
      [VirtualMg68Plus, 0x030e as KK], // 新增
      [VirtualMg75Max, 0x020e as KK],
      [VirtualND68Pro, 0x030e as KK],
      [VirtualRA68, 0x030e as KK],
      [VirtualMer68Max, 0x030e as KK],
      [VirtualMer68SE_JT, 0x030e as KK],
      [VirtualMars75, 0x020e as KK],
      [VirtualMars75Pro, 0x020e as KK], // 新增
      [VirtualIrokFe87V2, 0x3f as KK],
      [VirtualIrokFe87V2_24g, 0x3f as KK],
      [VirtualIrokFe87V2IMC, 0x3f as KK],
      [VirtualIrokFe87V2IMC_24g, 0x3f as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x21 as VK,
    HID: 0x4b as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'PGDN',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4e as KK],
      [VirtualFE87V2_MuYan, 0x4e as KK],
      [VirtualPolar75, 0x4e as KK],
      [VirtualMg75, 0x4e as KK],
      [VirtualMg75Pro, 0x4e as KK],
      [VirtualMer68, 0x4e as KK],
      [VirtualMer68Pro, 0x4e as KK],
      [VirtualMer68SE, 0x58 as KK],
      [VirtualMer68Lite, 0x58 as KK],
      [VirtualMu68Pro, 0x4e as KK],
      [VirtualMars68ProWireless, 0x58 as KK],
      [VirtualMars68ProWireless_24g, 0x58 as KK],
      [VirtualMars68, 0x58 as KK],
      [VirtualMg68Lite, 0x58 as KK],
      [VirtualMg68Max, 0x58 as KK],
      [VirtualMg68Max_24g, 0x58 as KK],
      [VirtualMg68Pro, 0x58 as KK],
      [VirtualMg68SE, 0x58 as KK],
      [VirtualMg68, 0x58 as KK],
      [VirtualRA68_1, 0x4e as KK],
      [VirtualMG75V2C12, 0x4e as KK],
      [VirtualND68, 0x58 as KK],
      [VirtualMG68ACE_W, 0x58 as KK],
      [VirtualMG68ACE_W_24g, 0x58 as KK],
      [VirtualMG68ACE, 0x58 as KK],
      [VirtualMG68ACE_UpPlus, 0x58 as KK],
      [VirtualMars68Wireless_24g, 0x58 as KK],
      [VirtualMars68Wireless, 0x58 as KK],
      [VirtualMars68Pro, 0x58 as KK],
      [VirtualMars68SE, 0x58 as KK],
      [VirtualMu68Pro_Cyan, 0x4e as KK],
      [VirtualMu68_ULTRA, 0x4e as KK],
      [VirtualMg68Plus, 0x040e as KK], // 新增
      [VirtualMg75Max, 0x030e as KK],
      [VirtualND68Pro, 0x040e as KK],
      [VirtualRA68, 0x040e as KK],
      [VirtualMer68Max, 0x040e as KK],
      [VirtualMer68SE_JT, 0x040e as KK],
      [VirtualMars75, 0x030e as KK],
      [VirtualMars75Pro, 0x030e as KK], // 新增
      [VirtualIrokFe87V2, 0x4f as KK],
      [VirtualIrokFe87V2_24g, 0x4f as KK],
      [VirtualIrokFe87V2IMC, 0x4f as KK],
      [VirtualIrokFe87V2IMC_24g, 0x4f as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x22 as VK,
    HID: 0x4e as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'END',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4d as KK],
      [VirtualFE87V2_MuYan, 0x4d as KK],
      [VirtualIrokFe87V2, 0x2f as KK],
      [VirtualIrokFe87V2_24g, 0x2f as KK],
      [VirtualIrokFe87V2IMC, 0x2f as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2f as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x23 as VK,
    HID: 0x4d as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'HOME',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4a as KK],
      [VirtualFE87V2_MuYan, 0x4a as KK],
      [VirtualIrokFe87V2, 0x1f as KK],
      [VirtualIrokFe87V2_24g, 0x1f as KK],
      [VirtualIrokFe87V2IMC, 0x1f as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1f as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x24 as VK,
    HID: 0x4a as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Left',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x50 as KK],
      [VirtualFE87V2_MuYan, 0x50 as KK],
      [VirtualPolar75, 0x50 as KK],
      [VirtualMg75, 0x50 as KK],
      [VirtualMg75Pro, 0x50 as KK],
      [VirtualMer68, 0x50 as KK],
      [VirtualMer68Pro, 0x50 as KK],
      [VirtualMer68SE, 0x4d as KK],
      [VirtualMer68Lite, 0x4d as KK],
      [VirtualMu68Pro, 0x50 as KK],
      [VirtualMars68ProWireless, 0x4d as KK],
      [VirtualMars68ProWireless_24g, 0x4d as KK],
      [VirtualMars68, 0x4d as KK],
      [VirtualMg68Lite, 0x4d as KK],
      [VirtualMg68Max, 0x4d as KK],
      [VirtualMg68Max_24g, 0x4d as KK],
      [VirtualMg68Pro, 0x4d as KK],
      [VirtualMg68SE, 0x4d as KK],
      [VirtualMg68, 0x4d as KK],
      [VirtualND63Max, 0x47 as KK],
      [VirtualND68, 0x4d as KK],
      [VirtualMG68ACE_W, 0x4d as KK],
      [VirtualMG68ACE_W_24g, 0x4d as KK],
      [VirtualMG68ACE, 0x4d as KK],
      [VirtualMG68ACE_UpPlus, 0x4d as KK],
      [VirtualMars68Wireless_24g, 0x4d as KK],
      [VirtualMars68Wireless, 0x4d as KK],
      [VirtualMars68Pro, 0x4d as KK],
      [VirtualMars68SE, 0x4d as KK],
      [VirtualMu68Pro_Cyan, 0x50 as KK],
      [VirtualMu68_ULTRA, 0x50 as KK],
      [VirtualNd63, 0x50 as KK],
      [VirtualMG63, 0x50 as KK],
      [VirtualRA68_1, 0x50 as KK],
      [VirtualMG75V2C12, 0x50 as KK],
      [VirtualNd63_Cyan, 0x50 as KK],
      [VirtualMg68Plus, 0x050c as KK], // 新增
      [VirtualMg75Max, 0x050c as KK],
      [VirtualND68Pro, 0x050c as KK],
      [VirtualRA68, 0x050c as KK],
      [VirtualMer68Max, 0x050c as KK],
      [VirtualMer68SE_JT, 0x050c as KK],
      [VirtualND63Ultra, 0x050c as KK],
      [VirtualMars75, 0x050c as KK],
      [VirtualMars75Pro, 0x050c as KK], // 新增
      [VirtualIrokFe87V2, 0x58 as KK],
      [VirtualIrokFe87V2_24g, 0x58 as KK],
      [VirtualIrokFe87V2IMC, 0x58 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x58 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x25 as VK,
    HID: 0x50 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'UP',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x52 as KK],
      [VirtualFE87V2_MuYan, 0x52 as KK],
      [VirtualPolar75, 0x52 as KK],
      [VirtualMg75, 0x52 as KK],
      [VirtualMg75Pro, 0x52 as KK],
      [VirtualMer68, 0x52 as KK],
      [VirtualMer68Pro, 0x52 as KK],
      [VirtualMer68SE, 0x52 as KK],
      [VirtualMer68Lite, 0x52 as KK],
      [VirtualMu68Pro, 0x52 as KK],
      [VirtualMars68ProWireless, 0x52 as KK],
      [VirtualMars68ProWireless_24g, 0x52 as KK],
      [VirtualMars68, 0x52 as KK],
      [VirtualMg68Lite, 0x52 as KK],
      [VirtualMg68Max, 0x52 as KK],
      [VirtualMg68Max_24g, 0x52 as KK],
      [VirtualMg68Pro, 0x52 as KK],
      [VirtualMg68SE, 0x52 as KK],
      [VirtualMg68, 0x52 as KK],
      [VirtualND63Max, 0x52 as KK],
      [VirtualND68, 0x52 as KK],
      [VirtualMG68ACE_W, 0x52 as KK],
      [VirtualMG68ACE_W_24g, 0x52 as KK],
      [VirtualMG68ACE, 0x52 as KK],
      [VirtualMG68ACE_UpPlus, 0x52 as KK],
      [VirtualMars68Wireless_24g, 0x52 as KK],
      [VirtualMars68Wireless, 0x52 as KK],
      [VirtualMars68Pro, 0x52 as KK],
      [VirtualMars68SE, 0x52 as KK],
      [VirtualMu68Pro_Cyan, 0x52 as KK],
      [VirtualMu68_ULTRA, 0x52 as KK],
      [VirtualNd63, 0x52 as KK],
      [VirtualMG63, 0x52 as KK],
      [VirtualRA68_1, 0x52 as KK],
      [VirtualMG75V2C12, 0x52 as KK],
      [VirtualNd63_Cyan, 0x52 as KK],
      [VirtualMg68Plus, 0x040d as KK], // 新增
      [VirtualMg75Max, 0x040d as KK],
      [VirtualND68Pro, 0x040d as KK],
      [VirtualRA68, 0x040d as KK],
      [VirtualMer68Max, 0x040d as KK],
      [VirtualMer68SE_JT, 0x040d as KK],
      [VirtualND63Ultra, 0x040d as KK],
      [VirtualMars75, 0x040d as KK],
      [VirtualMars75Pro, 0x040d as KK], // 新增
      [VirtualIrokFe87V2, 0x4c as KK],
      [VirtualIrokFe87V2_24g, 0x4c as KK],
      [VirtualIrokFe87V2IMC, 0x4c as KK],
      [VirtualIrokFe87V2IMC_24g, 0x4c as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x26 as VK,
    HID: 0x52 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Right',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4f as KK],
      [VirtualFE87V2_MuYan, 0x4f as KK],
      [VirtualPolar75, 0x4f as KK],
      [VirtualMg75, 0x4f as KK],
      [VirtualMg75Pro, 0x4f as KK],
      [VirtualMer68, 0x4f as KK],
      [VirtualMer68Pro, 0x4f as KK],
      [VirtualMer68SE, 0x59 as KK],
      [VirtualMer68Lite, 0x59 as KK],
      [VirtualMu68Pro, 0x4f as KK],
      [VirtualMars68ProWireless, 0x59 as KK],
      [VirtualMars68ProWireless_24g, 0x59 as KK],
      [VirtualMars68, 0x59 as KK],
      [VirtualMg68Lite, 0x59 as KK],
      [VirtualMg68Max, 0x59 as KK],
      [VirtualMg68Max_24g, 0x59 as KK],
      [VirtualMg68Pro, 0x59 as KK],
      [VirtualMg68SE, 0x59 as KK],
      [VirtualMg68, 0x59 as KK],
      [VirtualND63Max, 0x53 as KK],
      [VirtualND68, 0x59 as KK],
      [VirtualMG68ACE_W, 0x59 as KK],
      [VirtualMG68ACE_W_24g, 0x59 as KK],
      [VirtualMG68ACE, 0x59 as KK],
      [VirtualMG68ACE_UpPlus, 0x59 as KK],
      [VirtualMars68Wireless_24g, 0x59 as KK],
      [VirtualMars68Wireless, 0x59 as KK],
      [VirtualMars68Pro, 0x59 as KK],
      [VirtualMars68SE, 0x59 as KK],
      [VirtualMu68Pro_Cyan, 0x4f as KK],
      [VirtualMu68_ULTRA, 0x4f as KK],
      [VirtualNd63, 0x4f as KK],
      [VirtualMG63, 0x4f as KK],
      [VirtualRA68_1, 0x4f as KK],
      [VirtualMG75V2C12, 0x4f as KK],
      [VirtualNd63_Cyan, 0x4f as KK],
      [VirtualMg68Plus, 0x050e as KK], // 新增
      [VirtualMg75Max, 0x050e as KK],
      [VirtualND68Pro, 0x050e as KK],
      [VirtualRA68, 0x050e as KK],
      [VirtualMer68Max, 0x050e as KK],
      [VirtualMer68SE_JT, 0x050e as KK],
      [VirtualND63Ultra, 0x050e as KK],
      [VirtualMars75, 0x050e as KK],
      [VirtualMars75Pro, 0x050e as KK], // 新增
      [VirtualIrokFe87V2, 0x5a as KK],
      [VirtualIrokFe87V2_24g, 0x5a as KK],
      [VirtualIrokFe87V2IMC, 0x5a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x5a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x27 as VK,
    HID: 0x4f as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Down',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x51 as KK],
      [VirtualFE87V2_MuYan, 0x51 as KK],
      [VirtualPolar75, 0x51 as KK],
      [VirtualMg75, 0x51 as KK],
      [VirtualMg75Pro, 0x51 as KK],
      [VirtualMer68, 0x51 as KK],
      [VirtualMer68Pro, 0x51 as KK],
      [VirtualMer68SE, 0x53 as KK],
      [VirtualMer68Lite, 0x53 as KK],
      [VirtualMu68Pro, 0x51 as KK],
      [VirtualMars68ProWireless, 0x53 as KK],
      [VirtualMars68ProWireless_24g, 0x53 as KK],
      [VirtualMars68, 0x53 as KK],
      [VirtualMg68Lite, 0x53 as KK],
      [VirtualMg68Max, 0x53 as KK],
      [VirtualMg68Max_24g, 0x53 as KK],
      [VirtualMg68Pro, 0x53 as KK],
      [VirtualMg68SE, 0x53 as KK],
      [VirtualMg68, 0x53 as KK],
      [VirtualND63Max, 0x4d as KK],
      [VirtualND68, 0x53 as KK],
      [VirtualMG68ACE_W, 0x53 as KK],
      [VirtualMG68ACE_W_24g, 0x53 as KK],
      [VirtualMG68ACE, 0x53 as KK],
      [VirtualMG68ACE_UpPlus, 0x53 as KK],
      [VirtualMars68Wireless_24g, 0x53 as KK],
      [VirtualMars68Wireless, 0x53 as KK],
      [VirtualMars68Pro, 0x53 as KK],
      [VirtualMars68SE, 0x53 as KK],
      [VirtualMu68Pro_Cyan, 0x51 as KK],
      [VirtualMu68_ULTRA, 0x51 as KK],
      [VirtualNd63, 0x51 as KK],
      [VirtualMG63, 0x51 as KK],
      [VirtualRA68_1, 0x51 as KK],
      [VirtualMG75V2C12, 0x51 as KK],
      [VirtualNd63_Cyan, 0x51 as KK],
      [VirtualMg68Plus, 0x050d as KK], // 新增
      [VirtualMg75Max, 0x050d as KK],
      [VirtualND68Pro, 0x050d as KK],
      [VirtualRA68, 0x050d as KK],
      [VirtualMer68Max, 0x050d as KK],
      [VirtualMer68SE_JT, 0x050d as KK],
      [VirtualND63Ultra, 0x050d as KK],
      [VirtualMars75, 0x050d as KK],
      [VirtualMars75Pro, 0x050d as KK], // 新增
      [VirtualIrokFe87V2, 0x59 as KK],
      [VirtualIrokFe87V2_24g, 0x59 as KK],
      [VirtualIrokFe87V2IMC, 0x59 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x59 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x28 as VK,
    HID: 0x51 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'PRTSC',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x46 as KK],
      [VirtualFE87V2_MuYan, 0x46 as KK],
      [VirtualPolar75, 0x46 as KK],
      [VirtualMg75, 0x46 as KK],
      [VirtualMG75V2C12, 0x46 as KK],
      [VirtualMg75Pro, 0x46 as KK],
      [VirtualMg75Max, 0x000d as KK],
      [VirtualMars75, 0x000d as KK],
      [VirtualMars75Pro, 0x000d as KK], // 新增
      [VirtualIrokFe87V2, 0x0d as KK],
      [VirtualIrokFe87V2_24g, 0x0d as KK],
      [VirtualIrokFe87V2IMC, 0x0d as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0d as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x2c as VK,
    HID: 0x46 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'INS',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x49 as KK],
      [VirtualFE87V2_MuYan, 0x49 as KK],
      [VirtualPolar75, 0x49 as KK],
      [VirtualMg75, 0x49 as KK],
      [VirtualMg75Pro, 0x49 as KK],
      [VirtualMu68Pro, 0x49 as KK],
      [VirtualMars68ProWireless, 0x55 as KK],
      [VirtualMars68ProWireless_24g, 0x55 as KK],
      [VirtualMars68, 0x55 as KK],
      [VirtualMg68Lite, 0x55 as KK],
      [VirtualMg68Max, 0x55 as KK],
      [VirtualMg68Max_24g, 0x55 as KK],
      [VirtualMg68Pro, 0x55 as KK],
      [VirtualMg68SE, 0x55 as KK],
      [VirtualMg68, 0x55 as KK],
      [VirtualRA68_1, 0x49 as KK],
      [VirtualMG75V2C12, 0x49 as KK],
      [VirtualND68, 0x55 as KK],
      [VirtualMG68ACE_W, 0x55 as KK],
      [VirtualMG68ACE_W_24g, 0x55 as KK],
      [VirtualMG68ACE, 0x55 as KK],
      [VirtualMG68ACE_UpPlus, 0x55 as KK],
      [VirtualMars68Wireless_24g, 0x55 as KK],
      [VirtualMars68Wireless, 0x55 as KK],
      [VirtualMars68Pro, 0x55 as KK],
      [VirtualMars68SE, 0x55 as KK],
      [VirtualMu68Pro_Cyan, 0x49 as KK],
      [VirtualMu68_ULTRA, 0x49 as KK],

      [VirtualMer68, 0x49 as KK],
      [VirtualMer68Pro, 0x49 as KK],
      [VirtualMer68SE, 0x55 as KK],
      [VirtualMer68Lite, 0x55 as KK],
      [VirtualMg68Plus, 0x010e as KK], // 新增
      [VirtualMg75Max, 0x010e as KK],
      [VirtualND68Pro, 0x010e as KK],
      [VirtualRA68, 0x010e as KK],
      [VirtualMer68Max, 0x010e as KK],
      [VirtualMer68SE_JT, 0x010e as KK],
      [VirtualMars75, 0x010e as KK],
      [VirtualMars75Pro, 0x010e as KK], // 新增
      [VirtualIrokFe87V2, 0x1e as KK],
      [VirtualIrokFe87V2_24g, 0x1e as KK],
      [VirtualIrokFe87V2IMC, 0x1e as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1e as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x2d as VK,
    HID: 0x49 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'DEL',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x4c as KK],
      [VirtualFE87V2_MuYan, 0x4c as KK],
      [VirtualPolar75, 0x4c as KK],
      [VirtualMg75, 0x4c as KK],
      [VirtualMg75Pro, 0x4c as KK],
      [VirtualMer68, 0x4c as KK],
      [VirtualMer68Pro, 0x4c as KK],
      [VirtualMer68SE, 0x56 as KK],
      [VirtualMer68Lite, 0x56 as KK],
      [VirtualMu68Pro, 0x4c as KK],
      [VirtualMars68ProWireless, 0x56 as KK],
      [VirtualMars68ProWireless_24g, 0x56 as KK],
      [VirtualMars68, 0x56 as KK],
      [VirtualMg68Lite, 0x56 as KK],
      [VirtualMg68Max, 0x56 as KK],
      [VirtualMg68Max_24g, 0x56 as KK],
      [VirtualMg68Pro, 0x56 as KK],
      [VirtualMg68SE, 0x56 as KK],
      [VirtualMg68, 0x56 as KK],
      [VirtualND68, 0x56 as KK],
      [VirtualND63Max, 0x58 as KK],
      [VirtualMG63, 0x4c as KK],
      [VirtualRA68_1, 0x4c as KK],
      [VirtualMG75V2C12, 0x4c as KK],
      [VirtualMG68ACE_W, 0x56 as KK],
      [VirtualMG68ACE_W_24g, 0x56 as KK],
      [VirtualMG68ACE, 0x56 as KK],
      [VirtualMG68ACE_UpPlus, 0x56 as KK],
      [VirtualMars68Wireless_24g, 0x56 as KK],
      [VirtualMars68Wireless, 0x56 as KK],
      [VirtualMars68Pro, 0x56 as KK],
      [VirtualMars68SE, 0x56 as KK],
      [VirtualMu68Pro_Cyan, 0x4c as KK],
      [VirtualMu68_ULTRA, 0x4c as KK],
      [VirtualMg68Plus, 0x020e as KK], // 新增
      [VirtualMg75Max, 0x000e as KK],
      [VirtualND68Pro, 0x020e as KK],
      [VirtualRA68, 0x020e as KK],
      [VirtualMer68Max, 0x020e as KK],
      [VirtualMer68SE_JT, 0x020e as KK],
      [VirtualND63Ultra, 0x040e as KK],
      [VirtualMars75, 0x000e as KK],
      [VirtualMars75Pro, 0x000e as KK], // 新增
      [VirtualIrokFe87V2, 0x2e as KK],
      [VirtualIrokFe87V2_24g, 0x2e as KK],
      [VirtualIrokFe87V2IMC, 0x2e as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2e as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x2e as VK,
    HID: 0x4c as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'A',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x04 as KK],
      [VirtualFE87V2_MuYan, 0x04 as KK],
      [VirtualPolar75, 0x04 as KK],
      [VirtualMg75, 0x04 as KK],
      [VirtualMg75Pro, 0x04 as KK],
      [VirtualMer68, 0x04 as KK],
      [VirtualMer68Pro, 0x04 as KK],
      [VirtualMer68SE, 0x09 as KK],
      [VirtualMer68Lite, 0x09 as KK],
      [VirtualMu68Pro, 0x04 as KK],
      [VirtualMars68ProWireless, 0x09 as KK],
      [VirtualMars68ProWireless_24g, 0x09 as KK],
      [VirtualMars68, 0x09 as KK],
      [VirtualMg68Lite, 0x09 as KK],
      [VirtualMg68Max, 0x09 as KK],
      [VirtualMg68Max_24g, 0x09 as KK],
      [VirtualMg68Pro, 0x09 as KK],
      [VirtualMg68SE, 0x09 as KK],
      [VirtualMg68, 0x09 as KK],
      [VirtualND63Max, 0x09 as KK],
      [VirtualND68, 0x09 as KK],
      [VirtualMG68ACE_W, 0x09 as KK],
      [VirtualMG68ACE_W_24g, 0x09 as KK],
      [VirtualMG68ACE, 0x09 as KK],
      [VirtualMG68ACE_UpPlus, 0x09 as KK],
      [VirtualMars68Wireless_24g, 0x09 as KK],
      [VirtualMars68Wireless, 0x09 as KK],
      [VirtualMars68Pro, 0x09 as KK],
      [VirtualMars68SE, 0x09 as KK],
      [VirtualMu68Pro_Cyan, 0x04 as KK],
      [VirtualMu68_ULTRA, 0x04 as KK],
      [VirtualNd63, 0x04 as KK],
      [VirtualMG63, 0x04 as KK],
      [VirtualRA68_1, 0x04 as KK],
      [VirtualMG75V2C12, 0x04 as KK],
      [VirtualNd63_Cyan, 0x04 as KK],
      [VirtualMg68Plus, 0x0301 as KK],
      [VirtualMg75Max, 0x0301 as KK],
      [VirtualND68Pro, 0x0301 as KK],
      [VirtualRA68, 0x0301 as KK],
      [VirtualMer68Max, 0x0301 as KK],
      [VirtualMer68SE_JT, 0x0301 as KK],
      [VirtualND63Ultra, 0x0301 as KK],
      [VirtualMars75, 0x0301 as KK],
      [VirtualMars75Pro, 0x0301 as KK],
      [VirtualIrokFe87V2, 0x31 as KK],
      [VirtualIrokFe87V2_24g, 0x31 as KK],
      [VirtualIrokFe87V2IMC, 0x31 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x31 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x020004 as DVK],
      [VirtualHE3SEWireless, 0x020004 as DVK],
    ]),
    VirtualKey: 0x41 as VK,
    HID: 0x04 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'B',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x05 as KK],
      [VirtualFE87V2_MuYan, 0x05 as KK],
      [VirtualPolar75, 0x05 as KK],
      [VirtualMg75, 0x05 as KK],
      [VirtualMg75Pro, 0x05 as KK],
      [VirtualMer68, 0x05 as KK],
      [VirtualMer68Pro, 0x05 as KK],
      [VirtualMer68SE, 0x28 as KK],
      [VirtualMer68Lite, 0x28 as KK],
      [VirtualMu68Pro, 0x05 as KK],
      [VirtualMars68ProWireless, 0x28 as KK],
      [VirtualMars68ProWireless_24g, 0x28 as KK],
      [VirtualMars68, 0x28 as KK],
      [VirtualMg68Lite, 0x28 as KK],
      [VirtualMg68Max, 0x28 as KK],
      [VirtualMg68Max_24g, 0x28 as KK],
      [VirtualMg68Pro, 0x28 as KK],
      [VirtualMg68SE, 0x28 as KK],
      [VirtualMg68, 0x28 as KK],
      [VirtualND63Max, 0x28 as KK],
      [VirtualND68, 0x28 as KK],
      [VirtualMG68ACE_W, 0x28 as KK],
      [VirtualMG68ACE_W_24g, 0x28 as KK],
      [VirtualMG68ACE, 0x28 as KK],
      [VirtualMG68ACE_UpPlus, 0x28 as KK],
      [VirtualMars68Wireless_24g, 0x28 as KK],
      [VirtualMars68Wireless, 0x28 as KK],
      [VirtualMars68Pro, 0x28 as KK],
      [VirtualMars68SE, 0x28 as KK],
      [VirtualMu68Pro_Cyan, 0x05 as KK],
      [VirtualMu68_ULTRA, 0x05 as KK],
      [VirtualNd63, 0x05 as KK],
      [VirtualMG63, 0x05 as KK],
      [VirtualRA68_1, 0x05 as KK],
      [VirtualMG75V2C12, 0x05 as KK],
      [VirtualNd63_Cyan, 0x05 as KK],
      [VirtualMg68Plus, 0x0406 as KK], // 新增
      [VirtualMg75Max, 0x0406 as KK],
      [VirtualND68Pro, 0x0406 as KK],
      [VirtualRA68, 0x0406 as KK],
      [VirtualMer68Max, 0x0406 as KK],
      [VirtualMer68SE_JT, 0x0406 as KK],
      [VirtualND63Ultra, 0x0406 as KK],
      [VirtualMars75, 0x0406 as KK],
      [VirtualMars75Pro, 0x0406 as KK], // 新增
      [VirtualIrokFe87V2, 0x45 as KK],
      [VirtualIrokFe87V2_24g, 0x45 as KK],
      [VirtualIrokFe87V2IMC, 0x45 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x45 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x42 as VK,
    HID: 0x05 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'C',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x06 as KK],
      [VirtualFE87V2_MuYan, 0x06 as KK],
      [VirtualPolar75, 0x06 as KK],
      [VirtualMg75, 0x06 as KK],
      [VirtualMg75Pro, 0x06 as KK],
      [VirtualMer68, 0x06 as KK],
      [VirtualMer68Pro, 0x06 as KK],
      [VirtualMer68SE, 0x1c as KK],
      [VirtualMer68Lite, 0x1c as KK],
      [VirtualMu68Pro, 0x06 as KK],
      [VirtualMars68ProWireless, 0x1c as KK],
      [VirtualMars68ProWireless_24g, 0x1c as KK],
      [VirtualMars68, 0x1c as KK],
      [VirtualMg68Lite, 0x1c as KK],
      [VirtualMg68Max, 0x1c as KK],
      [VirtualMg68Max_24g, 0x1c as KK],
      [VirtualMg68Pro, 0x1c as KK],
      [VirtualMg68SE, 0x1c as KK],
      [VirtualMg68, 0x1c as KK],
      [VirtualND63Max, 0x1c as KK],
      [VirtualND68, 0x1c as KK],
      [VirtualMG68ACE_W, 0x1c as KK],
      [VirtualMG68ACE_W_24g, 0x1c as KK],
      [VirtualMG68ACE, 0x1c as KK],
      [VirtualMG68ACE_UpPlus, 0x1c as KK],
      [VirtualMars68Wireless_24g, 0x1c as KK],
      [VirtualMars68Wireless, 0x1c as KK],
      [VirtualMars68Pro, 0x1c as KK],
      [VirtualMars68SE, 0x1c as KK],
      [VirtualMu68Pro_Cyan, 0x06 as KK],
      [VirtualMu68_ULTRA, 0x06 as KK],
      [VirtualNd63, 0x06 as KK],
      [VirtualMG63, 0x06 as KK],
      [VirtualRA68_1, 0x06 as KK],
      [VirtualMG75V2C12, 0x06 as KK],
      [VirtualNd63_Cyan, 0x06 as KK],
      [VirtualMg68Plus, 0x0404 as KK], // 新增
      [VirtualMg75Max, 0x0404 as KK],
      [VirtualND68Pro, 0x0404 as KK],
      [VirtualRA68, 0x0404 as KK],
      [VirtualMer68Max, 0x0404 as KK],
      [VirtualMer68SE_JT, 0x0404 as KK],
      [VirtualND63Ultra, 0x0404 as KK],
      [VirtualMars75, 0x0404 as KK],
      [VirtualMars75Pro, 0x0404 as KK], // 新增
      [VirtualIrokFe87V2, 0x43 as KK],
      [VirtualIrokFe87V2_24g, 0x43 as KK],
      [VirtualIrokFe87V2IMC, 0x43 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x43 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x43 as VK,
    HID: 0x06 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'D',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x07 as KK],
      [VirtualFE87V2_MuYan, 0x07 as KK],
      [VirtualPolar75, 0x07 as KK],
      [VirtualMg75, 0x07 as KK],
      [VirtualMg75Pro, 0x07 as KK],
      [VirtualMer68, 0x07 as KK],
      [VirtualMer68Pro, 0x07 as KK],
      [VirtualMer68SE, 0x15 as KK],
      [VirtualMer68Lite, 0x15 as KK],
      [VirtualMu68Pro, 0x07 as KK],
      [VirtualMars68ProWireless, 0x15 as KK],
      [VirtualMars68ProWireless_24g, 0x15 as KK],
      [VirtualMars68, 0x15 as KK],
      [VirtualMg68Lite, 0x15 as KK],
      [VirtualMg68Max, 0x15 as KK],
      [VirtualMg68Max_24g, 0x15 as KK],
      [VirtualMg68Pro, 0x15 as KK],
      [VirtualMg68SE, 0x15 as KK],
      [VirtualMg68, 0x15 as KK],
      [VirtualND63Max, 0x15 as KK],
      [VirtualND68, 0x15 as KK],
      [VirtualMG68ACE_W, 0x15 as KK],
      [VirtualMG68ACE_W_24g, 0x15 as KK],
      [VirtualMG68ACE, 0x15 as KK],
      [VirtualMG68ACE_UpPlus, 0x15 as KK],
      [VirtualMars68Wireless_24g, 0x15 as KK],
      [VirtualMars68Wireless, 0x15 as KK],
      [VirtualMars68Pro, 0x15 as KK],
      [VirtualMars68SE, 0x15 as KK],
      [VirtualMu68Pro_Cyan, 0x07 as KK],
      [VirtualMu68_ULTRA, 0x07 as KK],
      [VirtualNd63, 0x07 as KK],
      [VirtualMG63, 0x07 as KK],
      [VirtualRA68_1, 0x07 as KK],
      [VirtualMG75V2C12, 0x07 as KK],
      [VirtualNd63_Cyan, 0x07 as KK],
      [VirtualMg68Plus, 0x0303 as KK], // 新增
      [VirtualMg75Max, 0x0303 as KK],
      [VirtualND68Pro, 0x0303 as KK],
      [VirtualRA68, 0x0303 as KK],
      [VirtualMer68Max, 0x0303 as KK],
      [VirtualMer68SE_JT, 0x0303 as KK],
      [VirtualND63Ultra, 0x0303 as KK],
      [VirtualMars75, 0x0303 as KK],
      [VirtualMars75Pro, 0x0303 as KK], // 新增
      [VirtualIrokFe87V2, 0x33 as KK],
      [VirtualIrokFe87V2_24g, 0x33 as KK],
      [VirtualIrokFe87V2IMC, 0x33 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x33 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x44 as VK,
    HID: 0x07 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'E',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x08 as KK],
      [VirtualFE87V2_MuYan, 0x08 as KK],
      [VirtualPolar75, 0x08 as KK],
      [VirtualMg75, 0x08 as KK],
      [VirtualMg75Pro, 0x08 as KK],
      [VirtualMer68, 0x08 as KK],
      [VirtualMer68Pro, 0x08 as KK],
      [VirtualMer68SE, 0x14 as KK],
      [VirtualMer68Lite, 0x14 as KK],
      [VirtualMu68Pro, 0x08 as KK],
      [VirtualMars68ProWireless, 0x14 as KK],
      [VirtualMars68ProWireless_24g, 0x14 as KK],
      [VirtualMars68, 0x14 as KK],
      [VirtualMg68Lite, 0x14 as KK],
      [VirtualMg68Max, 0x14 as KK],
      [VirtualMg68Max_24g, 0x14 as KK],
      [VirtualMg68Pro, 0x14 as KK],
      [VirtualMg68SE, 0x14 as KK],
      [VirtualMg68, 0x14 as KK],
      [VirtualND63Max, 0x14 as KK],
      [VirtualND68, 0x14 as KK],
      [VirtualMG68ACE_W, 0x14 as KK],
      [VirtualMG68ACE_W_24g, 0x14 as KK],
      [VirtualMG68ACE, 0x14 as KK],
      [VirtualMG68ACE_UpPlus, 0x14 as KK],
      [VirtualMars68Wireless_24g, 0x14 as KK],
      [VirtualMars68Wireless, 0x14 as KK],
      [VirtualMars68Pro, 0x14 as KK],
      [VirtualMars68SE, 0x14 as KK],
      [VirtualMu68Pro_Cyan, 0x08 as KK],
      [VirtualMu68_ULTRA, 0x08 as KK],
      [VirtualNd63, 0x08 as KK],
      [VirtualMG63, 0x08 as KK],
      [VirtualRA68_1, 0x08 as KK],
      [VirtualMG75V2C12, 0x08 as KK],
      [VirtualNd63_Cyan, 0x08 as KK],
      [VirtualMg68Plus, 0x0203 as KK], // 新增
      [VirtualMg75Max, 0x0203 as KK],
      [VirtualND68Pro, 0x0203 as KK],
      [VirtualRA68, 0x0203 as KK],
      [VirtualMer68Max, 0x0203 as KK],
      [VirtualMer68SE_JT, 0x0203 as KK],
      [VirtualND63Ultra, 0x0203 as KK],
      [VirtualMars75, 0x0203 as KK],
      [VirtualMars75Pro, 0x0203 as KK], // 新增
      [VirtualIrokFe87V2, 0x23 as KK],
      [VirtualIrokFe87V2_24g, 0x23 as KK],
      [VirtualIrokFe87V2IMC, 0x23 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x23 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x45 as VK,
    HID: 0x08 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'F',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x09 as KK],
      [VirtualFE87V2_MuYan, 0x09 as KK],
      [VirtualPolar75, 0x09 as KK],
      [VirtualMg75, 0x09 as KK],
      [VirtualMg75Pro, 0x09 as KK],
      [VirtualMer68, 0x09 as KK],
      [VirtualMer68Pro, 0x09 as KK],
      [VirtualMer68SE, 0x1b as KK],
      [VirtualMer68Lite, 0x1b as KK],
      [VirtualMu68Pro, 0x09 as KK],
      [VirtualMars68ProWireless, 0x1b as KK],
      [VirtualMars68ProWireless_24g, 0x1b as KK],
      [VirtualMars68, 0x1b as KK],
      [VirtualMg68Lite, 0x1b as KK],
      [VirtualMg68Max, 0x1b as KK],
      [VirtualMg68Max_24g, 0x1b as KK],
      [VirtualMg68Pro, 0x1b as KK],
      [VirtualMg68SE, 0x1b as KK],
      [VirtualMg68, 0x1b as KK],
      [VirtualND63Max, 0x1b as KK],
      [VirtualND68, 0x1b as KK],
      [VirtualMG68ACE_W, 0x1b as KK],
      [VirtualMG68ACE_W_24g, 0x1b as KK],
      [VirtualMG68ACE, 0x1b as KK],
      [VirtualMG68ACE_UpPlus, 0x1b as KK],
      [VirtualMars68Wireless_24g, 0x1b as KK],
      [VirtualMars68Wireless, 0x1b as KK],
      [VirtualMars68Pro, 0x1b as KK],
      [VirtualMars68SE, 0x1b as KK],
      [VirtualMu68Pro_Cyan, 0x09 as KK],
      [VirtualMu68_ULTRA, 0x09 as KK],
      [VirtualNd63, 0x09 as KK],
      [VirtualMG63, 0x09 as KK],
      [VirtualRA68_1, 0x09 as KK],
      [VirtualMG75V2C12, 0x09 as KK],
      [VirtualNd63_Cyan, 0x09 as KK],
      [VirtualMg68Plus, 0x0304 as KK], // 新增
      [VirtualMg75Max, 0x0304 as KK],
      [VirtualND68Pro, 0x0304 as KK],
      [VirtualRA68, 0x0304 as KK],
      [VirtualMer68Max, 0x0304 as KK],
      [VirtualMer68SE_JT, 0x0304 as KK],
      [VirtualND63Ultra, 0x0304 as KK],
      [VirtualMars75, 0x0304 as KK],
      [VirtualMars75Pro, 0x0304 as KK], // 新增
      [VirtualIrokFe87V2, 0x34 as KK],
      [VirtualIrokFe87V2_24g, 0x34 as KK],
      [VirtualIrokFe87V2IMC, 0x34 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x34 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x46 as VK,
    HID: 0x09 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'G',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0a as KK],
      [VirtualFE87V2_MuYan, 0x0a as KK],
      [VirtualPolar75, 0x0a as KK],
      [VirtualMg75, 0x0a as KK],
      [VirtualMg75Pro, 0x0a as KK],
      [VirtualMer68, 0x0a as KK],
      [VirtualMer68Pro, 0x0a as KK],
      [VirtualMer68SE, 0x21 as KK],
      [VirtualMer68Lite, 0x21 as KK],
      [VirtualMu68Pro, 0x0a as KK],
      [VirtualMars68ProWireless, 0x21 as KK],
      [VirtualMars68ProWireless_24g, 0x21 as KK],
      [VirtualMars68, 0x21 as KK],
      [VirtualMg68Lite, 0x21 as KK],
      [VirtualMg68Max, 0x21 as KK],
      [VirtualMg68Max_24g, 0x21 as KK],
      [VirtualMg68Pro, 0x21 as KK],
      [VirtualMg68SE, 0x21 as KK],
      [VirtualMg68, 0x21 as KK],
      [VirtualND63Max, 0x21 as KK],
      [VirtualND68, 0x21 as KK],
      [VirtualMG68ACE_W, 0x21 as KK],
      [VirtualMG68ACE_W_24g, 0x21 as KK],
      [VirtualMG68ACE, 0x21 as KK],
      [VirtualMG68ACE_UpPlus, 0x21 as KK],
      [VirtualMars68Wireless_24g, 0x21 as KK],
      [VirtualMars68Wireless, 0x21 as KK],
      [VirtualMars68Pro, 0x21 as KK],
      [VirtualMars68SE, 0x21 as KK],
      [VirtualMu68Pro_Cyan, 0x0a as KK],
      [VirtualMu68_ULTRA, 0x0a as KK],
      [VirtualNd63, 0x0a as KK],
      [VirtualMG63, 0x0a as KK],
      [VirtualRA68_1, 0x0a as KK],
      [VirtualMG75V2C12, 0x0a as KK],
      [VirtualNd63_Cyan, 0x0a as KK],
      [VirtualMg68Plus, 0x0305 as KK], // 新增
      [VirtualMg75Max, 0x0305 as KK],
      [VirtualND68Pro, 0x0305 as KK],
      [VirtualRA68, 0x0305 as KK],
      [VirtualMer68Max, 0x0305 as KK],
      [VirtualMer68SE_JT, 0x0305 as KK],
      [VirtualND63Ultra, 0x0305 as KK],
      [VirtualMars75, 0x0305 as KK],
      [VirtualMars75Pro, 0x0305 as KK], // 新增
      [VirtualIrokFe87V2, 0x35 as KK],
      [VirtualIrokFe87V2_24g, 0x35 as KK],
      [VirtualIrokFe87V2IMC, 0x35 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x35 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x47 as VK,
    HID: 0x0a as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'H',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0b as KK],
      [VirtualFE87V2_MuYan, 0x0b as KK],
      [VirtualPolar75, 0x0b as KK],
      [VirtualMg75, 0x0b as KK],
      [VirtualMg75Pro, 0x0b as KK],
      [VirtualMer68, 0x0b as KK],
      [VirtualMer68Pro, 0x0b as KK],
      [VirtualMer68SE, 0x27 as KK],
      [VirtualMer68Lite, 0x27 as KK],
      [VirtualMu68Pro, 0x0b as KK],
      [VirtualMars68ProWireless, 0x27 as KK],
      [VirtualMars68ProWireless_24g, 0x27 as KK],
      [VirtualMars68, 0x27 as KK],
      [VirtualMg68Lite, 0x27 as KK],
      [VirtualMg68Max, 0x27 as KK],
      [VirtualMg68Max_24g, 0x27 as KK],
      [VirtualMg68Pro, 0x27 as KK],
      [VirtualMg68SE, 0x27 as KK],
      [VirtualMg68, 0x27 as KK],
      [VirtualND63Max, 0x27 as KK],
      [VirtualND68, 0x27 as KK],
      [VirtualMG68ACE_W, 0x27 as KK],
      [VirtualMG68ACE_W_24g, 0x27 as KK],
      [VirtualMG68ACE, 0x27 as KK],
      [VirtualMG68ACE_UpPlus, 0x27 as KK],
      [VirtualMars68Wireless_24g, 0x27 as KK],
      [VirtualMars68Wireless, 0x27 as KK],
      [VirtualMars68Pro, 0x27 as KK],
      [VirtualMars68SE, 0x27 as KK],
      [VirtualMu68Pro_Cyan, 0x0b as KK],
      [VirtualMu68_ULTRA, 0x0b as KK],
      [VirtualNd63, 0x0b as KK],
      [VirtualMG63, 0x0b as KK],
      [VirtualRA68_1, 0x0b as KK],
      [VirtualMG75V2C12, 0x0b as KK],
      [VirtualNd63_Cyan, 0x0b as KK],
      [VirtualMg68Plus, 0x0306 as KK], // 新增
      [VirtualMg75Max, 0x0306 as KK],
      [VirtualND68Pro, 0x0306 as KK],
      [VirtualRA68, 0x0306 as KK],
      [VirtualMer68Max, 0x0306 as KK],
      [VirtualMer68SE_JT, 0x0306 as KK],
      [VirtualND63Ultra, 0x0306 as KK],
      [VirtualMars75, 0x0306 as KK],
      [VirtualMars75Pro, 0x0306 as KK], // 新增
      [VirtualIrokFe87V2, 0x36 as KK],
      [VirtualIrokFe87V2_24g, 0x36 as KK],
      [VirtualIrokFe87V2IMC, 0x36 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x36 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x48 as VK,
    HID: 0x0b as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'I',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0c as KK],
      [VirtualFE87V2_MuYan, 0x0c as KK],
      [VirtualPolar75, 0x0c as KK],
      [VirtualMg75, 0x0c as KK],
      [VirtualMg75Pro, 0x0c as KK],
      [VirtualMer68, 0x0c as KK],
      [VirtualMer68Pro, 0x0c as KK],
      [VirtualMer68SE, 0x32 as KK],
      [VirtualMer68Lite, 0x32 as KK],
      [VirtualMu68Pro, 0x0c as KK],
      [VirtualMars68ProWireless, 0x32 as KK],
      [VirtualMars68ProWireless_24g, 0x32 as KK],
      [VirtualMars68, 0x32 as KK],
      [VirtualMg68Lite, 0x32 as KK],
      [VirtualMg68Max, 0x32 as KK],
      [VirtualMg68Max_24g, 0x32 as KK],
      [VirtualMg68Pro, 0x32 as KK],
      [VirtualMg68SE, 0x32 as KK],
      [VirtualMg68, 0x32 as KK],
      [VirtualND63Max, 0x32 as KK],
      [VirtualND68, 0x32 as KK],
      [VirtualMG68ACE_W, 0x32 as KK],
      [VirtualMG68ACE_W_24g, 0x32 as KK],
      [VirtualMG68ACE, 0x32 as KK],
      [VirtualMG68ACE_UpPlus, 0x32 as KK],
      [VirtualMars68Wireless_24g, 0x32 as KK],
      [VirtualMars68Wireless, 0x32 as KK],
      [VirtualMars68Pro, 0x32 as KK],
      [VirtualMars68SE, 0x32 as KK],
      [VirtualMu68Pro_Cyan, 0x0c as KK],
      [VirtualMu68_ULTRA, 0x0c as KK],
      [VirtualNd63, 0x0c as KK],
      [VirtualMG63, 0x0c as KK],
      [VirtualRA68_1, 0x0c as KK],
      [VirtualMG75V2C12, 0x0c as KK],
      [VirtualNd63_Cyan, 0x0c as KK],
      [VirtualMg68Plus, 0x0208 as KK], // 新增
      [VirtualMg75Max, 0x0208 as KK],
      [VirtualND68Pro, 0x0208 as KK],
      [VirtualRA68, 0x0208 as KK],
      [VirtualMer68Max, 0x0208 as KK],
      [VirtualMer68SE_JT, 0x0208 as KK],
      [VirtualND63Ultra, 0x0208 as KK],
      [VirtualMars75, 0x0208 as KK],
      [VirtualMars75Pro, 0x0208 as KK], // 新增
      [VirtualIrokFe87V2, 0x28 as KK],
      [VirtualIrokFe87V2_24g, 0x28 as KK],
      [VirtualIrokFe87V2IMC, 0x28 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x28 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x49 as VK,
    HID: 0x0c as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'J',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0d as KK],
      [VirtualFE87V2_MuYan, 0x0d as KK],
      [VirtualPolar75, 0x0d as KK],
      [VirtualMg75, 0x0d as KK],
      [VirtualMg75Pro, 0x0d as KK],
      [VirtualMer68, 0x0d as KK],
      [VirtualMer68Pro, 0x0d as KK],
      [VirtualMer68SE, 0x2d as KK],
      [VirtualMer68Lite, 0x2d as KK],
      [VirtualMu68Pro, 0x0d as KK],
      [VirtualMars68ProWireless, 0x2d as KK],
      [VirtualMars68ProWireless_24g, 0x2d as KK],
      [VirtualMars68, 0x2d as KK],
      [VirtualMg68Lite, 0x2d as KK],
      [VirtualMg68Max, 0x2d as KK],
      [VirtualMg68Max_24g, 0x2d as KK],
      [VirtualMg68Pro, 0x2d as KK],
      [VirtualMg68SE, 0x2d as KK],
      [VirtualMg68, 0x2d as KK],
      [VirtualND63Max, 0x2d as KK],
      [VirtualND68, 0x2d as KK],
      [VirtualMG68ACE_W, 0x2d as KK],
      [VirtualMG68ACE_W_24g, 0x2d as KK],
      [VirtualMG68ACE, 0x2d as KK],
      [VirtualMG68ACE_UpPlus, 0x2d as KK],
      [VirtualMars68Wireless_24g, 0x2d as KK],
      [VirtualMars68Wireless, 0x2d as KK],
      [VirtualMars68Pro, 0x2d as KK],
      [VirtualMars68SE, 0x2d as KK],
      [VirtualMu68Pro_Cyan, 0x0d as KK],
      [VirtualMu68_ULTRA, 0x0d as KK],
      [VirtualNd63, 0x0d as KK],
      [VirtualMG63, 0x0d as KK],
      [VirtualRA68_1, 0x0d as KK],
      [VirtualMG75V2C12, 0x0d as KK],
      [VirtualNd63_Cyan, 0x0d as KK],
      [VirtualMg68Plus, 0x0307 as KK], // 新增
      [VirtualMg75Max, 0x0307 as KK],
      [VirtualND68Pro, 0x0307 as KK],
      [VirtualRA68, 0x0307 as KK],
      [VirtualMer68Max, 0x0307 as KK],
      [VirtualMer68SE_JT, 0x0307 as KK],
      [VirtualND63Ultra, 0x0307 as KK],
      [VirtualMars75, 0x0307 as KK],
      [VirtualMars75Pro, 0x0307 as KK], // 新增
      [VirtualIrokFe87V2, 0x37 as KK],
      [VirtualIrokFe87V2_24g, 0x37 as KK],
      [VirtualIrokFe87V2IMC, 0x37 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x37 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4a as VK,
    HID: 0x0d as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'K',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0e as KK],
      [VirtualFE87V2_MuYan, 0x0e as KK],
      [VirtualPolar75, 0x0e as KK],
      [VirtualMg75, 0x0e as KK],
      [VirtualMg75Pro, 0x0e as KK],
      [VirtualMer68, 0x0e as KK],
      [VirtualMer68Pro, 0x0e as KK],
      [VirtualMer68SE, 0x33 as KK],
      [VirtualMer68Lite, 0x33 as KK],
      [VirtualMu68Pro, 0x0e as KK],
      [VirtualMars68ProWireless, 0x33 as KK],
      [VirtualMars68ProWireless_24g, 0x33 as KK],
      [VirtualMars68, 0x33 as KK],
      [VirtualMg68Lite, 0x33 as KK],
      [VirtualMg68Max, 0x33 as KK],
      [VirtualMg68Max_24g, 0x33 as KK],
      [VirtualMg68Pro, 0x33 as KK],
      [VirtualMg68SE, 0x33 as KK],
      [VirtualMg68, 0x33 as KK],
      [VirtualND63Max, 0x33 as KK],
      [VirtualND68, 0x33 as KK],
      [VirtualMG68ACE_W, 0x33 as KK],
      [VirtualMG68ACE_W_24g, 0x33 as KK],
      [VirtualMG68ACE, 0x33 as KK],
      [VirtualMG68ACE_UpPlus, 0x33 as KK],
      [VirtualMars68Wireless_24g, 0x33 as KK],
      [VirtualMars68Wireless, 0x33 as KK],
      [VirtualMars68Pro, 0x33 as KK],
      [VirtualMars68SE, 0x33 as KK],
      [VirtualMu68Pro_Cyan, 0x0e as KK],
      [VirtualMu68_ULTRA, 0x0e as KK],
      [VirtualNd63, 0x0e as KK],
      [VirtualMG63, 0x0e as KK],
      [VirtualRA68_1, 0x0e as KK],
      [VirtualMG75V2C12, 0x0e as KK],
      [VirtualNd63_Cyan, 0x0e as KK],
      [VirtualMg68Plus, 0x0308 as KK], // 新增
      [VirtualMg75Max, 0x0308 as KK],
      [VirtualND68Pro, 0x0308 as KK],
      [VirtualRA68, 0x0308 as KK],
      [VirtualMer68Max, 0x0308 as KK],
      [VirtualMer68SE_JT, 0x0308 as KK],
      [VirtualND63Ultra, 0x0308 as KK],
      [VirtualMars75, 0x0308 as KK],
      [VirtualMars75Pro, 0x0308 as KK], // 新增
      [VirtualIrokFe87V2, 0x38 as KK],
      [VirtualIrokFe87V2_24g, 0x38 as KK],
      [VirtualIrokFe87V2IMC, 0x38 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x38 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4b as VK,
    HID: 0x0e as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'L',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x0f as KK],
      [VirtualFE87V2_MuYan, 0x0f as KK],
      [VirtualPolar75, 0x0f as KK],
      [VirtualMg75, 0x0f as KK],
      [VirtualMg75Pro, 0x0f as KK],
      [VirtualMer68, 0x0f as KK],
      [VirtualMer68Pro, 0x0f as KK],
      [VirtualMer68SE, 0x39 as KK],
      [VirtualMer68Lite, 0x39 as KK],
      [VirtualMu68Pro, 0x0f as KK],
      [VirtualMars68ProWireless, 0x39 as KK],
      [VirtualMars68ProWireless_24g, 0x39 as KK],
      [VirtualMars68, 0x39 as KK],
      [VirtualMg68Lite, 0x39 as KK],
      [VirtualMg68Max, 0x39 as KK],
      [VirtualMg68Max_24g, 0x39 as KK],
      [VirtualMg68Pro, 0x39 as KK],
      [VirtualMg68SE, 0x39 as KK],
      [VirtualMg68, 0x39 as KK],
      [VirtualND63Max, 0x39 as KK],
      [VirtualND68, 0x39 as KK],
      [VirtualMG68ACE_W, 0x39 as KK],
      [VirtualMG68ACE_W_24g, 0x39 as KK],
      [VirtualMG68ACE, 0x39 as KK],
      [VirtualMG68ACE_UpPlus, 0x39 as KK],
      [VirtualMars68Wireless_24g, 0x39 as KK],
      [VirtualMars68Wireless, 0x39 as KK],
      [VirtualMars68Pro, 0x39 as KK],
      [VirtualMars68SE, 0x39 as KK],
      [VirtualMu68Pro_Cyan, 0x0f as KK],
      [VirtualMu68_ULTRA, 0x0f as KK],
      [VirtualNd63, 0x0f as KK],
      [VirtualMG63, 0x0f as KK],
      [VirtualRA68_1, 0x0f as KK],
      [VirtualMG75V2C12, 0x0f as KK],
      [VirtualNd63_Cyan, 0x0f as KK],
      [VirtualMg68Plus, 0x0309 as KK], // 新增
      [VirtualMg75Max, 0x0309 as KK],
      [VirtualND68Pro, 0x0309 as KK],
      [VirtualRA68, 0x0309 as KK],
      [VirtualMer68Max, 0x0309 as KK],
      [VirtualMer68SE_JT, 0x0309 as KK],
      [VirtualND63Ultra, 0x0309 as KK],
      [VirtualMars75, 0x0309 as KK],
      [VirtualMars75Pro, 0x0309 as KK], // 新增
      [VirtualIrokFe87V2, 0x39 as KK],
      [VirtualIrokFe87V2_24g, 0x39 as KK],
      [VirtualIrokFe87V2IMC, 0x39 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x39 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4c as VK,
    HID: 0x0f as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'M',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x10 as KK],
      [VirtualFE87V2_MuYan, 0x10 as KK],
      [VirtualPolar75, 0x10 as KK],
      [VirtualMg75, 0x10 as KK],
      [VirtualMg75Pro, 0x10 as KK],
      [VirtualMer68, 0x10 as KK],
      [VirtualMer68Pro, 0x10 as KK],
      [VirtualMer68SE, 0x34 as KK],
      [VirtualMer68Lite, 0x34 as KK],
      [VirtualMu68Pro, 0x10 as KK],
      [VirtualMars68ProWireless, 0x34 as KK],
      [VirtualMars68ProWireless_24g, 0x34 as KK],
      [VirtualMars68, 0x34 as KK],
      [VirtualMg68Lite, 0x34 as KK],
      [VirtualMg68Max, 0x34 as KK],
      [VirtualMg68Max_24g, 0x34 as KK],
      [VirtualMg68Pro, 0x34 as KK],
      [VirtualMg68SE, 0x34 as KK],
      [VirtualMg68, 0x34 as KK],
      [VirtualND63Max, 0x34 as KK],
      [VirtualND68, 0x34 as KK],
      [VirtualMG68ACE_W, 0x34 as KK],
      [VirtualMG68ACE_W_24g, 0x34 as KK],
      [VirtualMG68ACE, 0x34 as KK],
      [VirtualMG68ACE_UpPlus, 0x34 as KK],
      [VirtualMars68Wireless_24g, 0x34 as KK],
      [VirtualMars68Wireless, 0x34 as KK],
      [VirtualMars68Pro, 0x34 as KK],
      [VirtualMars68SE, 0x34 as KK],
      [VirtualMu68Pro_Cyan, 0x10 as KK],
      [VirtualMu68_ULTRA, 0x10 as KK],
      [VirtualNd63, 0x10 as KK],
      [VirtualMG63, 0x10 as KK],
      [VirtualRA68_1, 0x10 as KK],
      [VirtualMG75V2C12, 0x10 as KK],
      [VirtualNd63_Cyan, 0x10 as KK],
      [VirtualMg68Plus, 0x0408 as KK], // 新增
      [VirtualMg75Max, 0x0408 as KK],
      [VirtualND68Pro, 0x0408 as KK],
      [VirtualRA68, 0x0408 as KK],
      [VirtualMer68Max, 0x0408 as KK],
      [VirtualMer68SE_JT, 0x0408 as KK],
      [VirtualND63Ultra, 0x0408 as KK],
      [VirtualMars75, 0x0408 as KK],
      [VirtualMars75Pro, 0x0408 as KK], // 新增
      [VirtualIrokFe87V2, 0x47 as KK],
      [VirtualIrokFe87V2_24g, 0x47 as KK],
      [VirtualIrokFe87V2IMC, 0x47 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x47 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4d as VK,
    HID: 0x10 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'N',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x11 as KK],
      [VirtualFE87V2_MuYan, 0x11 as KK],
      [VirtualPolar75, 0x11 as KK],
      [VirtualMg75, 0x11 as KK],
      [VirtualMg75Pro, 0x11 as KK],
      [VirtualMer68, 0x11 as KK],
      [VirtualMer68Pro, 0x11 as KK],
      [VirtualMer68SE, 0x2e as KK],
      [VirtualMer68Lite, 0x2e as KK],
      [VirtualMu68Pro, 0x11 as KK],
      [VirtualMars68ProWireless, 0x2e as KK],
      [VirtualMars68ProWireless_24g, 0x2e as KK],
      [VirtualMars68, 0x2e as KK],
      [VirtualMg68Lite, 0x2e as KK],
      [VirtualMg68Max, 0x2e as KK],
      [VirtualMg68Max_24g, 0x2e as KK],
      [VirtualMg68Pro, 0x2e as KK],
      [VirtualMg68SE, 0x2e as KK],
      [VirtualMg68, 0x2e as KK],
      [VirtualND63Max, 0x2e as KK],
      [VirtualND68, 0x2e as KK],
      [VirtualMG68ACE_W, 0x2e as KK],
      [VirtualMG68ACE_W_24g, 0x2e as KK],
      [VirtualMG68ACE, 0x2e as KK],
      [VirtualMG68ACE_UpPlus, 0x2e as KK],
      [VirtualMars68Wireless_24g, 0x2e as KK],
      [VirtualMars68Wireless, 0x2e as KK],
      [VirtualMars68Pro, 0x2e as KK],
      [VirtualMars68SE, 0x2e as KK],
      [VirtualMu68Pro_Cyan, 0x11 as KK],
      [VirtualMu68_ULTRA, 0x11 as KK],
      [VirtualNd63, 0x11 as KK],
      [VirtualMG63, 0x11 as KK],
      [VirtualRA68_1, 0x11 as KK],
      [VirtualMG75V2C12, 0x11 as KK],
      [VirtualNd63_Cyan, 0x11 as KK],
      [VirtualMg68Plus, 0x0407 as KK], // 新增
      [VirtualMg75Max, 0x0407 as KK],
      [VirtualND68Pro, 0x0407 as KK],
      [VirtualRA68, 0x0407 as KK],
      [VirtualMer68Max, 0x0407 as KK],
      [VirtualMer68SE_JT, 0x0407 as KK],
      [VirtualND63Ultra, 0x0407 as KK],
      [VirtualMars75, 0x0407 as KK],
      [VirtualMars75Pro, 0x0407 as KK], // 新增
      [VirtualIrokFe87V2, 0x46 as KK],
      [VirtualIrokFe87V2_24g, 0x46 as KK],
      [VirtualIrokFe87V2IMC, 0x46 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x46 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4e as VK,
    HID: 0x11 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'O',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x12 as KK],
      [VirtualFE87V2_MuYan, 0x12 as KK],
      [VirtualPolar75, 0x12 as KK],
      [VirtualMg75, 0x12 as KK],
      [VirtualMg75Pro, 0x12 as KK],
      [VirtualMer68, 0x12 as KK],
      [VirtualMer68Pro, 0x12 as KK],
      [VirtualMer68SE, 0x38 as KK],
      [VirtualMer68Lite, 0x38 as KK],
      [VirtualMu68Pro, 0x12 as KK],
      [VirtualMars68ProWireless, 0x38 as KK],
      [VirtualMars68ProWireless_24g, 0x38 as KK],
      [VirtualMars68, 0x38 as KK],
      [VirtualMg68Lite, 0x38 as KK],
      [VirtualMg68Max, 0x38 as KK],
      [VirtualMg68Max_24g, 0x38 as KK],
      [VirtualMg68Pro, 0x38 as KK],
      [VirtualMg68SE, 0x38 as KK],
      [VirtualMg68, 0x38 as KK],
      [VirtualND63Max, 0x38 as KK],
      [VirtualND68, 0x38 as KK],
      [VirtualMG68ACE_W, 0x38 as KK],
      [VirtualMG68ACE_W_24g, 0x38 as KK],
      [VirtualMG68ACE, 0x38 as KK],
      [VirtualMG68ACE_UpPlus, 0x38 as KK],
      [VirtualMars68Wireless_24g, 0x38 as KK],
      [VirtualMars68Wireless, 0x38 as KK],
      [VirtualMars68Pro, 0x38 as KK],
      [VirtualMars68SE, 0x38 as KK],
      [VirtualMu68Pro_Cyan, 0x12 as KK],
      [VirtualMu68_ULTRA, 0x12 as KK],
      [VirtualNd63, 0x12 as KK],
      [VirtualMG63, 0x12 as KK],
      [VirtualRA68_1, 0x12 as KK],
      [VirtualMG75V2C12, 0x12 as KK],
      [VirtualNd63_Cyan, 0x12 as KK],
      [VirtualMg68Plus, 0x0209 as KK], // 新增
      [VirtualMg75Max, 0x0209 as KK],
      [VirtualND68Pro, 0x0209 as KK],
      [VirtualRA68, 0x0209 as KK],
      [VirtualMer68Max, 0x0209 as KK],
      [VirtualMer68SE_JT, 0x0209 as KK],
      [VirtualND63Ultra, 0x0209 as KK],
      [VirtualMars75, 0x0209 as KK],
      [VirtualMars75Pro, 0x0209 as KK], // 新增
      [VirtualIrokFe87V2, 0x29 as KK],
      [VirtualIrokFe87V2_24g, 0x29 as KK],
      [VirtualIrokFe87V2IMC, 0x29 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x29 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x4f as VK,
    HID: 0x12 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'P',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x13 as KK],
      [VirtualFE87V2_MuYan, 0x13 as KK],
      [VirtualPolar75, 0x13 as KK],
      [VirtualMg75, 0x13 as KK],
      [VirtualMg75Pro, 0x13 as KK],
      [VirtualMer68, 0x13 as KK],
      [VirtualMer68Pro, 0x13 as KK],
      [VirtualMer68SE, 0x3e as KK],
      [VirtualMer68Lite, 0x3e as KK],
      [VirtualMu68Pro, 0x13 as KK],
      [VirtualMars68ProWireless, 0x3e as KK],
      [VirtualMars68ProWireless_24g, 0x3e as KK],
      [VirtualMars68, 0x3e as KK],
      [VirtualMg68Lite, 0x3e as KK],
      [VirtualMg68Max, 0x3e as KK],
      [VirtualMg68Max_24g, 0x3e as KK],
      [VirtualMg68Pro, 0x3e as KK],
      [VirtualMg68SE, 0x3e as KK],
      [VirtualMg68, 0x3e as KK],
      [VirtualND63Max, 0x3e as KK],
      [VirtualND68, 0x3e as KK],
      [VirtualMG68ACE_W, 0x3e as KK],
      [VirtualMG68ACE_W_24g, 0x3e as KK],
      [VirtualMG68ACE, 0x3e as KK],
      [VirtualMG68ACE_UpPlus, 0x3e as KK],
      [VirtualMars68Wireless_24g, 0x3e as KK],
      [VirtualMars68Wireless, 0x3e as KK],
      [VirtualMars68Pro, 0x3e as KK],
      [VirtualMars68SE, 0x3e as KK],
      [VirtualMu68Pro_Cyan, 0x13 as KK],
      [VirtualMu68_ULTRA, 0x13 as KK],
      [VirtualNd63, 0x13 as KK],
      [VirtualMG63, 0x13 as KK],
      [VirtualRA68_1, 0x13 as KK],
      [VirtualMG75V2C12, 0x13 as KK],
      [VirtualNd63_Cyan, 0x13 as KK],
      [VirtualMg68Plus, 0x020a as KK], // 新增
      [VirtualMg75Max, 0x020a as KK],
      [VirtualND68Pro, 0x020a as KK],
      [VirtualRA68, 0x020a as KK],
      [VirtualMer68Max, 0x020a as KK],
      [VirtualMer68SE_JT, 0x020a as KK],
      [VirtualND63Ultra, 0x020a as KK],
      [VirtualMars75, 0x020a as KK],
      [VirtualMars75Pro, 0x020a as KK], // 新增
      [VirtualIrokFe87V2, 0x2a as KK],
      [VirtualIrokFe87V2_24g, 0x2a as KK],
      [VirtualIrokFe87V2IMC, 0x2a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x50 as VK,
    HID: 0x13 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'Q',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x14 as KK],
      [VirtualFE87V2_MuYan, 0x14 as KK],
      [VirtualPolar75, 0x14 as KK],
      [VirtualMg75, 0x14 as KK],
      [VirtualMg75Pro, 0x14 as KK],
      [VirtualMer68, 0x14 as KK],
      [VirtualMer68Pro, 0x14 as KK],
      [VirtualMer68SE, 0x08 as KK],
      [VirtualMer68Lite, 0x08 as KK],
      [VirtualMu68Pro, 0x14 as KK],
      [VirtualMars68ProWireless, 0x08 as KK],
      [VirtualMars68ProWireless_24g, 0x08 as KK],
      [VirtualMars68, 0x08 as KK],
      [VirtualMg68Lite, 0x08 as KK],
      [VirtualMg68Max, 0x08 as KK],
      [VirtualMg68Max_24g, 0x08 as KK],
      [VirtualMg68Pro, 0x08 as KK],
      [VirtualMg68SE, 0x08 as KK],
      [VirtualMg68, 0x08 as KK],
      [VirtualND63Max, 0x08 as KK],
      [VirtualND68, 0x08 as KK],
      [VirtualMG68ACE_W, 0x08 as KK],
      [VirtualMG68ACE_W_24g, 0x08 as KK],
      [VirtualMG68ACE, 0x08 as KK],
      [VirtualMG68ACE_UpPlus, 0x08 as KK],
      [VirtualMars68Wireless_24g, 0x08 as KK],
      [VirtualMars68Wireless, 0x08 as KK],
      [VirtualMars68Pro, 0x08 as KK],
      [VirtualMars68SE, 0x08 as KK],
      [VirtualMu68Pro_Cyan, 0x14 as KK],
      [VirtualMu68_ULTRA, 0x14 as KK],
      [VirtualNd63, 0x14 as KK],
      [VirtualMG63, 0x14 as KK],
      [VirtualRA68_1, 0x14 as KK],
      [VirtualMG75V2C12, 0x14 as KK],
      [VirtualNd63_Cyan, 0x14 as KK],
      [VirtualMg68Plus, 0x0201 as KK], // 新增
      [VirtualMg75Max, 0x0201 as KK],
      [VirtualND68Pro, 0x0201 as KK],
      [VirtualRA68, 0x0201 as KK],
      [VirtualMer68Max, 0x0201 as KK],
      [VirtualMer68SE_JT, 0x0201 as KK],
      [VirtualND63Ultra, 0x0201 as KK],
      [VirtualMars75, 0x0201 as KK],
      [VirtualMars75Pro, 0x0201 as KK], // 新增
      [VirtualIrokFe87V2, 0x21 as KK],
      [VirtualIrokFe87V2_24g, 0x21 as KK],
      [VirtualIrokFe87V2IMC, 0x21 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x21 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x51 as VK,
    HID: 0x14 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'R',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x15 as KK],
      [VirtualFE87V2_MuYan, 0x15 as KK],
      [VirtualPolar75, 0x15 as KK],
      [VirtualMg75, 0x15 as KK],
      [VirtualMg75Pro, 0x15 as KK],
      [VirtualMer68, 0x15 as KK],
      [VirtualMer68Pro, 0x15 as KK],
      [VirtualMer68SE, 0x1a as KK],
      [VirtualMer68Lite, 0x1a as KK],
      [VirtualMu68Pro, 0x15 as KK],
      [VirtualMars68ProWireless, 0x1a as KK],
      [VirtualMars68ProWireless_24g, 0x1a as KK],
      [VirtualMars68, 0x1a as KK],
      [VirtualMg68Lite, 0x1a as KK],
      [VirtualMg68Max, 0x1a as KK],
      [VirtualMg68Max_24g, 0x1a as KK],
      [VirtualMg68Pro, 0x1a as KK],
      [VirtualMg68SE, 0x1a as KK],
      [VirtualMg68, 0x1a as KK],
      [VirtualND63Max, 0x1a as KK],
      [VirtualND68, 0x1a as KK],
      [VirtualMG68ACE_W, 0x1a as KK],
      [VirtualMG68ACE_W_24g, 0x1a as KK],
      [VirtualMG68ACE, 0x1a as KK],
      [VirtualMG68ACE_UpPlus, 0x1a as KK],
      [VirtualMars68Wireless_24g, 0x1a as KK],
      [VirtualMars68Wireless, 0x1a as KK],
      [VirtualMars68Pro, 0x1a as KK],
      [VirtualMars68SE, 0x1a as KK],
      [VirtualMu68Pro_Cyan, 0x15 as KK],
      [VirtualMu68_ULTRA, 0x15 as KK],
      [VirtualNd63, 0x15 as KK],
      [VirtualMG63, 0x15 as KK],
      [VirtualRA68_1, 0x15 as KK],
      [VirtualMG75V2C12, 0x15 as KK],
      [VirtualNd63_Cyan, 0x15 as KK],
      [VirtualMg68Plus, 0x0204 as KK], // 新增
      [VirtualMg75Max, 0x0204 as KK],
      [VirtualND68Pro, 0x0204 as KK],
      [VirtualRA68, 0x0204 as KK],
      [VirtualMer68Max, 0x0204 as KK],
      [VirtualMer68SE_JT, 0x0204 as KK],
      [VirtualND63Ultra, 0x0204 as KK],
      [VirtualMars75, 0x0204 as KK],
      [VirtualMars75Pro, 0x0204 as KK], // 新增
      [VirtualIrokFe87V2, 0x24 as KK],
      [VirtualIrokFe87V2_24g, 0x24 as KK],
      [VirtualIrokFe87V2IMC, 0x24 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x24 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x52 as VK,
    HID: 0x15 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'S',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x16 as KK],
      [VirtualFE87V2_MuYan, 0x16 as KK],
      [VirtualPolar75, 0x16 as KK],
      [VirtualMg75, 0x16 as KK],
      [VirtualMg75Pro, 0x16 as KK],
      [VirtualMer68, 0x16 as KK],
      [VirtualMer68Pro, 0x16 as KK],
      [VirtualMer68SE, 0x0f as KK],
      [VirtualMer68Lite, 0x0f as KK],
      [VirtualMu68Pro, 0x16 as KK],
      [VirtualMars68ProWireless, 0x0f as KK],
      [VirtualMars68ProWireless_24g, 0x0f as KK],
      [VirtualMars68, 0x0f as KK],
      [VirtualMg68Lite, 0x0f as KK],
      [VirtualMg68Max, 0x0f as KK],
      [VirtualMg68Max_24g, 0x0f as KK],
      [VirtualMg68Pro, 0x0f as KK],
      [VirtualMg68SE, 0x0f as KK],
      [VirtualMg68, 0x0f as KK],
      [VirtualND63Max, 0x0f as KK],
      [VirtualND68, 0x0f as KK],
      [VirtualMG68ACE_W, 0x0f as KK],
      [VirtualMG68ACE_W_24g, 0x0f as KK],
      [VirtualMG68ACE, 0x0f as KK],
      [VirtualMG68ACE_UpPlus, 0x0f as KK],
      [VirtualMars68Wireless_24g, 0x0f as KK],
      [VirtualMars68Wireless, 0x0f as KK],
      [VirtualMars68Pro, 0x0f as KK],
      [VirtualMars68SE, 0x0f as KK],
      [VirtualMu68Pro_Cyan, 0x16 as KK],
      [VirtualMu68_ULTRA, 0x16 as KK],
      [VirtualNd63, 0x16 as KK],
      [VirtualMG63, 0x16 as KK],
      [VirtualRA68_1, 0x16 as KK],
      [VirtualMG75V2C12, 0x16 as KK],
      [VirtualNd63_Cyan, 0x16 as KK],
      [VirtualMg68Plus, 0x0302 as KK], // 新增
      [VirtualMg75Max, 0x0302 as KK],
      [VirtualND68Pro, 0x0302 as KK],
      [VirtualRA68, 0x0302 as KK],
      [VirtualMer68Max, 0x0302 as KK],
      [VirtualMer68SE_JT, 0x0302 as KK],
      [VirtualND63Ultra, 0x0302 as KK],
      [VirtualMars75, 0x0302 as KK],
      [VirtualMars75Pro, 0x0302 as KK], // 新增
      [VirtualIrokFe87V2, 0x32 as KK],
      [VirtualIrokFe87V2_24g, 0x32 as KK],
      [VirtualIrokFe87V2IMC, 0x32 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x32 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x53 as VK,
    HID: 0x16 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'T',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x17 as KK],
      [VirtualFE87V2_MuYan, 0x17 as KK],
      [VirtualPolar75, 0x17 as KK],
      [VirtualMg75, 0x17 as KK],
      [VirtualMg75Pro, 0x17 as KK],
      [VirtualMer68, 0x17 as KK],
      [VirtualMer68Pro, 0x17 as KK],
      [VirtualMer68SE, 0x20 as KK],
      [VirtualMer68Lite, 0x20 as KK],
      [VirtualMu68Pro, 0x17 as KK],
      [VirtualMars68ProWireless, 0x20 as KK],
      [VirtualMars68ProWireless_24g, 0x20 as KK],
      [VirtualMars68, 0x20 as KK],
      [VirtualMg68Lite, 0x20 as KK],
      [VirtualMg68Max, 0x20 as KK],
      [VirtualMg68Max_24g, 0x20 as KK],
      [VirtualMg68Pro, 0x20 as KK],
      [VirtualMg68SE, 0x20 as KK],
      [VirtualMg68, 0x20 as KK],
      [VirtualND63Max, 0x20 as KK],
      [VirtualND68, 0x20 as KK],
      [VirtualMG68ACE_W, 0x20 as KK],
      [VirtualMG68ACE_W_24g, 0x20 as KK],
      [VirtualMG68ACE, 0x20 as KK],
      [VirtualMG68ACE_UpPlus, 0x20 as KK],
      [VirtualMars68Wireless_24g, 0x20 as KK],
      [VirtualMars68Wireless, 0x20 as KK],
      [VirtualMars68Pro, 0x20 as KK],
      [VirtualMars68SE, 0x20 as KK],
      [VirtualMu68Pro_Cyan, 0x17 as KK],
      [VirtualMu68_ULTRA, 0x17 as KK],
      [VirtualNd63, 0x17 as KK],
      [VirtualMG63, 0x17 as KK],
      [VirtualRA68_1, 0x17 as KK],
      [VirtualMG75V2C12, 0x17 as KK],
      [VirtualNd63_Cyan, 0x17 as KK],
      [VirtualMg68Plus, 0x0205 as KK], // 新增
      [VirtualMg75Max, 0x0205 as KK],
      [VirtualND68Pro, 0x0205 as KK],
      [VirtualRA68, 0x0205 as KK],
      [VirtualMer68Max, 0x0205 as KK],
      [VirtualMer68SE_JT, 0x0205 as KK],
      [VirtualND63Ultra, 0x0205 as KK],
      [VirtualMars75, 0x0205 as KK],
      [VirtualMars75Pro, 0x0205 as KK], // 新增
      [VirtualIrokFe87V2, 0x25 as KK],
      [VirtualIrokFe87V2_24g, 0x25 as KK],
      [VirtualIrokFe87V2IMC, 0x25 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x25 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x54 as VK,
    HID: 0x17 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'U',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x18 as KK],
      [VirtualFE87V2_MuYan, 0x18 as KK],
      [VirtualPolar75, 0x18 as KK],
      [VirtualMg75, 0x18 as KK],

      [VirtualMg75Pro, 0x18 as KK],
      [VirtualMer68, 0x18 as KK],
      [VirtualMer68Pro, 0x18 as KK],
      [VirtualMer68SE, 0x2c as KK],
      [VirtualMer68Lite, 0x2c as KK],

      [VirtualMu68Pro, 0x18 as KK],
      [VirtualMars68ProWireless, 0x2c as KK],
      [VirtualMars68ProWireless_24g, 0x2c as KK],
      [VirtualMars68, 0x2c as KK],
      [VirtualMg68Lite, 0x2c as KK],
      [VirtualMg68Max, 0x2c as KK],
      [VirtualMg68Max_24g, 0x2c as KK],
      [VirtualMg68Pro, 0x2c as KK],
      [VirtualMg68SE, 0x2c as KK],
      [VirtualMg68, 0x2c as KK],
      [VirtualND63Max, 0x2c as KK],
      [VirtualND68, 0x2c as KK],
      [VirtualMG68ACE_W, 0x2c as KK],
      [VirtualMG68ACE_W_24g, 0x2c as KK],
      [VirtualMG68ACE, 0x2c as KK],
      [VirtualMG68ACE_UpPlus, 0x2c as KK],
      [VirtualMars68Wireless_24g, 0x2c as KK],
      [VirtualMars68Wireless, 0x2c as KK],
      [VirtualMars68Pro, 0x2c as KK],
      [VirtualMars68SE, 0x2c as KK],
      [VirtualMu68Pro_Cyan, 0x18 as KK],
      [VirtualMu68_ULTRA, 0x18 as KK],
      [VirtualNd63, 0x18 as KK],
      [VirtualMG63, 0x18 as KK],
      [VirtualRA68_1, 0x18 as KK],
      [VirtualMG75V2C12, 0x18 as KK],
      [VirtualNd63_Cyan, 0x18 as KK],
      [VirtualMg68Plus, 0x0207 as KK], // 新增
      [VirtualMg75Max, 0x0207 as KK],
      [VirtualND68Pro, 0x0207 as KK],
      [VirtualRA68, 0x0207 as KK],
      [VirtualMer68Max, 0x0207 as KK],
      [VirtualMer68SE_JT, 0x0207 as KK],
      [VirtualND63Ultra, 0x0207 as KK],
      [VirtualMars75, 0x0207 as KK],
      [VirtualMars75Pro, 0x0207 as KK], // 新增
      [VirtualIrokFe87V2, 0x27 as KK],
      [VirtualIrokFe87V2_24g, 0x27 as KK],
      [VirtualIrokFe87V2IMC, 0x27 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x27 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x55 as VK,
    HID: 0x18 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'V',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x19 as KK],
      [VirtualFE87V2_MuYan, 0x19 as KK],
      [VirtualPolar75, 0x19 as KK],
      [VirtualMg75, 0x19 as KK],

      [VirtualMg75Pro, 0x19 as KK],
      [VirtualMer68, 0x19 as KK],
      [VirtualMer68Pro, 0x19 as KK],
      [VirtualMer68SE, 0x22 as KK],
      [VirtualMer68Lite, 0x22 as KK],

      [VirtualMu68Pro, 0x19 as KK],
      [VirtualMars68ProWireless, 0x22 as KK],
      [VirtualMars68ProWireless_24g, 0x22 as KK],
      [VirtualMars68, 0x22 as KK],
      [VirtualMg68Lite, 0x22 as KK],
      [VirtualMg68Max, 0x22 as KK],
      [VirtualMg68Max_24g, 0x22 as KK],
      [VirtualMg68Pro, 0x22 as KK],
      [VirtualMg68SE, 0x22 as KK],
      [VirtualMg68, 0x22 as KK],
      [VirtualND63Max, 0x22 as KK],
      [VirtualND68, 0x22 as KK],
      [VirtualMG68ACE_W, 0x22 as KK],
      [VirtualMG68ACE_W_24g, 0x22 as KK],
      [VirtualMG68ACE, 0x22 as KK],
      [VirtualMG68ACE_UpPlus, 0x22 as KK],
      [VirtualMars68Wireless_24g, 0x22 as KK],
      [VirtualMars68Wireless, 0x22 as KK],
      [VirtualMars68Pro, 0x22 as KK],
      [VirtualMars68SE, 0x22 as KK],
      [VirtualMu68Pro_Cyan, 0x19 as KK],
      [VirtualMu68_ULTRA, 0x19 as KK],
      [VirtualNd63, 0x19 as KK],
      [VirtualMG63, 0x19 as KK],
      [VirtualRA68_1, 0x19 as KK],
      [VirtualMG75V2C12, 0x19 as KK],
      [VirtualNd63_Cyan, 0x19 as KK],
      [VirtualMg68Plus, 0x0405 as KK], // 新增
      [VirtualMg75Max, 0x0405 as KK],
      [VirtualND68Pro, 0x0405 as KK],
      [VirtualRA68, 0x0405 as KK],
      [VirtualMer68Max, 0x0405 as KK],
      [VirtualMer68SE_JT, 0x0405 as KK],
      [VirtualND63Ultra, 0x0405 as KK],
      [VirtualMars75, 0x0405 as KK],
      [VirtualMars75Pro, 0x0405 as KK], // 新增
      [VirtualIrokFe87V2, 0x44 as KK],
      [VirtualIrokFe87V2_24g, 0x44 as KK],
      [VirtualIrokFe87V2IMC, 0x44 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x44 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x56 as VK,
    HID: 0x19 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'W',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1a as KK],
      [VirtualFE87V2_MuYan, 0x1a as KK],
      [VirtualPolar75, 0x1a as KK],
      [VirtualMg75, 0x1a as KK],

      [VirtualMg75Pro, 0x1a as KK],
      [VirtualMer68, 0x1a as KK],
      [VirtualMer68Pro, 0x1a as KK],
      [VirtualMer68SE, 0x0e as KK],
      [VirtualMer68Lite, 0x0e as KK],

      [VirtualMu68Pro, 0x1a as KK],
      [VirtualMars68ProWireless, 0x0e as KK],
      [VirtualMars68ProWireless_24g, 0x0e as KK],
      [VirtualMars68, 0x0e as KK],
      [VirtualMg68Lite, 0x0e as KK],
      [VirtualMg68Max, 0x0e as KK],
      [VirtualMg68Max_24g, 0x0e as KK],
      [VirtualMg68Pro, 0x0e as KK],
      [VirtualMg68SE, 0x0e as KK],
      [VirtualMg68, 0x0e as KK],
      [VirtualND63Max, 0x0e as KK],
      [VirtualND68, 0x0e as KK],
      [VirtualMG68ACE_W, 0x0e as KK],
      [VirtualMG68ACE_W_24g, 0x0e as KK],
      [VirtualMG68ACE, 0x0e as KK],
      [VirtualMG68ACE_UpPlus, 0x0e as KK],
      [VirtualMars68Wireless_24g, 0x0e as KK],
      [VirtualMars68Wireless, 0x0e as KK],
      [VirtualMars68Pro, 0x0e as KK],
      [VirtualMars68SE, 0x0e as KK],
      [VirtualMu68Pro_Cyan, 0x1a as KK],
      [VirtualMu68_ULTRA, 0x1a as KK],
      [VirtualNd63, 0x1a as KK],
      [VirtualMG63, 0x1a as KK],
      [VirtualRA68_1, 0x1a as KK],
      [VirtualMG75V2C12, 0x1a as KK],
      [VirtualNd63_Cyan, 0x1a as KK],
      [VirtualMg68Plus, 0x0202 as KK], // 新增
      [VirtualMg75Max, 0x0202 as KK],
      [VirtualND68Pro, 0x0202 as KK],
      [VirtualRA68, 0x0202 as KK],
      [VirtualMer68Max, 0x0202 as KK],
      [VirtualMer68SE_JT, 0x0202 as KK],
      [VirtualND63Ultra, 0x0202 as KK],
      [VirtualMars75, 0x0202 as KK],
      [VirtualMars75Pro, 0x0202 as KK], // 新增
      [VirtualIrokFe87V2, 0x22 as KK],
      [VirtualIrokFe87V2_24g, 0x22 as KK],
      [VirtualIrokFe87V2IMC, 0x22 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x22 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x57 as VK,
    HID: 0x1a as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'X',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1b as KK],
      [VirtualFE87V2_MuYan, 0x1b as KK],
      [VirtualPolar75, 0x1b as KK],
      [VirtualMg75, 0x1b as KK],

      [VirtualMg75Pro, 0x1b as KK],
      [VirtualMer68, 0x1b as KK],
      [VirtualMer68Pro, 0x1b as KK],
      [VirtualMer68SE, 0x16 as KK],
      [VirtualMer68Lite, 0x16 as KK],

      [VirtualMu68Pro, 0x1b as KK],
      [VirtualMars68ProWireless, 0x16 as KK],
      [VirtualMars68ProWireless_24g, 0x16 as KK],
      [VirtualMars68, 0x16 as KK],
      [VirtualMg68Lite, 0x16 as KK],
      [VirtualMg68Max, 0x16 as KK],
      [VirtualMg68Max_24g, 0x16 as KK],
      [VirtualMg68Pro, 0x16 as KK],
      [VirtualMg68SE, 0x16 as KK],
      [VirtualMg68, 0x16 as KK],
      [VirtualND63Max, 0x16 as KK],
      [VirtualND68, 0x16 as KK],
      [VirtualMG68ACE_W, 0x16 as KK],
      [VirtualMG68ACE_W_24g, 0x16 as KK],
      [VirtualMG68ACE, 0x16 as KK],
      [VirtualMG68ACE_UpPlus, 0x16 as KK],
      [VirtualMars68Wireless_24g, 0x16 as KK],
      [VirtualMars68Wireless, 0x16 as KK],
      [VirtualMars68Pro, 0x16 as KK],
      [VirtualMars68SE, 0x16 as KK],
      [VirtualMu68Pro_Cyan, 0x1b as KK],
      [VirtualMu68_ULTRA, 0x1b as KK],
      [VirtualNd63, 0x1b as KK],
      [VirtualMG63, 0x1b as KK],
      [VirtualRA68_1, 0x1b as KK],
      [VirtualMG75V2C12, 0x1b as KK],
      [VirtualNd63_Cyan, 0x1b as KK],
      [VirtualMg68Plus, 0x0403 as KK], // 新增
      [VirtualMg75Max, 0x0403 as KK],
      [VirtualND68Pro, 0x0403 as KK],
      [VirtualRA68, 0x0403 as KK],
      [VirtualMer68Max, 0x0403 as KK],
      [VirtualMer68SE_JT, 0x0403 as KK],
      [VirtualND63Ultra, 0x0403 as KK],
      [VirtualMars75, 0x0403 as KK],
      [VirtualMars75Pro, 0x0403 as KK], // 新增
      [VirtualIrokFe87V2, 0x42 as KK],
      [VirtualIrokFe87V2_24g, 0x42 as KK],
      [VirtualIrokFe87V2IMC, 0x42 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x42 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x58 as VK,
    HID: 0x1b as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'Y',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1c as KK],
      [VirtualFE87V2_MuYan, 0x1c as KK],
      [VirtualPolar75, 0x1c as KK],
      [VirtualMg75, 0x1c as KK],

      [VirtualMg75Pro, 0x1c as KK],
      [VirtualMer68, 0x1c as KK],
      [VirtualMer68Pro, 0x1c as KK],
      [VirtualMer68SE, 0x26 as KK],
      [VirtualMer68Lite, 0x26 as KK],

      [VirtualMu68Pro, 0x1c as KK],
      [VirtualMars68ProWireless, 0x26 as KK],
      [VirtualMars68ProWireless_24g, 0x26 as KK],
      [VirtualMars68, 0x26 as KK],
      [VirtualMg68Lite, 0x26 as KK],
      [VirtualMg68Max, 0x26 as KK],
      [VirtualMg68Max_24g, 0x26 as KK],
      [VirtualMg68Pro, 0x26 as KK],
      [VirtualMg68SE, 0x26 as KK],
      [VirtualMg68, 0x26 as KK],
      [VirtualND63Max, 0x26 as KK],
      [VirtualND68, 0x26 as KK],
      [VirtualMG68ACE_W, 0x26 as KK],
      [VirtualMG68ACE_W_24g, 0x26 as KK],
      [VirtualMG68ACE, 0x26 as KK],
      [VirtualMG68ACE_UpPlus, 0x26 as KK],
      [VirtualMars68Wireless_24g, 0x26 as KK],
      [VirtualMars68Wireless, 0x26 as KK],
      [VirtualMars68Pro, 0x26 as KK],
      [VirtualMars68SE, 0x26 as KK],
      [VirtualMu68Pro_Cyan, 0x1c as KK],
      [VirtualMu68_ULTRA, 0x1c as KK],
      [VirtualNd63, 0x1c as KK],
      [VirtualMG63, 0x1c as KK],
      [VirtualRA68_1, 0x1c as KK],
      [VirtualMG75V2C12, 0x1c as KK],
      [VirtualNd63_Cyan, 0x1c as KK],
      [VirtualMg68Plus, 0x0206 as KK], // 新增
      [VirtualMg75Max, 0x0206 as KK],
      [VirtualND68Pro, 0x0206 as KK],
      [VirtualRA68, 0x0206 as KK],
      [VirtualMer68Max, 0x0206 as KK],
      [VirtualMer68SE_JT, 0x0206 as KK],
      [VirtualND63Ultra, 0x0206 as KK],
      [VirtualMars75, 0x0206 as KK],
      [VirtualMars75Pro, 0x0206 as KK], // 新增
      [VirtualIrokFe87V2, 0x26 as KK],
      [VirtualIrokFe87V2_24g, 0x26 as KK],
      [VirtualIrokFe87V2IMC, 0x26 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x26 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x59 as VK,
    HID: 0x1c as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'Z',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1d as KK],
      [VirtualFE87V2_MuYan, 0x1d as KK],
      [VirtualPolar75, 0x1d as KK],
      [VirtualMg75, 0x1d as KK],

      [VirtualMg75Pro, 0x1d as KK],
      [VirtualMer68, 0x1d as KK],
      [VirtualMer68Pro, 0x1d as KK],
      [VirtualMer68SE, 0x10 as KK],
      [VirtualMer68Lite, 0x10 as KK],

      [VirtualMu68Pro, 0x1d as KK],
      [VirtualMars68ProWireless, 0x10 as KK],
      [VirtualMars68ProWireless_24g, 0x10 as KK],
      [VirtualMars68, 0x10 as KK],
      [VirtualMg68Lite, 0x10 as KK],
      [VirtualMg68Max, 0x10 as KK],
      [VirtualMg68Max_24g, 0x10 as KK],
      [VirtualMg68Pro, 0x10 as KK],
      [VirtualMg68SE, 0x10 as KK],
      [VirtualMg68, 0x10 as KK],
      [VirtualND63Max, 0x10 as KK],
      [VirtualND68, 0x10 as KK],
      [VirtualMG68ACE_W, 0x10 as KK],
      [VirtualMG68ACE_W_24g, 0x10 as KK],
      [VirtualMG68ACE, 0x10 as KK],
      [VirtualMG68ACE_UpPlus, 0x10 as KK],
      [VirtualMars68Wireless_24g, 0x10 as KK],
      [VirtualMars68Wireless, 0x10 as KK],
      [VirtualMars68Pro, 0x10 as KK],
      [VirtualMars68SE, 0x10 as KK],
      [VirtualMu68Pro_Cyan, 0x1d as KK],
      [VirtualMu68_ULTRA, 0x1d as KK],
      [VirtualNd63, 0x1d as KK],
      [VirtualMG63, 0x1d as KK],
      [VirtualRA68_1, 0x1d as KK],
      [VirtualMG75V2C12, 0x1d as KK],
      [VirtualNd63_Cyan, 0x1d as KK],
      [VirtualMg68Plus, 0x0402 as KK], // 新增
      [VirtualMg75Max, 0x0402 as KK],
      [VirtualND68Pro, 0x0402 as KK],
      [VirtualRA68, 0x0402 as KK],
      [VirtualMer68Max, 0x0402 as KK],
      [VirtualMer68SE_JT, 0x0402 as KK],
      [VirtualND63Ultra, 0x0402 as KK],
      [VirtualMars75, 0x0402 as KK],
      [VirtualMars75Pro, 0x0402 as KK], // 新增
      [VirtualIrokFe87V2, 0x41 as KK],
      [VirtualIrokFe87V2_24g, 0x41 as KK],
      [VirtualIrokFe87V2IMC, 0x41 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x41 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x5a as VK,
    HID: 0x1d as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '0',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x27 as KK],
      [VirtualFE87V2_MuYan, 0x27 as KK],
      [VirtualPolar75, 0x27 as KK],
      [VirtualMg75, 0x27 as KK],

      [VirtualMg75Pro, 0x27 as KK],
      [VirtualMer68, 0x27 as KK],
      [VirtualMer68Pro, 0x27 as KK],
      [VirtualMer68SE, 0x3d as KK],
      [VirtualMer68Lite, 0x3d as KK],

      [VirtualMu68Pro, 0x27 as KK],
      [VirtualMars68ProWireless, 0x3d as KK],
      [VirtualMars68ProWireless_24g, 0x3d as KK],
      [VirtualMars68, 0x3d as KK],
      [VirtualMg68Lite, 0x3d as KK],
      [VirtualMg68Max, 0x3d as KK],
      [VirtualMg68Max_24g, 0x3d as KK],
      [VirtualMg68Pro, 0x3d as KK],
      [VirtualMg68SE, 0x3d as KK],
      [VirtualMg68, 0x3d as KK],
      [VirtualND63Max, 0x3d as KK],
      [VirtualND68, 0x3d as KK],
      [VirtualMG68ACE_W, 0x3d as KK],
      [VirtualMG68ACE_W_24g, 0x3d as KK],
      [VirtualMG68ACE, 0x3d as KK],
      [VirtualMG68ACE_UpPlus, 0x3d as KK],
      [VirtualMars68Wireless_24g, 0x3d as KK],
      [VirtualMars68Wireless, 0x3d as KK],
      [VirtualMars68Pro, 0x3d as KK],
      [VirtualMars68SE, 0x3d as KK],
      [VirtualMu68Pro_Cyan, 0x27 as KK],
      [VirtualMu68_ULTRA, 0x27 as KK],
      [VirtualNd63, 0x27 as KK],
      [VirtualMG63, 0x27 as KK],
      [VirtualRA68_1, 0x27 as KK],
      [VirtualMG75V2C12, 0x27 as KK],
      [VirtualNd63_Cyan, 0x27 as KK],
      [VirtualMg68Plus, 0x010a as KK], // 新增
      [VirtualMg75Max, 0x010a as KK],
      [VirtualND68Pro, 0x010a as KK],
      [VirtualRA68, 0x010a as KK],
      [VirtualMer68Max, 0x010a as KK],
      [VirtualMer68SE_JT, 0x010a as KK],
      [VirtualND63Ultra, 0x010a as KK],
      [VirtualMars75, 0x010a as KK],
      [VirtualMars75Pro, 0x010a as KK], // 新增
      [VirtualIrokFe87V2, 0x1a as KK],
      [VirtualIrokFe87V2_24g, 0x1a as KK],
      [VirtualIrokFe87V2IMC, 0x1a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x30 as VK,
    HID: 0x27 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '1',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1e as KK],
      [VirtualFE87V2_MuYan, 0x1e as KK],
      [VirtualPolar75, 0x1e as KK],
      [VirtualMg75, 0x1e as KK],

      [VirtualMg75Pro, 0x1e as KK],
      [VirtualMer68, 0x1e as KK],
      [VirtualMer68Pro, 0x1e as KK],
      [VirtualMer68SE, 0x07 as KK],
      [VirtualMer68Lite, 0x07 as KK],

      [VirtualMu68Pro, 0x1e as KK],
      [VirtualMars68ProWireless, 0x07 as KK],
      [VirtualMars68ProWireless_24g, 0x07 as KK],
      [VirtualMars68, 0x07 as KK],
      [VirtualMg68Lite, 0x07 as KK],
      [VirtualMg68Max, 0x07 as KK],
      [VirtualMg68Max_24g, 0x07 as KK],
      [VirtualMg68Pro, 0x07 as KK],
      [VirtualMg68SE, 0x07 as KK],
      [VirtualMg68, 0x07 as KK],
      [VirtualND63Max, 0x07 as KK],
      [VirtualND68, 0x07 as KK],
      [VirtualMG68ACE_W, 0x07 as KK],
      [VirtualMG68ACE_W_24g, 0x07 as KK],
      [VirtualMG68ACE, 0x07 as KK],
      [VirtualMG68ACE_UpPlus, 0x07 as KK],
      [VirtualMars68Wireless_24g, 0x07 as KK],
      [VirtualMars68Wireless, 0x07 as KK],
      [VirtualMars68Pro, 0x07 as KK],
      [VirtualMars68SE, 0x07 as KK],
      [VirtualMu68Pro_Cyan, 0x1e as KK],
      [VirtualMu68_ULTRA, 0x1e as KK],
      [VirtualNd63, 0x1e as KK],
      [VirtualMG63, 0x1e as KK],
      [VirtualRA68_1, 0x1e as KK],
      [VirtualMG75V2C12, 0x1e as KK],
      [VirtualNd63_Cyan, 0x1e as KK],
      [VirtualMg68Plus, 0x0101 as KK], // 新增
      [VirtualMg75Max, 0x0101 as KK],
      [VirtualND68Pro, 0x0101 as KK],
      [VirtualRA68, 0x0101 as KK],
      [VirtualMer68Max, 0x0101 as KK],
      [VirtualMer68SE_JT, 0x0101 as KK],
      [VirtualND63Ultra, 0x0101 as KK],
      [VirtualMars75, 0x0101 as KK],
      [VirtualMars75Pro, 0x0101 as KK], // 新增
      [VirtualIrokFe87V2, 0x11 as KK],
      [VirtualIrokFe87V2_24g, 0x11 as KK],
      [VirtualIrokFe87V2IMC, 0x11 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x11 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x31 as VK,
    HID: 0x1e as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '2',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x1f as KK],
      [VirtualFE87V2_MuYan, 0x1f as KK],
      [VirtualPolar75, 0x1f as KK],
      [VirtualMg75, 0x1f as KK],

      [VirtualMg75Pro, 0x1f as KK],
      [VirtualMer68, 0x1f as KK],
      [VirtualMer68Pro, 0x1f as KK],
      [VirtualMer68SE, 0x0d as KK],
      [VirtualMer68Lite, 0x0d as KK],

      [VirtualMu68Pro, 0x1f as KK],
      [VirtualMars68ProWireless, 0x0d as KK],
      [VirtualMars68ProWireless_24g, 0x0d as KK],
      [VirtualMars68, 0x0d as KK],
      [VirtualMg68Lite, 0x0d as KK],
      [VirtualMg68Max, 0x0d as KK],
      [VirtualMg68Max_24g, 0x0d as KK],
      [VirtualMg68Pro, 0x0d as KK],
      [VirtualMg68SE, 0x0d as KK],
      [VirtualMg68, 0x0d as KK],
      [VirtualND63Max, 0x0d as KK],
      [VirtualND68, 0x0d as KK],
      [VirtualMG68ACE_W, 0x0d as KK],
      [VirtualMG68ACE_W_24g, 0x0d as KK],
      [VirtualMG68ACE, 0x0d as KK],
      [VirtualMG68ACE_UpPlus, 0x0d as KK],
      [VirtualMars68Wireless_24g, 0x0d as KK],
      [VirtualMars68Wireless, 0x0d as KK],
      [VirtualMars68Pro, 0x0d as KK],
      [VirtualMars68SE, 0x0d as KK],
      [VirtualMu68Pro_Cyan, 0x1f as KK],
      [VirtualMu68_ULTRA, 0x1f as KK],
      [VirtualNd63, 0x1f as KK],
      [VirtualMG63, 0x1f as KK],
      [VirtualRA68_1, 0x1f as KK],
      [VirtualMG75V2C12, 0x1f as KK],
      [VirtualNd63_Cyan, 0x1f as KK],
      [VirtualMg68Plus, 0x0102 as KK], // 新增
      [VirtualMg75Max, 0x0102 as KK],
      [VirtualND68Pro, 0x0102 as KK],
      [VirtualRA68, 0x0102 as KK],
      [VirtualMer68Max, 0x0102 as KK],
      [VirtualMer68SE_JT, 0x0102 as KK],
      [VirtualND63Ultra, 0x0102 as KK],
      [VirtualMars75, 0x0102 as KK],
      [VirtualMars75Pro, 0x0102 as KK], // 新增
      [VirtualIrokFe87V2, 0x12 as KK],
      [VirtualIrokFe87V2_24g, 0x12 as KK],
      [VirtualIrokFe87V2IMC, 0x12 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x12 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x32 as VK,
    HID: 0x1f as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '3',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x20 as KK],
      [VirtualFE87V2_MuYan, 0x20 as KK],
      [VirtualPolar75, 0x20 as KK],
      [VirtualMg75, 0x20 as KK],

      [VirtualMg75Pro, 0x20 as KK],
      [VirtualMer68, 0x20 as KK],
      [VirtualMer68Pro, 0x20 as KK],
      [VirtualMer68SE, 0x13 as KK],
      [VirtualMer68Lite, 0x13 as KK],

      [VirtualMu68Pro, 0x20 as KK],
      [VirtualMars68ProWireless, 0x13 as KK],
      [VirtualMars68ProWireless_24g, 0x13 as KK],
      [VirtualMars68, 0x13 as KK],
      [VirtualMg68Lite, 0x13 as KK],
      [VirtualMg68Max, 0x13 as KK],
      [VirtualMg68Max_24g, 0x13 as KK],
      [VirtualMg68Pro, 0x13 as KK],
      [VirtualMg68SE, 0x13 as KK],
      [VirtualMg68, 0x13 as KK],
      [VirtualND63Max, 0x13 as KK],
      [VirtualND68, 0x13 as KK],
      [VirtualMG68ACE_W, 0x13 as KK],
      [VirtualMG68ACE_W_24g, 0x13 as KK],
      [VirtualMG68ACE, 0x13 as KK],
      [VirtualMG68ACE_UpPlus, 0x13 as KK],
      [VirtualMars68Wireless_24g, 0x13 as KK],
      [VirtualMars68Wireless, 0x13 as KK],
      [VirtualMars68Pro, 0x13 as KK],
      [VirtualMars68SE, 0x13 as KK],
      [VirtualMu68Pro_Cyan, 0x20 as KK],
      [VirtualMu68_ULTRA, 0x20 as KK],
      [VirtualNd63, 0x20 as KK],
      [VirtualMG63, 0x20 as KK],
      [VirtualRA68_1, 0x20 as KK],
      [VirtualMG75V2C12, 0x20 as KK],
      [VirtualNd63_Cyan, 0x20 as KK],
      [VirtualMg68Plus, 0x0103 as KK], // 新增
      [VirtualMg75Max, 0x0103 as KK],
      [VirtualND68Pro, 0x0103 as KK],
      [VirtualRA68, 0x0103 as KK],
      [VirtualMer68Max, 0x0103 as KK],
      [VirtualMer68SE_JT, 0x0103 as KK],
      [VirtualND63Ultra, 0x0103 as KK],
      [VirtualMars75, 0x0103 as KK],
      [VirtualMars75Pro, 0x0103 as KK], // 新增
      [VirtualIrokFe87V2, 0x13 as KK],
      [VirtualIrokFe87V2_24g, 0x13 as KK],
      [VirtualIrokFe87V2IMC, 0x13 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x13 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x33 as VK,
    HID: 0x20 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '4',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x21 as KK],
      [VirtualFE87V2_MuYan, 0x21 as KK],
      [VirtualPolar75, 0x21 as KK],
      [VirtualMg75, 0x21 as KK],

      [VirtualMg75Pro, 0x21 as KK],
      [VirtualMer68, 0x21 as KK],
      [VirtualMer68Pro, 0x21 as KK],
      [VirtualMer68SE, 0x19 as KK],
      [VirtualMer68Lite, 0x19 as KK],

      [VirtualMu68Pro, 0x21 as KK],
      [VirtualMars68ProWireless, 0x19 as KK],
      [VirtualMars68ProWireless_24g, 0x19 as KK],
      [VirtualMars68, 0x19 as KK],
      [VirtualMg68Lite, 0x19 as KK],
      [VirtualMg68Max, 0x19 as KK],
      [VirtualMg68Max_24g, 0x19 as KK],
      [VirtualMg68Pro, 0x19 as KK],
      [VirtualMg68SE, 0x19 as KK],
      [VirtualMg68, 0x19 as KK],
      [VirtualND63Max, 0x19 as KK],
      [VirtualND68, 0x19 as KK],
      [VirtualMG68ACE_W, 0x19 as KK],
      [VirtualMG68ACE_W_24g, 0x19 as KK],
      [VirtualMG68ACE, 0x19 as KK],
      [VirtualMG68ACE_UpPlus, 0x19 as KK],
      [VirtualMars68Wireless_24g, 0x19 as KK],
      [VirtualMars68Wireless, 0x19 as KK],
      [VirtualMars68Pro, 0x19 as KK],
      [VirtualMars68SE, 0x19 as KK],
      [VirtualMu68Pro_Cyan, 0x21 as KK],
      [VirtualMu68_ULTRA, 0x21 as KK],
      [VirtualNd63, 0x21 as KK],
      [VirtualMG63, 0x21 as KK],
      [VirtualRA68_1, 0x21 as KK],
      [VirtualMG75V2C12, 0x21 as KK],
      [VirtualNd63_Cyan, 0x21 as KK],
      [VirtualMg68Plus, 0x0104 as KK], // 新增
      [VirtualMg75Max, 0x0104 as KK],
      [VirtualND68Pro, 0x0104 as KK],
      [VirtualRA68, 0x0104 as KK],
      [VirtualMer68Max, 0x0104 as KK],
      [VirtualMer68SE_JT, 0x0104 as KK],
      [VirtualND63Ultra, 0x0104 as KK],
      [VirtualMars75, 0x0104 as KK],
      [VirtualMars75Pro, 0x0104 as KK], // 新增
      [VirtualIrokFe87V2, 0x14 as KK],
      [VirtualIrokFe87V2_24g, 0x14 as KK],
      [VirtualIrokFe87V2IMC, 0x14 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x14 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x34 as VK,
    HID: 0x21 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '5',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x22 as KK],
      [VirtualFE87V2_MuYan, 0x22 as KK],
      [VirtualPolar75, 0x22 as KK],
      [VirtualMg75, 0x22 as KK],

      [VirtualMg75Pro, 0x22 as KK],
      [VirtualMer68, 0x22 as KK],
      [VirtualMer68Pro, 0x22 as KK],
      [VirtualMer68SE, 0x1f as KK],
      [VirtualMer68Lite, 0x1f as KK],

      [VirtualMu68Pro, 0x22 as KK],
      [VirtualMars68ProWireless, 0x1f as KK],
      [VirtualMars68ProWireless_24g, 0x1f as KK],
      [VirtualMars68, 0x1f as KK],
      [VirtualMg68Lite, 0x1f as KK],
      [VirtualMg68Max, 0x1f as KK],
      [VirtualMg68Max_24g, 0x1f as KK],
      [VirtualMg68Pro, 0x1f as KK],
      [VirtualMg68SE, 0x1f as KK],
      [VirtualMg68, 0x1f as KK],
      [VirtualND63Max, 0x1f as KK],
      [VirtualND68, 0x1f as KK],
      [VirtualMG68ACE_W, 0x1f as KK],
      [VirtualMG68ACE_W_24g, 0x1f as KK],
      [VirtualMG68ACE, 0x1f as KK],
      [VirtualMG68ACE_UpPlus, 0x1f as KK],
      [VirtualMars68Wireless_24g, 0x1f as KK],
      [VirtualMars68Wireless, 0x1f as KK],
      [VirtualMars68Pro, 0x1f as KK],
      [VirtualMars68SE, 0x1f as KK],
      [VirtualMu68Pro_Cyan, 0x22 as KK],
      [VirtualMu68_ULTRA, 0x22 as KK],
      [VirtualNd63, 0x22 as KK],
      [VirtualMG63, 0x22 as KK],
      [VirtualRA68_1, 0x22 as KK],
      [VirtualMG75V2C12, 0x22 as KK],
      [VirtualNd63_Cyan, 0x22 as KK],
      [VirtualMg68Plus, 0x0105 as KK], // 新增
      [VirtualMg75Max, 0x0105 as KK],
      [VirtualND68Pro, 0x0105 as KK],
      [VirtualRA68, 0x0105 as KK],
      [VirtualMer68Max, 0x0105 as KK],
      [VirtualMer68SE_JT, 0x0105 as KK],
      [VirtualND63Ultra, 0x0105 as KK],
      [VirtualMars75, 0x0105 as KK],
      [VirtualMars75Pro, 0x0105 as KK], // 新增
      [VirtualIrokFe87V2, 0x15 as KK],
      [VirtualIrokFe87V2_24g, 0x15 as KK],
      [VirtualIrokFe87V2IMC, 0x15 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x15 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x35 as VK,
    HID: 0x22 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '6',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x23 as KK],
      [VirtualFE87V2_MuYan, 0x23 as KK],
      [VirtualPolar75, 0x23 as KK],
      [VirtualMg75, 0x23 as KK],

      [VirtualMg75Pro, 0x23 as KK],
      [VirtualMer68, 0x23 as KK],
      [VirtualMer68Pro, 0x23 as KK],
      [VirtualMer68SE, 0x25 as KK],
      [VirtualMer68Lite, 0x25 as KK],

      [VirtualMu68Pro, 0x23 as KK],
      [VirtualMars68ProWireless, 0x25 as KK],
      [VirtualMars68ProWireless_24g, 0x25 as KK],
      [VirtualMars68, 0x25 as KK],
      [VirtualMg68Lite, 0x25 as KK],
      [VirtualMg68Max, 0x25 as KK],
      [VirtualMg68Max_24g, 0x25 as KK],
      [VirtualMg68Pro, 0x25 as KK],
      [VirtualMg68SE, 0x25 as KK],
      [VirtualMg68, 0x25 as KK],
      [VirtualND63Max, 0x25 as KK],
      [VirtualND68, 0x25 as KK],
      [VirtualMG68ACE_W, 0x25 as KK],
      [VirtualMG68ACE_W_24g, 0x25 as KK],
      [VirtualMG68ACE, 0x25 as KK],
      [VirtualMG68ACE_UpPlus, 0x25 as KK],
      [VirtualMars68Wireless_24g, 0x25 as KK],
      [VirtualMars68Wireless, 0x25 as KK],
      [VirtualMars68Pro, 0x25 as KK],
      [VirtualMars68SE, 0x25 as KK],
      [VirtualMu68Pro_Cyan, 0x23 as KK],
      [VirtualMu68_ULTRA, 0x23 as KK],
      [VirtualNd63, 0x23 as KK],
      [VirtualMG63, 0x23 as KK],
      [VirtualRA68_1, 0x23 as KK],
      [VirtualMG75V2C12, 0x23 as KK],
      [VirtualNd63_Cyan, 0x23 as KK],
      [VirtualMg68Plus, 0x0106 as KK], // 新增
      [VirtualMg75Max, 0x0106 as KK],
      [VirtualND68Pro, 0x0106 as KK],
      [VirtualRA68, 0x0106 as KK],
      [VirtualMer68Max, 0x0106 as KK],
      [VirtualMer68SE_JT, 0x0106 as KK],
      [VirtualND63Ultra, 0x0106 as KK],
      [VirtualMars75, 0x0106 as KK],
      [VirtualMars75Pro, 0x0106 as KK], // 新增
      [VirtualIrokFe87V2, 0x16 as KK],
      [VirtualIrokFe87V2_24g, 0x16 as KK],
      [VirtualIrokFe87V2IMC, 0x16 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x16 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x36 as VK,
    HID: 0x23 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '7',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x24 as KK],
      [VirtualFE87V2_MuYan, 0x24 as KK],
      [VirtualPolar75, 0x24 as KK],
      [VirtualMg75, 0x24 as KK],

      [VirtualMg75Pro, 0x24 as KK],
      [VirtualMer68, 0x24 as KK],
      [VirtualMer68Pro, 0x24 as KK],
      [VirtualMer68SE, 0x2b as KK],
      [VirtualMer68Lite, 0x2b as KK],

      [VirtualMu68Pro, 0x24 as KK],
      [VirtualMars68ProWireless, 0x2b as KK],
      [VirtualMars68ProWireless_24g, 0x2b as KK],
      [VirtualMars68, 0x2b as KK],
      [VirtualMg68Lite, 0x2b as KK],
      [VirtualMg68Max, 0x2b as KK],
      [VirtualMg68Max_24g, 0x2b as KK],
      [VirtualMg68Pro, 0x2b as KK],
      [VirtualMg68SE, 0x2b as KK],
      [VirtualMg68, 0x2b as KK],
      [VirtualND63Max, 0x2b as KK],
      [VirtualND68, 0x2b as KK],
      [VirtualMG68ACE_W, 0x2b as KK],
      [VirtualMG68ACE_W_24g, 0x2b as KK],
      [VirtualMG68ACE, 0x2b as KK],
      [VirtualMG68ACE_UpPlus, 0x2b as KK],
      [VirtualMars68Wireless_24g, 0x2b as KK],
      [VirtualMars68Wireless, 0x2b as KK],
      [VirtualMars68Pro, 0x2b as KK],
      [VirtualMars68SE, 0x2b as KK],
      [VirtualMu68Pro_Cyan, 0x24 as KK],
      [VirtualMu68_ULTRA, 0x24 as KK],
      [VirtualNd63, 0x24 as KK],
      [VirtualMG63, 0x24 as KK],
      [VirtualRA68_1, 0x24 as KK],
      [VirtualMG75V2C12, 0x24 as KK],
      [VirtualNd63_Cyan, 0x24 as KK],
      [VirtualMg68Plus, 0x0107 as KK], // 新增
      [VirtualMg75Max, 0x0107 as KK],
      [VirtualND68Pro, 0x0107 as KK],
      [VirtualRA68, 0x0107 as KK],
      [VirtualMer68Max, 0x0107 as KK],
      [VirtualMer68SE_JT, 0x0107 as KK],
      [VirtualND63Ultra, 0x0107 as KK],
      [VirtualMars75, 0x0107 as KK],
      [VirtualMars75Pro, 0x0107 as KK], // 新增
      [VirtualIrokFe87V2, 0x17 as KK],
      [VirtualIrokFe87V2_24g, 0x17 as KK],
      [VirtualIrokFe87V2IMC, 0x17 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x17 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x37 as VK,
    HID: 0x24 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '8',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x25 as KK],
      [VirtualFE87V2_MuYan, 0x25 as KK],
      [VirtualPolar75, 0x25 as KK],
      [VirtualMg75, 0x25 as KK],

      [VirtualMg75Pro, 0x25 as KK],
      [VirtualMer68, 0x25 as KK],
      [VirtualMer68Pro, 0x25 as KK],
      [VirtualMer68SE, 0x31 as KK],
      [VirtualMer68Lite, 0x31 as KK],

      [VirtualMu68Pro, 0x25 as KK],
      [VirtualMars68ProWireless, 0x31 as KK],
      [VirtualMars68ProWireless_24g, 0x31 as KK],
      [VirtualMars68, 0x31 as KK],
      [VirtualMg68Lite, 0x31 as KK],
      [VirtualMg68Max, 0x31 as KK],
      [VirtualMg68Max_24g, 0x31 as KK],
      [VirtualMg68Pro, 0x31 as KK],
      [VirtualMg68SE, 0x31 as KK],
      [VirtualMg68, 0x31 as KK],
      [VirtualND63Max, 0x31 as KK],
      [VirtualND68, 0x31 as KK],
      [VirtualMG68ACE_W, 0x31 as KK],
      [VirtualMG68ACE_W_24g, 0x31 as KK],
      [VirtualMG68ACE, 0x31 as KK],
      [VirtualMG68ACE_UpPlus, 0x31 as KK],
      [VirtualMars68Wireless_24g, 0x31 as KK],
      [VirtualMars68Wireless, 0x31 as KK],
      [VirtualMars68Pro, 0x31 as KK],
      [VirtualMars68SE, 0x31 as KK],
      [VirtualMu68Pro_Cyan, 0x25 as KK],
      [VirtualMu68_ULTRA, 0x25 as KK],
      [VirtualNd63, 0x25 as KK],
      [VirtualMG63, 0x25 as KK],
      [VirtualRA68_1, 0x25 as KK],
      [VirtualMG75V2C12, 0x25 as KK],
      [VirtualNd63_Cyan, 0x25 as KK],
      [VirtualMg68Plus, 0x0108 as KK], // 新增
      [VirtualMg75Max, 0x0108 as KK],
      [VirtualND68Pro, 0x0108 as KK],
      [VirtualRA68, 0x0108 as KK],
      [VirtualMer68Max, 0x0108 as KK],
      [VirtualMer68SE_JT, 0x0108 as KK],
      [VirtualND63Ultra, 0x0108 as KK],
      [VirtualMars75, 0x0108 as KK],
      [VirtualMars75Pro, 0x0108 as KK], // 新增
      [VirtualIrokFe87V2, 0x18 as KK],
      [VirtualIrokFe87V2_24g, 0x18 as KK],
      [VirtualIrokFe87V2IMC, 0x18 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x18 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x38 as VK,
    HID: 0x25 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '9',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x26 as KK],
      [VirtualFE87V2_MuYan, 0x26 as KK],
      [VirtualPolar75, 0x26 as KK],
      [VirtualMg75, 0x26 as KK],

      [VirtualMg75Pro, 0x26 as KK],
      [VirtualMer68, 0x26 as KK],
      [VirtualMer68Pro, 0x26 as KK],
      [VirtualMer68SE, 0x37 as KK],
      [VirtualMer68Lite, 0x37 as KK],

      [VirtualMu68Pro, 0x26 as KK],
      [VirtualMars68ProWireless, 0x37 as KK],
      [VirtualMars68ProWireless_24g, 0x37 as KK],
      [VirtualMars68, 0x37 as KK],
      [VirtualMg68Lite, 0x37 as KK],
      [VirtualMg68Max, 0x37 as KK],
      [VirtualMg68Max_24g, 0x37 as KK],
      [VirtualMg68Pro, 0x37 as KK],
      [VirtualMg68SE, 0x37 as KK],
      [VirtualMg68, 0x37 as KK],
      [VirtualND63Max, 0x37 as KK],
      [VirtualND68, 0x37 as KK],
      [VirtualMG68ACE_W, 0x37 as KK],
      [VirtualMG68ACE_W_24g, 0x37 as KK],
      [VirtualMG68ACE, 0x37 as KK],
      [VirtualMG68ACE_UpPlus, 0x37 as KK],
      [VirtualMars68Wireless_24g, 0x37 as KK],
      [VirtualMars68Wireless, 0x37 as KK],
      [VirtualMars68Pro, 0x37 as KK],
      [VirtualMars68SE, 0x37 as KK],
      [VirtualMu68Pro_Cyan, 0x26 as KK],
      [VirtualMu68_ULTRA, 0x26 as KK],
      [VirtualNd63, 0x26 as KK],
      [VirtualMG63, 0x26 as KK],
      [VirtualRA68_1, 0x26 as KK],
      [VirtualMG75V2C12, 0x26 as KK],
      [VirtualNd63_Cyan, 0x26 as KK],
      [VirtualMg68Plus, 0x0109 as KK], // 新增
      [VirtualMg75Max, 0x0109 as KK],
      [VirtualND68Pro, 0x0109 as KK],
      [VirtualRA68, 0x0109 as KK],
      [VirtualMer68Max, 0x0109 as KK],
      [VirtualMer68SE_JT, 0x0109 as KK],
      [VirtualND63Ultra, 0x0109 as KK],
      [VirtualMars75, 0x0109 as KK],
      [VirtualMars75Pro, 0x0109 as KK], // 新增
      [VirtualIrokFe87V2, 0x19 as KK],
      [VirtualIrokFe87V2_24g, 0x19 as KK],
      [VirtualIrokFe87V2IMC, 0x19 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x19 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x39 as VK,
    HID: 0x26 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'LWIN',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe3 as KK],
      [VirtualFE87V2_MuYan, 0xe3 as KK],
      [VirtualPolar75, 0xe3 as KK],
      [VirtualMg75, 0xe3 as KK],

      [VirtualMg75Pro, 0xe3 as KK],
      [VirtualMer68, 0xe3 as KK],
      [VirtualMer68Pro, 0xe3 as KK],
      [VirtualMer68SE, 0x0b as KK],
      [VirtualMer68Lite, 0x0b as KK],

      [VirtualMu68Pro, 0xe3 as KK],
      [VirtualMars68ProWireless, 0x0b as KK],
      [VirtualMars68ProWireless_24g, 0x0b as KK],
      [VirtualMars68, 0x0b as KK],

      [VirtualMg68Lite, 0x11 as KK],
      [VirtualMg68Max, 0x11 as KK],
      [VirtualMg68Max_24g, 0x11 as KK],
      [VirtualMg68Pro, 0x11 as KK],
      [VirtualMg68SE, 0x11 as KK],
      [VirtualMg68, 0x11 as KK],
      [VirtualND63Max, 0x0b as KK],
      [VirtualND68, 0x0b as KK],
      [VirtualMG68ACE_W, 0x0b as KK],
      [VirtualMG68ACE_W_24g, 0x0b as KK],
      [VirtualMG68ACE, 0x0b as KK],
      [VirtualMG68ACE_UpPlus, 0x0b as KK],

      [VirtualMars68Wireless_24g, 0x0b as KK],
      [VirtualMars68Wireless, 0x0b as KK],
      [VirtualMars68Pro, 0x0b as KK],
      [VirtualMars68SE, 0x0b as KK],
      [VirtualMu68Pro_Cyan, 0xe3 as KK],
      [VirtualMu68_ULTRA, 0xe3 as KK],
      [VirtualNd63, 0xe3 as KK],
      [VirtualMG63, 0xe3 as KK],
      [VirtualRA68_1, 0xe3 as KK],
      [VirtualMG75V2C12, 0xe3 as KK],
      [VirtualNd63_Cyan, 0xe3 as KK],
      [VirtualMg68Plus, 0x0501 as KK], // 新增
      [VirtualMg75Max, 0x0501 as KK],
      [VirtualND68Pro, 0x0501 as KK],
      [VirtualRA68, 0x0501 as KK],
      [VirtualMer68Max, 0x0501 as KK],
      [VirtualMer68SE_JT, 0x0501 as KK],
      [VirtualND63Ultra, 0x0501 as KK],
      [VirtualMars75, 0x0501 as KK],
      [VirtualMars75Pro, 0x0501 as KK], // 新增
      [VirtualIrokFe87V2, 0x51 as KK],
      [VirtualIrokFe87V2_24g, 0x51 as KK],
      [VirtualIrokFe87V2IMC, 0x51 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x51 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x08 as DVK],
      [VirtualHE3SEWireless, 0x08 as DVK],
      [VirtualHe6Ultra, 0x08 as DVK],
    ]),
    VirtualKey: 0x5b as VK,
    HID: 0xe3 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'APP',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x65 as KK],
      [VirtualFE87V2_MuYan, 0x65 as KK],
      [VirtualIrokFe87V2, 0x56 as KK],
      [VirtualIrokFe87V2_24g, 0x56 as KK],
      [VirtualIrokFe87V2IMC, 0x56 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x56 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x5d as VK,
    HID: 0x65 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F1',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3a as KK],
      [VirtualFE87V2_MuYan, 0x3a as KK],
      [VirtualPolar75, 0x3a as KK],
      [VirtualMg75, 0x3a as KK],

      [VirtualMG75V2C12, 0x3a as KK],
      [VirtualMg75Pro, 0x3a as KK],
      [VirtualMg75Max, 0x0001 as KK],
      [VirtualMars75, 0x0001 as KK],
      [VirtualMars75Pro, 0x0001 as KK],
      [VirtualIrokFe87V2, 0x01 as KK],
      [VirtualIrokFe87V2_24g, 0x01 as KK],
      [VirtualIrokFe87V2IMC, 0x01 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x01 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x70 as VK,
    HID: 0x3a as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F2',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3b as KK],
      [VirtualFE87V2_MuYan, 0x3b as KK],
      [VirtualPolar75, 0x3b as KK],
      [VirtualMg75, 0x3b as KK],

      [VirtualMG75V2C12, 0x3b as KK],
      [VirtualMg75Pro, 0x3b as KK],
      [VirtualMg75Max, 0x0002 as KK],
      [VirtualMars75, 0x0002 as KK],
      [VirtualMars75Pro, 0x0002 as KK],
      [VirtualIrokFe87V2, 0x02 as KK],
      [VirtualIrokFe87V2_24g, 0x02 as KK],
      [VirtualIrokFe87V2IMC, 0x02 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x02 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x71 as VK,
    HID: 0x3b as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F3',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3c as KK],
      [VirtualFE87V2_MuYan, 0x3c as KK],
      [VirtualPolar75, 0x3c as KK],
      [VirtualMg75, 0x3c as KK],

      [VirtualMG75V2C12, 0x3c as KK],
      [VirtualMg75Pro, 0x3c as KK],
      [VirtualMg75Max, 0x0003 as KK],
      [VirtualMars75, 0x0003 as KK],
      [VirtualMars75Pro, 0x0003 as KK],
      [VirtualIrokFe87V2, 0x03 as KK],
      [VirtualIrokFe87V2_24g, 0x03 as KK],
      [VirtualIrokFe87V2IMC, 0x03 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x03 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x72 as VK,
    HID: 0x3c as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F4',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3d as KK],
      [VirtualFE87V2_MuYan, 0x3d as KK],
      [VirtualPolar75, 0x3d as KK],
      [VirtualMg75, 0x3d as KK],

      [VirtualMG75V2C12, 0x3d as KK],
      [VirtualMg75Pro, 0x3d as KK],
      [VirtualMg75Max, 0x0004 as KK],
      [VirtualMars75, 0x0004 as KK],
      [VirtualMars75Pro, 0x0004 as KK],
      [VirtualIrokFe87V2, 0x04 as KK],
      [VirtualIrokFe87V2_24g, 0x04 as KK],
      [VirtualIrokFe87V2IMC, 0x04 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x04 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x73 as VK,
    HID: 0x3d as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F5',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3e as KK],
      [VirtualFE87V2_MuYan, 0x3e as KK],
      [VirtualPolar75, 0x3e as KK],
      [VirtualMg75, 0x3e as KK],

      [VirtualMG75V2C12, 0x3e as KK],
      [VirtualMg75Pro, 0x3e as KK],
      [VirtualMg75Max, 0x0005 as KK],
      [VirtualMars75, 0x0005 as KK],
      [VirtualMars75Pro, 0x0005 as KK],
      [VirtualIrokFe87V2, 0x05 as KK],
      [VirtualIrokFe87V2_24g, 0x05 as KK],
      [VirtualIrokFe87V2IMC, 0x05 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x05 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x74 as VK,
    HID: 0x3e as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F6',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x3f as KK],
      [VirtualFE87V2_MuYan, 0x3f as KK],
      [VirtualPolar75, 0x3f as KK],
      [VirtualMg75, 0x3f as KK],

      [VirtualMG75V2C12, 0x3f as KK],
      [VirtualMg75Pro, 0x3f as KK],
      [VirtualMg75Max, 0x0006 as KK],
      [VirtualMars75, 0x0006 as KK],
      [VirtualMars75Pro, 0x0006 as KK],
      [VirtualIrokFe87V2, 0x06 as KK],
      [VirtualIrokFe87V2_24g, 0x06 as KK],
      [VirtualIrokFe87V2IMC, 0x06 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x06 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x75 as VK,
    HID: 0x3f as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F7',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x40 as KK],
      [VirtualFE87V2_MuYan, 0x40 as KK],
      [VirtualPolar75, 0x40 as KK],
      [VirtualMg75, 0x40 as KK],

      [VirtualMG75V2C12, 0x40 as KK],
      [VirtualMg75Pro, 0x40 as KK],
      [VirtualMg75Max, 0x0007 as KK],
      [VirtualMars75, 0x0007 as KK],
      [VirtualMars75Pro, 0x0007 as KK],
      [VirtualIrokFe87V2, 0x07 as KK],
      [VirtualIrokFe87V2_24g, 0x07 as KK],
      [VirtualIrokFe87V2IMC, 0x07 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x07 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x76 as VK,
    HID: 0x40 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F8',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x41 as KK],
      [VirtualFE87V2_MuYan, 0x41 as KK],
      [VirtualPolar75, 0x41 as KK],
      [VirtualMg75, 0x41 as KK],

      [VirtualMG75V2C12, 0x41 as KK],
      [VirtualMg75Pro, 0x41 as KK],
      [VirtualMg75Max, 0x0008 as KK],
      [VirtualMars75, 0x0008 as KK],
      [VirtualMars75Pro, 0x0008 as KK],
      [VirtualIrokFe87V2, 0x08 as KK],
      [VirtualIrokFe87V2_24g, 0x08 as KK],
      [VirtualIrokFe87V2IMC, 0x08 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x08 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x77 as VK,
    HID: 0x41 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F9',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x42 as KK],
      [VirtualFE87V2_MuYan, 0x42 as KK],
      [VirtualPolar75, 0x42 as KK],
      [VirtualMg75, 0x42 as KK],

      [VirtualMG75V2C12, 0x42 as KK],
      [VirtualMg75Pro, 0x42 as KK],
      [VirtualMg75Max, 0x0009 as KK],
      [VirtualMars75, 0x0009 as KK],
      [VirtualMars75Pro, 0x0009 as KK],
      [VirtualIrokFe87V2, 0x09 as KK],
      [VirtualIrokFe87V2_24g, 0x09 as KK],
      [VirtualIrokFe87V2IMC, 0x09 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x09 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x78 as VK,
    HID: 0x42 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F10',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x43 as KK],
      [VirtualFE87V2_MuYan, 0x43 as KK],
      [VirtualPolar75, 0x43 as KK],
      [VirtualMg75, 0x43 as KK],

      [VirtualMG75V2C12, 0x43 as KK],
      [VirtualMg75Pro, 0x43 as KK],
      [VirtualMg75Max, 0x000a as KK],
      [VirtualMars75, 0x000a as KK],
      [VirtualMars75Pro, 0x000a as KK],
      [VirtualIrokFe87V2, 0x0a as KK],
      [VirtualIrokFe87V2_24g, 0x0a as KK],
      [VirtualIrokFe87V2IMC, 0x0a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x79 as VK,
    HID: 0x43 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F11',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x44 as KK],
      [VirtualFE87V2_MuYan, 0x44 as KK],
      [VirtualPolar75, 0x44 as KK],
      [VirtualMg75, 0x44 as KK],

      [VirtualMG75V2C12, 0x44 as KK],
      [VirtualMg75Pro, 0x44 as KK],
      [VirtualMg75Max, 0x000b as KK],
      [VirtualMars75, 0x000b as KK],
      [VirtualMars75Pro, 0x000b as KK],
      [VirtualIrokFe87V2, 0x0b as KK],
      [VirtualIrokFe87V2_24g, 0x0b as KK],
      [VirtualIrokFe87V2IMC, 0x0b as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0b as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x7a as VK,
    HID: 0x44 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'F12',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x45 as KK],
      [VirtualFE87V2_MuYan, 0x45 as KK],
      [VirtualPolar75, 0x45 as KK],
      [VirtualMg75, 0x45 as KK],

      [VirtualMG75V2C12, 0x45 as KK],
      [VirtualMg75Pro, 0x45 as KK],
      [VirtualMg75Max, 0x000c as KK],
      [VirtualMars75, 0x000c as KK],
      [VirtualMars75Pro, 0x000c as KK],
      [VirtualIrokFe87V2, 0x0c as KK],
      [VirtualIrokFe87V2_24g, 0x0c as KK],
      [VirtualIrokFe87V2IMC, 0x0c as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0c as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x7b as VK,
    HID: 0x45 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'SCRL',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x47 as KK],
      [VirtualFE87V2_MuYan, 0x47 as KK],
      [VirtualIrokFe87V2, 0x0e as KK],
      [VirtualIrokFe87V2_24g, 0x0e as KK],
      [VirtualIrokFe87V2IMC, 0x0e as KK],
      [VirtualIrokFe87V2IMC_24g, 0x0e as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x91 as VK,
    HID: 0x47 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'LSHIFT',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe1 as KK],
      [VirtualFE87V2_MuYan, 0xe1 as KK],
      [VirtualPolar75, 0xe1 as KK],
      [VirtualMg75, 0xe1 as KK],

      [VirtualMg75Pro, 0xe1 as KK],
      [VirtualMer68, 0xe1 as KK],
      [VirtualMer68Pro, 0xe1 as KK],
      [VirtualMer68SE, 0x04 as KK],
      [VirtualMer68Lite, 0x04 as KK],

      [VirtualMu68Pro, 0xe1 as KK],
      [VirtualMars68ProWireless, 0x04 as KK],
      [VirtualMars68ProWireless_24g, 0x04 as KK],
      [VirtualMars68, 0x04 as KK],
      [VirtualMg68Lite, 0x04 as KK],
      [VirtualMg68Max, 0x04 as KK],
      [VirtualMg68Max_24g, 0x04 as KK],
      [VirtualMg68Pro, 0x04 as KK],
      [VirtualMg68SE, 0x04 as KK],
      [VirtualMg68, 0x04 as KK],
      [VirtualND63Max, 0x04 as KK],
      [VirtualND68, 0x04 as KK],
      [VirtualMG68ACE_W, 0x04 as KK],
      [VirtualMG68ACE_W_24g, 0x04 as KK],
      [VirtualMG68ACE, 0x04 as KK],
      [VirtualMG68ACE_UpPlus, 0x04 as KK],
      [VirtualMars68Wireless_24g, 0x04 as KK],
      [VirtualMars68Wireless, 0x04 as KK],
      [VirtualMars68Pro, 0x04 as KK],
      [VirtualMars68SE, 0x04 as KK],
      [VirtualMu68Pro_Cyan, 0xe1 as KK],
      [VirtualMu68_ULTRA, 0xe1 as KK],
      [VirtualNd63, 0xe1 as KK],
      [VirtualMG63, 0xe1 as KK],
      [VirtualRA68_1, 0xe1 as KK],
      [VirtualMG75V2C12, 0xe1 as KK],
      [VirtualNd63_Cyan, 0xe1 as KK],
      [VirtualMg75Max, 0x0400 as KK],
      [VirtualND68Pro, 0x0400 as KK],
      [VirtualRA68, 0x0400 as KK],
      [VirtualMer68Max, 0x0400 as KK],
      [VirtualMer68SE_JT, 0x0400 as KK],
      [VirtualND63Ultra, 0x0400 as KK],
      [VirtualMars75, 0x0400 as KK],
      [VirtualMars75Pro, 0x0400 as KK],
      [VirtualMg68Plus, 0x0400 as KK],
      [VirtualIrokFe87V2, 0x40 as KK],
      [VirtualIrokFe87V2_24g, 0x40 as KK],
      [VirtualIrokFe87V2IMC, 0x40 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x40 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x02 as DVK],
      [VirtualHE3SEWireless, 0x02 as DVK],
      [VirtualHe6Ultra, 0x02 as DVK],
    ]),
    VirtualKey: 0xa0 as VK,
    HID: 0xe1 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'RSHIFT',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe5 as KK],
      [VirtualFE87V2_MuYan, 0xe5 as KK],
      [VirtualPolar75, 0xe5 as KK],
      [VirtualMg75, 0xe5 as KK],

      [VirtualMg75Pro, 0xe5 as KK],
      [VirtualMer68, 0xe5 as KK],
      [VirtualMer68Pro, 0xe5 as KK],
      [VirtualMer68SE, 0x4c as KK],
      [VirtualMer68Lite, 0x4c as KK],

      [VirtualMu68Pro, 0xe5 as KK],
      [VirtualMars68ProWireless, 0x4c as KK],
      [VirtualMars68ProWireless_24g, 0x4c as KK],
      [VirtualMars68, 0x4c as KK],
      [VirtualMg68Lite, 0x4c as KK],
      [VirtualMg68Max, 0x4c as KK],
      [VirtualMg68Max_24g, 0x4c as KK],
      [VirtualMg68Pro, 0x4c as KK],
      [VirtualMg68SE, 0x4c as KK],
      [VirtualMg68, 0x4c as KK],
      [VirtualND63Max, 0x4c as KK],
      [VirtualND68, 0x4c as KK],
      [VirtualMG68ACE_W, 0x4c as KK],
      [VirtualMG68ACE_W_24g, 0x4c as KK],
      [VirtualMG68ACE, 0x4c as KK],
      [VirtualMG68ACE_UpPlus, 0x4c as KK],
      [VirtualMars68Wireless_24g, 0x4c as KK],
      [VirtualMars68Wireless, 0x4c as KK],
      [VirtualMars68Pro, 0x4c as KK],
      [VirtualMars68SE, 0x4c as KK],
      [VirtualMu68Pro_Cyan, 0xe5 as KK],
      [VirtualMu68_ULTRA, 0xe5 as KK],
      [VirtualNd63, 0xe5 as KK],
      [VirtualMG63, 0xe5 as KK],
      [VirtualRA68_1, 0xe5 as KK],
      [VirtualMG75V2C12, 0xe5 as KK],
      [VirtualNd63_Cyan, 0xe5 as KK],
      [VirtualMg75Max, 0x040c as KK],
      [VirtualND68Pro, 0x040c as KK],
      [VirtualRA68, 0x040c as KK],
      [VirtualMer68Max, 0x040c as KK],
      [VirtualMer68SE_JT, 0x040c as KK],
      [VirtualND63Ultra, 0x040c as KK],
      [VirtualMars75, 0x040c as KK],
      [VirtualMars75Pro, 0x040c as KK],
      [VirtualMg68Plus, 0x040c as KK],
      [VirtualIrokFe87V2, 0x4b as KK],
      [VirtualIrokFe87V2_24g, 0x4b as KK],
      [VirtualIrokFe87V2IMC, 0x4b as KK],
      [VirtualIrokFe87V2IMC_24g, 0x4b as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x20 as DVK],
      [VirtualHE3SEWireless, 0x20 as DVK],
      [VirtualHe6Ultra, 0x20 as DVK],
    ]),
    VirtualKey: 0xa1 as VK,
    HID: 0xe5 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'LCTRL',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe0 as KK],
      [VirtualFE87V2_MuYan, 0xe0 as KK],
      [VirtualPolar75, 0xe0 as KK],
      [VirtualMg75, 0xe0 as KK],

      [VirtualMg75Pro, 0xe0 as KK],
      [VirtualMer68, 0xe0 as KK],
      [VirtualMer68Pro, 0xe0 as KK],
      [VirtualMer68SE, 0x05 as KK],
      [VirtualMer68Lite, 0x05 as KK],

      [VirtualMu68Pro, 0xe0 as KK],
      [VirtualMars68ProWireless, 0x05 as KK],
      [VirtualMars68ProWireless_24g, 0x05 as KK],
      [VirtualMars68, 0x05 as KK],
      [VirtualMg68Lite, 0x05 as KK],
      [VirtualMg68Max, 0x05 as KK],
      [VirtualMg68Max_24g, 0x05 as KK],
      [VirtualMg68Pro, 0x05 as KK],
      [VirtualMg68SE, 0x05 as KK],
      [VirtualMg68, 0x05 as KK],
      [VirtualND63Max, 0x05 as KK],
      [VirtualND68, 0x05 as KK],
      [VirtualMG68ACE_W, 0x05 as KK],
      [VirtualMG68ACE_W_24g, 0x05 as KK],
      [VirtualMG68ACE, 0x05 as KK],
      [VirtualMG68ACE_UpPlus, 0x05 as KK],
      [VirtualMars68Wireless_24g, 0x05 as KK],
      [VirtualMars68Wireless, 0x05 as KK],
      [VirtualMars68Pro, 0x05 as KK],
      [VirtualMars68SE, 0x05 as KK],
      [VirtualMu68Pro_Cyan, 0xe0 as KK],
      [VirtualMu68_ULTRA, 0xe0 as KK],
      [VirtualNd63, 0xe0 as KK],
      [VirtualMG63, 0xe0 as KK],
      [VirtualRA68_1, 0xe0 as KK],
      [VirtualMG75V2C12, 0xe0 as KK],
      [VirtualNd63_Cyan, 0xe0 as KK],
      [VirtualMg75Max, 0x0500 as KK],
      [VirtualND68Pro, 0x0500 as KK],
      [VirtualRA68, 0x0500 as KK],
      [VirtualMer68Max, 0x0500 as KK],
      [VirtualMer68SE_JT, 0x0500 as KK],
      [VirtualND63Ultra, 0x0500 as KK],
      [VirtualMars75, 0x0500 as KK],
      [VirtualMars75Pro, 0x0500 as KK],
      [VirtualMg68Plus, 0x0500 as KK],
      [VirtualIrokFe87V2, 0x50 as KK],
      [VirtualIrokFe87V2_24g, 0x50 as KK],
      [VirtualIrokFe87V2IMC, 0x50 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x50 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x01 as DVK],
      [VirtualHE3SEWireless, 0x01 as DVK],
      [VirtualHe6Ultra, 0x01 as DVK],
    ]),
    VirtualKey: 0xa2 as VK,
    HID: 0xe0 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'RCTRL',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe4 as KK],
      [VirtualFE87V2_MuYan, 0xe4 as KK],
      [VirtualMu68Pro, 0xe4 as KK],
      [VirtualMars68ProWireless, 0x47 as KK],
      [VirtualMars68ProWireless_24g, 0x47 as KK],
      [VirtualMars68, 0x47 as KK],
      [VirtualMg68Lite, 0x47 as KK],
      [VirtualMg68Max, 0x47 as KK],
      [VirtualMg68Max_24g, 0x47 as KK],
      [VirtualMg68Pro, 0x47 as KK],
      [VirtualMg68SE, 0x47 as KK],
      [VirtualMg68, 0x47 as KK],
      [VirtualRA68_1, 0xe4 as KK],
      [VirtualND68, 0x47 as KK],
      [VirtualMG68ACE_W, 0x47 as KK],
      [VirtualMG68ACE_W_24g, 0x47 as KK],
      [VirtualMG68ACE, 0x47 as KK],
      [VirtualMG68ACE_UpPlus, 0x47 as KK],
      [VirtualMars68Wireless_24g, 0x47 as KK],
      [VirtualMars68Wireless, 0x47 as KK],
      [VirtualMars68Pro, 0x47 as KK],
      [VirtualMars68SE, 0x47 as KK],
      [VirtualMu68Pro_Cyan, 0xe4 as KK],
      [VirtualMu68_ULTRA, 0xe4 as KK],
      [VirtualMer68, 0xe4 as KK],
      [VirtualMer68Pro, 0xe4 as KK],
      [VirtualMer68SE, 0x47 as KK],
      [VirtualMer68Lite, 0x47 as KK],
      [VirtualMg68Plus, 0x050b as KK],
      [VirtualND68Pro, 0x050b as KK],
      [VirtualRA68, 0x050b as KK],
      [VirtualMer68Max, 0x050b as KK],
      [VirtualMer68SE_JT, 0x050b as KK],
      [VirtualND63Ultra, 0x050b as KK],
      [VirtualIrokFe87V2, 0x57 as KK],
      [VirtualIrokFe87V2_24g, 0x57 as KK],
      [VirtualIrokFe87V2IMC, 0x57 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x57 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x10 as DVK],
      [VirtualHE3SEWireless, 0x10 as DVK],
      [VirtualHe6Ultra, 0x10 as DVK],
    ]),
    VirtualKey: 0xa3 as VK,
    HID: 0xe4 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'LALT',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe2 as KK],
      [VirtualFE87V2_MuYan, 0xe2 as KK],
      [VirtualPolar75, 0xe2 as KK],
      [VirtualMg75, 0xe2 as KK],

      [VirtualMg75Pro, 0xe2 as KK],
      [VirtualMer68, 0xe2 as KK],
      [VirtualMer68Pro, 0xe2 as KK],
      [VirtualMer68SE, 0x11 as KK],
      [VirtualMer68Lite, 0x11 as KK],

      [VirtualMu68Pro, 0xe2 as KK],
      [VirtualMars68ProWireless, 0x11 as KK],
      [VirtualMars68ProWireless_24g, 0x11 as KK],
      [VirtualMars68, 0x11 as KK],

      [VirtualMg68Lite, 0x17 as KK],
      [VirtualMg68Max, 0x17 as KK],
      [VirtualMg68Max_24g, 0x17 as KK],
      [VirtualMg68Pro, 0x17 as KK],
      [VirtualMg68SE, 0x17 as KK],
      [VirtualMg68, 0x17 as KK],
      [VirtualND63Max, 0x11 as KK],
      [VirtualND68, 0x11 as KK],
      [VirtualMG68ACE_W, 0x11 as KK],
      [VirtualMG68ACE_W_24g, 0x11 as KK],
      [VirtualMG68ACE, 0x11 as KK],
      [VirtualMG68ACE_UpPlus, 0x11 as KK],

      [VirtualMars68Wireless_24g, 0x11 as KK],
      [VirtualMars68Wireless, 0x11 as KK],
      [VirtualMars68Pro, 0x11 as KK],
      [VirtualMars68SE, 0x11 as KK],
      [VirtualMu68Pro_Cyan, 0xe2 as KK],
      [VirtualMu68_ULTRA, 0xe2 as KK],
      [VirtualNd63, 0xe2 as KK],
      [VirtualMG63, 0xe2 as KK],
      [VirtualRA68_1, 0xe2 as KK],
      [VirtualMG75V2C12, 0xe2 as KK],
      [VirtualNd63_Cyan, 0xe2 as KK],
      [VirtualMg75Max, 0x0502 as KK],
      [VirtualND68Pro, 0x0502 as KK],
      [VirtualRA68, 0x0502 as KK],
      [VirtualMer68Max, 0x0502 as KK],
      [VirtualMer68SE_JT, 0x0502 as KK],
      [VirtualND63Ultra, 0x0502 as KK],
      [VirtualMars75, 0x0502 as KK],
      [VirtualMars75Pro, 0x0502 as KK],
      [VirtualMg68Plus, 0x0502 as KK],
      [VirtualIrokFe87V2, 0x52 as KK],
      [VirtualIrokFe87V2_24g, 0x52 as KK],
      [VirtualIrokFe87V2IMC, 0x52 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x52 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x04 as DVK],
      [VirtualHE3SEWireless, 0x04 as DVK],
      [VirtualHe6Ultra, 0x04 as DVK],
    ]),
    VirtualKey: 0xa4 as VK,
    HID: 0xe2 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'RALT',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0xe6 as KK],
      [VirtualFE87V2_MuYan, 0xe6 as KK],
      [VirtualPolar75, 0xe6 as KK],
      [VirtualMg75, 0xe6 as KK],

      [VirtualMg75Pro, 0xe6 as KK],
      [VirtualMer68, 0xe6 as KK],
      [VirtualMer68Pro, 0xe6 as KK],
      [VirtualMer68SE, 0x3b as KK],
      [VirtualMer68Lite, 0x3b as KK],

      [VirtualMu68Pro, 0xe6 as KK],
      [VirtualMars68ProWireless, 0x3b as KK],
      [VirtualMars68ProWireless_24g, 0x3b as KK],
      [VirtualMars68, 0x3b as KK],
      [VirtualMg68Lite, 0x3b as KK],
      [VirtualMg68Max, 0x3b as KK],
      [VirtualMg68Max_24g, 0x3b as KK],
      [VirtualMg68Pro, 0x3b as KK],
      [VirtualMg68SE, 0x3b as KK],
      [VirtualMg68, 0x3b as KK],
      [VirtualND63Max, 0x3b as KK],
      [VirtualND68, 0x3b as KK],
      [VirtualMG68ACE_W, 0x3b as KK],
      [VirtualMG68ACE_W_24g, 0x3b as KK],
      [VirtualMG68ACE, 0x3b as KK],
      [VirtualMG68ACE_UpPlus, 0x3b as KK],
      [VirtualMars68Wireless_24g, 0x3b as KK],
      [VirtualMars68Wireless, 0x3b as KK],
      [VirtualMars68Pro, 0x3b as KK],
      [VirtualMars68SE, 0x3b as KK],
      [VirtualMu68Pro_Cyan, 0xe6 as KK],
      [VirtualMu68_ULTRA, 0xe6 as KK],
      [VirtualNd63, 0xe6 as KK],
      [VirtualMG63, 0xe6 as KK],
      [VirtualRA68_1, 0xe6 as KK],
      [VirtualMG75V2C12, 0xe6 as KK],
      [VirtualNd63_Cyan, 0xe6 as KK],
      [VirtualMg75Max, 0x050a as KK],
      [VirtualND68Pro, 0x0509 as KK],
      [VirtualRA68, 0x0509 as KK],
      [VirtualMer68Max, 0x0509 as KK],
      [VirtualMer68SE_JT, 0x0509 as KK],
      [VirtualND63Ultra, 0x0509 as KK],
      [VirtualMars75, 0x050a as KK],
      [VirtualMars75Pro, 0x050a as KK],
      [VirtualMg68Plus, 0x0509 as KK],
      [VirtualIrokFe87V2, 0x54 as KK],
      [VirtualIrokFe87V2_24g, 0x54 as KK],
      [VirtualIrokFe87V2IMC, 0x54 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x54 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x40 as DVK],
      [VirtualHE3SEWireless, 0x40 as DVK],
      [VirtualHe6Ultra, 0x40 as DVK],
    ]),
    VirtualKey: 0xa5 as VK,
    HID: 0xe6 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: ':;',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x33 as KK],
      [VirtualFE87V2_MuYan, 0x33 as KK],
      [VirtualPolar75, 0x33 as KK],
      [VirtualMg75, 0x33 as KK],

      [VirtualMg75Pro, 0x33 as KK],
      [VirtualMer68, 0x33 as KK],
      [VirtualMer68Pro, 0x33 as KK],
      [VirtualMer68SE, 0x3f as KK],
      [VirtualMer68Lite, 0x3f as KK],

      [VirtualMu68Pro, 0x33 as KK],
      [VirtualMars68ProWireless, 0x3f as KK],
      [VirtualMars68ProWireless_24g, 0x3f as KK],
      [VirtualMars68, 0x3f as KK],
      [VirtualMg68Lite, 0x3f as KK],
      [VirtualMg68Max, 0x3f as KK],
      [VirtualMg68Max_24g, 0x3f as KK],
      [VirtualMg68Pro, 0x3f as KK],
      [VirtualMg68SE, 0x3f as KK],
      [VirtualMg68, 0x3f as KK],
      [VirtualND63Max, 0x3f as KK],
      [VirtualND68, 0x3f as KK],
      [VirtualMG68ACE_W, 0x3f as KK],
      [VirtualMG68ACE_W_24g, 0x3f as KK],
      [VirtualMG68ACE, 0x3f as KK],
      [VirtualMG68ACE_UpPlus, 0x3f as KK],
      [VirtualMars68Wireless_24g, 0x3f as KK],
      [VirtualMars68Wireless, 0x3f as KK],
      [VirtualMars68Pro, 0x3f as KK],
      [VirtualMars68SE, 0x3f as KK],
      [VirtualMu68Pro_Cyan, 0x33 as KK],
      [VirtualMu68_ULTRA, 0x33 as KK],
      [VirtualNd63, 0x33 as KK],
      [VirtualMG63, 0x33 as KK],
      [VirtualRA68_1, 0x33 as KK],
      [VirtualMG75V2C12, 0x33 as KK],
      [VirtualNd63_Cyan, 0x33 as KK],
      [VirtualMg75Max, 0x030a as KK],
      [VirtualND68Pro, 0x030a as KK],
      [VirtualRA68, 0x030a as KK],
      [VirtualMer68Max, 0x030a as KK],
      [VirtualMer68SE_JT, 0x030a as KK],
      [VirtualND63Ultra, 0x030a as KK],
      [VirtualMars75, 0x030a as KK],
      [VirtualMars75Pro, 0x030a as KK],
      [VirtualMg68Plus, 0x030a as KK],
      [VirtualIrokFe87V2, 0x3a as KK],
      [VirtualIrokFe87V2_24g, 0x3a as KK],
      [VirtualIrokFe87V2IMC, 0x3a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x3a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xba as VK,
    HID: 0x33 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '=+',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2e as KK],
      [VirtualFE87V2_MuYan, 0x2e as KK],
      [VirtualPolar75, 0x2e as KK],
      [VirtualMg75, 0x2e as KK],

      [VirtualMg75Pro, 0x2e as KK],
      [VirtualMer68, 0x2e as KK],
      [VirtualMer68Pro, 0x2e as KK],
      [VirtualMer68SE, 0x49 as KK],
      [VirtualMer68Lite, 0x49 as KK],

      [VirtualMu68Pro, 0x2e as KK],
      [VirtualMars68ProWireless, 0x49 as KK],
      [VirtualMars68ProWireless_24g, 0x49 as KK],
      [VirtualMars68, 0x49 as KK],
      [VirtualMg68Lite, 0x49 as KK],
      [VirtualMg68Max, 0x49 as KK],
      [VirtualMg68Max_24g, 0x49 as KK],
      [VirtualMg68Pro, 0x49 as KK],
      [VirtualMg68SE, 0x49 as KK],
      [VirtualMg68, 0x49 as KK],
      [VirtualND63Max, 0x49 as KK],
      [VirtualND68, 0x49 as KK],
      [VirtualMG68ACE_W, 0x49 as KK],
      [VirtualMG68ACE_W_24g, 0x49 as KK],
      [VirtualMG68ACE, 0x49 as KK],
      [VirtualMG68ACE_UpPlus, 0x49 as KK],
      [VirtualMars68Wireless_24g, 0x49 as KK],
      [VirtualMars68Wireless, 0x49 as KK],
      [VirtualMars68Pro, 0x49 as KK],
      [VirtualMars68SE, 0x49 as KK],
      [VirtualMu68Pro_Cyan, 0x2e as KK],
      [VirtualMu68_ULTRA, 0x2e as KK],
      [VirtualNd63, 0x2e as KK],
      [VirtualMG63, 0x2e as KK],
      [VirtualRA68_1, 0x2e as KK],
      [VirtualMG75V2C12, 0x2e as KK],
      [VirtualNd63_Cyan, 0x2e as KK],
      [VirtualMg75Max, 0x010c as KK],
      [VirtualND68Pro, 0x010c as KK],
      [VirtualRA68, 0x010c as KK],
      [VirtualMer68Max, 0x010c as KK],
      [VirtualMer68SE_JT, 0x010c as KK],
      [VirtualND63Ultra, 0x010c as KK],
      [VirtualMars75, 0x010c as KK],
      [VirtualMars75Pro, 0x010c as KK],
      [VirtualMg68Plus, 0x010c as KK],
      [VirtualIrokFe87V2, 0x1c as KK],
      [VirtualIrokFe87V2_24g, 0x1c as KK],
      [VirtualIrokFe87V2IMC, 0x1c as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1c as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xbb as VK,
    HID: 0x2e as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '<,',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x36 as KK],
      [VirtualFE87V2_MuYan, 0x36 as KK],
      [VirtualPolar75, 0x36 as KK],
      [VirtualMg75, 0x36 as KK],

      [VirtualMg75Pro, 0x36 as KK],
      [VirtualMer68, 0x36 as KK],
      [VirtualMer68Pro, 0x36 as KK],
      [VirtualMer68SE, 0x3a as KK],
      [VirtualMer68Lite, 0x3a as KK],

      [VirtualMu68Pro, 0x36 as KK],
      [VirtualMars68ProWireless, 0x3a as KK],
      [VirtualMars68ProWireless_24g, 0x3a as KK],
      [VirtualMars68, 0x3a as KK],
      [VirtualMg68Lite, 0x3a as KK],
      [VirtualMg68Max, 0x3a as KK],
      [VirtualMg68Max_24g, 0x3a as KK],
      [VirtualMg68Pro, 0x3a as KK],
      [VirtualMg68SE, 0x3a as KK],
      [VirtualMg68, 0x3a as KK],
      [VirtualND63Max, 0x3a as KK],
      [VirtualND68, 0x3a as KK],
      [VirtualMG68ACE_W, 0x3a as KK],
      [VirtualMG68ACE_W_24g, 0x3a as KK],
      [VirtualMG68ACE, 0x3a as KK],
      [VirtualMG68ACE_UpPlus, 0x3a as KK],
      [VirtualMars68Wireless_24g, 0x3a as KK],
      [VirtualMars68Wireless, 0x3a as KK],
      [VirtualMars68Pro, 0x3a as KK],
      [VirtualMars68SE, 0x3a as KK],
      [VirtualMu68Pro_Cyan, 0x36 as KK],
      [VirtualMu68_ULTRA, 0x36 as KK],
      [VirtualNd63, 0x36 as KK],
      [VirtualMG63, 0x36 as KK],
      [VirtualRA68_1, 0x36 as KK],
      [VirtualMG75V2C12, 0x36 as KK],
      [VirtualNd63_Cyan, 0x36 as KK],
      [VirtualMg75Max, 0x0409 as KK],
      [VirtualND68Pro, 0x0409 as KK],
      [VirtualRA68, 0x0409 as KK],
      [VirtualMer68Max, 0x0409 as KK],
      [VirtualMer68SE_JT, 0x0409 as KK],
      [VirtualND63Ultra, 0x0409 as KK],
      [VirtualMars75, 0x0409 as KK],
      [VirtualMars75Pro, 0x0409 as KK],
      [VirtualMg68Plus, 0x0409 as KK],
      [VirtualIrokFe87V2, 0x48 as KK],
      [VirtualIrokFe87V2_24g, 0x48 as KK],
      [VirtualIrokFe87V2IMC, 0x48 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x48 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xbc as VK,
    HID: 0x36 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '-_',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2d as KK],
      [VirtualFE87V2_MuYan, 0x2d as KK],
      [VirtualPolar75, 0x2d as KK],
      [VirtualMg75, 0x2d as KK],

      [VirtualMg75Pro, 0x2d as KK],
      [VirtualMer68, 0x2d as KK],
      [VirtualMer68Pro, 0x2d as KK],
      [VirtualMer68SE, 0x43 as KK],
      [VirtualMer68Lite, 0x43 as KK],

      [VirtualMu68Pro, 0x2d as KK],
      [VirtualMars68ProWireless, 0x43 as KK],
      [VirtualMars68ProWireless_24g, 0x43 as KK],
      [VirtualMars68, 0x43 as KK],
      [VirtualMg68Lite, 0x43 as KK],
      [VirtualMg68Max, 0x43 as KK],
      [VirtualMg68Max_24g, 0x43 as KK],
      [VirtualMg68Pro, 0x43 as KK],
      [VirtualMg68SE, 0x43 as KK],
      [VirtualMg68, 0x43 as KK],
      [VirtualND63Max, 0x43 as KK],
      [VirtualND68, 0x43 as KK],
      [VirtualMG68ACE_W, 0x43 as KK],
      [VirtualMG68ACE_W_24g, 0x43 as KK],
      [VirtualMG68ACE, 0x43 as KK],
      [VirtualMG68ACE_UpPlus, 0x43 as KK],
      [VirtualMars68Wireless_24g, 0x43 as KK],
      [VirtualMars68Wireless, 0x43 as KK],
      [VirtualMars68Pro, 0x43 as KK],
      [VirtualMars68SE, 0x43 as KK],
      [VirtualMu68Pro_Cyan, 0x2d as KK],
      [VirtualMu68_ULTRA, 0x2d as KK],
      [VirtualNd63, 0x2d as KK],
      [VirtualMG63, 0x2d as KK],
      [VirtualRA68_1, 0x2d as KK],
      [VirtualMG75V2C12, 0x2d as KK],
      [VirtualNd63_Cyan, 0x2d as KK],
      [VirtualMg75Max, 0x010b as KK],
      [VirtualND68Pro, 0x010b as KK],
      [VirtualRA68, 0x010b as KK],
      [VirtualMer68Max, 0x010b as KK],
      [VirtualMer68SE_JT, 0x010b as KK],
      [VirtualND63Ultra, 0x010b as KK],
      [VirtualMars75, 0x010b as KK],
      [VirtualMars75Pro, 0x010b as KK],
      [VirtualMg68Plus, 0x010b as KK],
      [VirtualIrokFe87V2, 0x1b as KK],
      [VirtualIrokFe87V2_24g, 0x1b as KK],
      [VirtualIrokFe87V2IMC, 0x1b as KK],
      [VirtualIrokFe87V2IMC_24g, 0x1b as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xbd as VK,
    HID: 0x2d as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '>.',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x37 as KK],
      [VirtualFE87V2_MuYan, 0x37 as KK],
      [VirtualPolar75, 0x37 as KK],
      [VirtualMg75, 0x37 as KK],

      [VirtualMg75Pro, 0x37 as KK],
      [VirtualMer68, 0x37 as KK],
      [VirtualMer68Pro, 0x37 as KK],
      [VirtualMer68SE, 0x40 as KK],
      [VirtualMer68Lite, 0x40 as KK],

      [VirtualMu68Pro, 0x37 as KK],
      [VirtualMars68ProWireless, 0x40 as KK],
      [VirtualMars68ProWireless_24g, 0x40 as KK],
      [VirtualMars68, 0x40 as KK],
      [VirtualMg68Lite, 0x40 as KK],
      [VirtualMg68Max, 0x40 as KK],
      [VirtualMg68Max_24g, 0x40 as KK],
      [VirtualMg68Pro, 0x40 as KK],
      [VirtualMg68SE, 0x40 as KK],
      [VirtualMg68, 0x40 as KK],
      [VirtualND63Max, 0x40 as KK],
      [VirtualND68, 0x40 as KK],
      [VirtualMG68ACE_W, 0x40 as KK],
      [VirtualMG68ACE_W_24g, 0x40 as KK],
      [VirtualMG68ACE, 0x40 as KK],
      [VirtualMG68ACE_UpPlus, 0x40 as KK],
      [VirtualMars68Wireless_24g, 0x40 as KK],
      [VirtualMars68Wireless, 0x40 as KK],
      [VirtualMars68Pro, 0x40 as KK],
      [VirtualMars68SE, 0x40 as KK],
      [VirtualMu68Pro_Cyan, 0x37 as KK],
      [VirtualMu68_ULTRA, 0x37 as KK],
      [VirtualNd63, 0x37 as KK],
      [VirtualMG63, 0x37 as KK],
      [VirtualRA68_1, 0x37 as KK],
      [VirtualMG75V2C12, 0x37 as KK],
      [VirtualNd63_Cyan, 0x37 as KK],
      [VirtualMg75Max, 0x040a as KK],
      [VirtualND68Pro, 0x040a as KK],
      [VirtualRA68, 0x040a as KK],
      [VirtualMer68Max, 0x040a as KK],
      [VirtualMer68SE_JT, 0x040a as KK],
      [VirtualND63Ultra, 0x040a as KK],
      [VirtualMars75, 0x040a as KK],
      [VirtualMars75Pro, 0x040a as KK],
      [VirtualMg68Plus, 0x040a as KK],
      [VirtualIrokFe87V2, 0x49 as KK],
      [VirtualIrokFe87V2_24g, 0x49 as KK],
      [VirtualIrokFe87V2IMC, 0x49 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x49 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xbe as VK,
    HID: 0x37 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '?/',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x38 as KK],
      [VirtualFE87V2_MuYan, 0x38 as KK],
      [VirtualPolar75, 0x38 as KK],
      [VirtualMg75, 0x38 as KK],

      [VirtualMg75Pro, 0x38 as KK],
      [VirtualMer68, 0x38 as KK],
      [VirtualMer68Pro, 0x38 as KK],
      [VirtualMer68SE, 0x46 as KK],
      [VirtualMer68Lite, 0x46 as KK],

      [VirtualMu68Pro, 0x38 as KK],
      [VirtualMars68ProWireless, 0x46 as KK],
      [VirtualMars68ProWireless_24g, 0x46 as KK],
      [VirtualMars68, 0x46 as KK],
      [VirtualMg68Lite, 0x46 as KK],
      [VirtualMg68Max, 0x46 as KK],
      [VirtualMg68Max_24g, 0x46 as KK],
      [VirtualMg68Pro, 0x46 as KK],
      [VirtualMg68SE, 0x46 as KK],
      [VirtualMg68, 0x46 as KK],
      [VirtualND63Max, 0x46 as KK],
      [VirtualND68, 0x46 as KK],
      [VirtualMG68ACE_W, 0x46 as KK],
      [VirtualMG68ACE_W_24g, 0x46 as KK],
      [VirtualMG68ACE, 0x46 as KK],
      [VirtualMG68ACE_UpPlus, 0x46 as KK],
      [VirtualMars68Wireless_24g, 0x46 as KK],
      [VirtualMars68Wireless, 0x46 as KK],
      [VirtualMars68Pro, 0x46 as KK],
      [VirtualMars68SE, 0x46 as KK],
      [VirtualMu68Pro_Cyan, 0x38 as KK],
      [VirtualMu68_ULTRA, 0x38 as KK],
      [VirtualNd63, 0x38 as KK],
      [VirtualMG63, 0x38 as KK],
      [VirtualRA68_1, 0x38 as KK],
      [VirtualMG75V2C12, 0x38 as KK],
      [VirtualNd63_Cyan, 0x38 as KK],
      [VirtualMg75Max, 0x040b as KK],
      [VirtualND68Pro, 0x040b as KK],
      [VirtualRA68, 0x040b as KK],
      [VirtualMer68Max, 0x040b as KK],
      [VirtualMer68SE_JT, 0x040b as KK],
      [VirtualND63Ultra, 0x040b as KK],
      [VirtualMars75, 0x040b as KK],
      [VirtualMars75Pro, 0x040b as KK],
      [VirtualMg68Plus, 0x040b as KK],
      [VirtualIrokFe87V2, 0x4a as KK],
      [VirtualIrokFe87V2_24g, 0x4a as KK],
      [VirtualIrokFe87V2IMC, 0x4a as KK],
      [VirtualIrokFe87V2IMC_24g, 0x4a as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xbf as VK,
    HID: 0x38 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '`~',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x35 as KK],
      [VirtualFE87V2_MuYan, 0x35 as KK],
      [VirtualPolar75, 0x35 as KK],
      [VirtualMg75, 0x35 as KK],

      [VirtualMG75V2C12, 0x35 as KK],
      [VirtualMg75Pro, 0x35 as KK],
      [VirtualMg75Max, 0x0100 as KK],
      [VirtualMars75, 0x0100 as KK],
      [VirtualMars75Pro, 0x0100 as KK],
      [VirtualIrokFe87V2, 0x10 as KK],
      [VirtualIrokFe87V2_24g, 0x10 as KK],
      [VirtualIrokFe87V2IMC, 0x10 as KK],
      [VirtualIrokFe87V2IMC_24g, 0x10 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xc0 as VK,
    HID: 0x35 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '[{',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x2f as KK],
      [VirtualFE87V2_MuYan, 0x2f as KK],
      [VirtualPolar75, 0x2f as KK],
      [VirtualMg75, 0x2f as KK],

      [VirtualMg75Pro, 0x2f as KK],
      [VirtualMer68, 0x2f as KK],
      [VirtualMer68Pro, 0x2f as KK],
      [VirtualMer68SE, 0x44 as KK],
      [VirtualMer68Lite, 0x44 as KK],

      [VirtualMu68Pro, 0x2f as KK],
      [VirtualMars68ProWireless, 0x44 as KK],
      [VirtualMars68ProWireless_24g, 0x44 as KK],
      [VirtualMars68, 0x44 as KK],
      [VirtualMg68Lite, 0x44 as KK],
      [VirtualMg68Max, 0x44 as KK],
      [VirtualMg68Max_24g, 0x44 as KK],
      [VirtualMg68Pro, 0x44 as KK],
      [VirtualMg68SE, 0x44 as KK],
      [VirtualMg68, 0x44 as KK],
      [VirtualND63Max, 0x44 as KK],
      [VirtualND68, 0x44 as KK],
      [VirtualMG68ACE_W, 0x44 as KK],
      [VirtualMG68ACE_W_24g, 0x44 as KK],
      [VirtualMG68ACE, 0x44 as KK],
      [VirtualMG68ACE_UpPlus, 0x44 as KK],
      [VirtualMars68Wireless_24g, 0x44 as KK],
      [VirtualMars68Wireless, 0x44 as KK],
      [VirtualMars68Pro, 0x44 as KK],
      [VirtualMars68SE, 0x44 as KK],
      [VirtualMu68Pro_Cyan, 0x2f as KK],
      [VirtualMu68_ULTRA, 0x2f as KK],
      [VirtualNd63, 0x2f as KK],
      [VirtualMG63, 0x2f as KK],
      [VirtualRA68_1, 0x2f as KK],
      [VirtualMG75V2C12, 0x2f as KK],
      [VirtualNd63_Cyan, 0x2f as KK],
      [VirtualMg75Max, 0x020b as KK],
      [VirtualND68Pro, 0x020b as KK],
      [VirtualRA68, 0x020b as KK],
      [VirtualMer68Max, 0x020b as KK],
      [VirtualMer68SE_JT, 0x020b as KK],
      [VirtualND63Ultra, 0x020b as KK],
      [VirtualMars75, 0x020b as KK],
      [VirtualMars75Pro, 0x020b as KK],
      [VirtualMg68Plus, 0x020b as KK],
      [VirtualIrokFe87V2, 0x2b as KK],
      [VirtualIrokFe87V2_24g, 0x2b as KK],
      [VirtualIrokFe87V2IMC, 0x2b as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2b as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xdb as VK,
    HID: 0x2f as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '|',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x31 as KK],
      [VirtualFE87V2_MuYan, 0x31 as KK],
      [VirtualPolar75, 0x31 as KK],
      [VirtualMg75, 0x31 as KK],

      [VirtualMg75Pro, 0x31 as KK],
      [VirtualMer68, 0x31 as KK],
      [VirtualMer68Pro, 0x31 as KK],
      [VirtualMer68SE, 0x50 as KK],
      [VirtualMer68Lite, 0x50 as KK],

      [VirtualMu68Pro, 0x31 as KK],
      [VirtualMars68ProWireless, 0x50 as KK],
      [VirtualMars68ProWireless_24g, 0x50 as KK],
      [VirtualMars68, 0x50 as KK],
      [VirtualMg68Lite, 0x50 as KK],
      [VirtualMg68Max, 0x50 as KK],
      [VirtualMg68Max_24g, 0x50 as KK],
      [VirtualMg68Pro, 0x50 as KK],
      [VirtualMg68SE, 0x50 as KK],
      [VirtualMg68, 0x50 as KK],
      [VirtualND63Max, 0x50 as KK],
      [VirtualND68, 0x50 as KK],
      [VirtualMG68ACE_W, 0x50 as KK],
      [VirtualMG68ACE_W_24g, 0x50 as KK],
      [VirtualMG68ACE, 0x50 as KK],
      [VirtualMG68ACE_UpPlus, 0x50 as KK],
      [VirtualMars68Wireless_24g, 0x50 as KK],
      [VirtualMars68Wireless, 0x50 as KK],
      [VirtualMars68Pro, 0x50 as KK],
      [VirtualMars68SE, 0x50 as KK],
      [VirtualMu68Pro_Cyan, 0x31 as KK],
      [VirtualMu68_ULTRA, 0x31 as KK],
      [VirtualNd63, 0x31 as KK],
      [VirtualMG63, 0x31 as KK],
      [VirtualRA68_1, 0x31 as KK],
      [VirtualMG75V2C12, 0x31 as KK],
      [VirtualNd63_Cyan, 0x31 as KK],
      [VirtualMg75Max, 0x020d as KK],
      [VirtualND68Pro, 0x020d as KK],
      [VirtualRA68, 0x020d as KK],
      [VirtualMer68Max, 0x020d as KK],
      [VirtualMer68SE_JT, 0x020d as KK],
      [VirtualND63Ultra, 0x020d as KK],
      [VirtualMars75, 0x020d as KK],
      [VirtualMars75Pro, 0x020d as KK],
      [VirtualMg68Plus, 0x020d as KK],
      [VirtualIrokFe87V2, 0x2d as KK],
      [VirtualIrokFe87V2_24g, 0x2d as KK],
      [VirtualIrokFe87V2IMC, 0x2d as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2d as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xdc as VK,
    HID: 0x31 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: ']}',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x30 as KK],
      [VirtualFE87V2_MuYan, 0x30 as KK],
      [VirtualPolar75, 0x30 as KK],
      [VirtualMg75, 0x30 as KK],

      [VirtualMg75Pro, 0x30 as KK],
      [VirtualMer68, 0x30 as KK],
      [VirtualMer68Pro, 0x30 as KK],
      [VirtualMer68SE, 0x4a as KK],
      [VirtualMer68Lite, 0x4a as KK],
      [VirtualMu68Pro, 0x30 as KK],
      [VirtualMars68ProWireless, 0x4a as KK],
      [VirtualMars68ProWireless_24g, 0x4a as KK],
      [VirtualMars68, 0x4a as KK],
      [VirtualMg68Lite, 0x4a as KK],
      [VirtualMg68Max, 0x4a as KK],
      [VirtualMg68Max_24g, 0x4a as KK],
      [VirtualMg68Pro, 0x4a as KK],
      [VirtualMg68SE, 0x4a as KK],
      [VirtualMg68, 0x4a as KK],
      [VirtualND63Max, 0x4a as KK],
      [VirtualND68, 0x4a as KK],
      [VirtualMG68ACE_W, 0x4a as KK],
      [VirtualMG68ACE_W_24g, 0x4a as KK],
      [VirtualMG68ACE, 0x4a as KK],
      [VirtualMG68ACE_UpPlus, 0x4a as KK],
      [VirtualMars68Wireless_24g, 0x4a as KK],
      [VirtualMars68Wireless, 0x4a as KK],
      [VirtualMars68Pro, 0x4a as KK],
      [VirtualMars68SE, 0x4a as KK],
      [VirtualMu68Pro_Cyan, 0x30 as KK],
      [VirtualMu68_ULTRA, 0x30 as KK],
      [VirtualNd63, 0x30 as KK],
      [VirtualMG63, 0x30 as KK],
      [VirtualRA68_1, 0x30 as KK],
      [VirtualMG75V2C12, 0x30 as KK],
      [VirtualNd63_Cyan, 0x30 as KK],
      [VirtualMg75Max, 0x020c as KK],
      [VirtualND68Pro, 0x020c as KK],
      [VirtualRA68, 0x020c as KK],
      [VirtualMer68Max, 0x020c as KK],
      [VirtualMer68SE_JT, 0x020c as KK],
      [VirtualND63Ultra, 0x020c as KK],
      [VirtualMars75, 0x020c as KK],
      [VirtualMars75Pro, 0x020c as KK],
      [VirtualMg68Plus, 0x020c as KK],
      [VirtualIrokFe87V2, 0x2c as KK],
      [VirtualIrokFe87V2_24g, 0x2c as KK],
      [VirtualIrokFe87V2IMC, 0x2c as KK],
      [VirtualIrokFe87V2IMC_24g, 0x2c as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xdd as VK,
    HID: 0x30 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: '"', //引号
    Keys: new Map<DefineDevice, KK>([
      [VirtualNa87ProWired, 0x34 as KK],
      [VirtualFE87V2_MuYan, 0x34 as KK],
      [VirtualPolar75, 0x34 as KK],
      [VirtualMg75, 0x34 as KK],

      [VirtualMg75Pro, 0x34 as KK],
      [VirtualMer68, 0x34 as KK],
      [VirtualMer68Pro, 0x34 as KK],
      [VirtualMer68SE, 0x45 as KK],
      [VirtualMer68Lite, 0x45 as KK],

      [VirtualMu68Pro, 0x34 as KK],
      [VirtualMars68ProWireless, 0x45 as KK],
      [VirtualMars68ProWireless_24g, 0x45 as KK],
      [VirtualMars68, 0x45 as KK],
      [VirtualMg68Lite, 0x45 as KK],
      [VirtualMg68Max, 0x45 as KK],
      [VirtualMg68Max_24g, 0x45 as KK],
      [VirtualMg68Pro, 0x45 as KK],
      [VirtualMg68SE, 0x45 as KK],
      [VirtualMg68, 0x45 as KK],
      [VirtualND63Max, 0x45 as KK],
      [VirtualND68, 0x45 as KK],
      [VirtualMG68ACE_W, 0x45 as KK],
      [VirtualMG68ACE_W_24g, 0x45 as KK],
      [VirtualMG68ACE, 0x45 as KK],
      [VirtualMG68ACE_UpPlus, 0x45 as KK],
      [VirtualMars68Wireless_24g, 0x45 as KK],
      [VirtualMars68Wireless, 0x45 as KK],
      [VirtualMars68Pro, 0x45 as KK],
      [VirtualMars68SE, 0x45 as KK],
      [VirtualMu68Pro_Cyan, 0x34 as KK],
      [VirtualMu68_ULTRA, 0x34 as KK],
      [VirtualNd63, 0x34 as KK],
      [VirtualMG63, 0x34 as KK],
      [VirtualRA68_1, 0x34 as KK],
      [VirtualMG75V2C12, 0x34 as KK],
      [VirtualNd63_Cyan, 0x34 as KK],
      [VirtualMg75Max, 0x030b as KK],
      [VirtualND68Pro, 0x030b as KK],
      [VirtualRA68, 0x030b as KK],
      [VirtualMer68Max, 0x030b as KK],
      [VirtualMer68SE_JT, 0x030b as KK],
      [VirtualND63Ultra, 0x030b as KK],
      [VirtualMars75, 0x030b as KK],
      [VirtualMars75Pro, 0x030b as KK],
      [VirtualMg68Plus, 0x030b as KK],
      [VirtualIrokFe87V2, 0x3b as KK],
      [VirtualIrokFe87V2_24g, 0x3b as KK],
      [VirtualIrokFe87V2IMC, 0x3b as KK],
      [VirtualIrokFe87V2IMC_24g, 0x3b as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xde as VK,
    HID: 0x34 as VK,
    Disable: false,
    Zone: KeyZone.normalKey,
  },
  {
    Text: 'Numeric keypad 1',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x61 as VK,
    HID: 0x59 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 2',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x62 as VK,
    HID: 0x5a as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 3',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x63 as VK,
    HID: 0x5b as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 4',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x64 as VK,
    HID: 0x5c as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 5',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x65 as VK,
    HID: 0x5d as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 6',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x66 as VK,
    HID: 0x5e as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 7',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x67 as VK,
    HID: 0x5f as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 8',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x68 as VK,
    HID: 0x60 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 9',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x69 as VK,
    HID: 0x61 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad 0',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x60 as VK,
    HID: 0x62 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Num',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x90 as VK,
    HID: 0x53 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad /',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x6f as VK,
    HID: 0x54 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad *',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x6a as VK,
    HID: 0x55 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad -',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x6d as VK,
    HID: 0x56 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad +',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x6b as VK,
    HID: 0x57 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad Enter',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0xfd as VK,
    HID: 0x58 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'Numeric keypad .',
    Keys: new Map<DefineDevice, KK>([
      [VirtualNd63, 0x63 as KK],
      [VirtualNd63_Cyan, 0x63 as KK],
    ]),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>(),
    VirtualKey: 0x6e as VK,
    HID: 0x63 as VK,
    Disable: false,
    Zone: KeyZone.extendKey,
  },
  {
    Text: 'RWIN',
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x80 as DVK],
      [VirtualHE3SEWireless, 0x80 as DVK],
      [VirtualHe6Ultra, 0x80 as DVK],
    ]),
    VirtualKey: 0x5c as VK,
    HID: 0xe7 as VK,
    Disable: false,
    Zone: KeyZone.modifierKey,
  },
  {
    Text: 'Browser Back key', //返回
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030224 as DVK],
      [VirtualHE3SEWireless, 0x030224 as DVK],
      [VirtualMars68, 0x030224 as DVK],
      [VirtualNa87ProWired, 0x1224 as DVK],
      [VirtualHe6Ultra, 0x03ed0224 as DVK],
      [VirtualMg68Plus, 0x2224 as DVK],
      [VirtualMg75Max, 0x2224 as DVK],
      [VirtualMars75, 0x2224 as DVK],
      [VirtualRA68, 0x2224 as DVK],
      [VirtualMars75Pro, 0x2224 as DVK],
      [VirtualND68Pro, 0x2224 as DVK],
      [VirtualMer68Max, 0x2224 as DVK],
      [VirtualMer68SE_JT, 0x2224 as DVK],
      [VirtualND63Ultra, 0x2024 as DVK],
      [VirtualIrokFe87V2, 0x0090 as DVK],
      [VirtualIrokFe87V2IMC, 0x0090 as DVK],
      [VirtualMG63, 0x04000224 as DVK],
      [VirtualRA68_1, 0x04000224 as DVK],
      [VirtualMG75V2C12, 0x04000224 as DVK],
      [VirtualFE87V2_MuYan, 0x224 as DVK],
    ]),
    VirtualKey: 0xa6 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Browser Forward key', //前进
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030225 as DVK],
      [VirtualHE3SEWireless, 0x030225 as DVK],
      [VirtualMars68, 0x030225 as DVK],
      [VirtualNa87ProWired, 0x1225 as DVK],
      [VirtualHe6Ultra, 0x03ed0225 as DVK],
      [VirtualMg68Plus, 0x2225 as DVK],
      [VirtualMg75Max, 0x2225 as DVK],
      [VirtualMars75, 0x2225 as DVK],
      [VirtualRA68, 0x2225 as DVK],
      [VirtualMars75Pro, 0x2225 as DVK],
      [VirtualND68Pro, 0x2225 as DVK],
      [VirtualMer68Max, 0x2225 as DVK],
      [VirtualMer68SE_JT, 0x2225 as DVK],
      [VirtualND63Ultra, 0x2225 as DVK],
      [VirtualIrokFe87V2, 0x0091 as DVK],
      [VirtualIrokFe87V2IMC, 0x0091 as DVK],
      [VirtualMG63, 0x04000225 as DVK],
      [VirtualRA68_1, 0x04000225 as DVK],
      [VirtualMG75V2C12, 0x04000225 as DVK],
      [VirtualFE87V2_MuYan, 0x225 as DVK],
    ]),
    VirtualKey: 0xa7 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Browser Refresh key', //刷新
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030227 as DVK],
      [VirtualHE3SEWireless, 0x030227 as DVK],
      [VirtualNa87ProWired, 0x1227 as DVK],
      [VirtualMars68, 0x030227 as DVK],
      [VirtualHe6Ultra, 0x03ed0227 as DVK],
      [VirtualMg68Plus, 0x2227 as DVK],
      [VirtualMg75Max, 0x2227 as DVK],
      [VirtualMars75, 0x2227 as DVK],
      [VirtualRA68, 0x2227 as DVK],
      [VirtualMars75Pro, 0x2227 as DVK],
      [VirtualND68Pro, 0x2227 as DVK],
      [VirtualMer68Max, 0x2227 as DVK],
      [VirtualMer68SE_JT, 0x2227 as DVK],
      [VirtualND63Ultra, 0x2227 as DVK],
      [VirtualIrokFe87V2, 0x0092 as DVK],
      [VirtualIrokFe87V2IMC, 0x0092 as DVK],
      [VirtualMG63, 0x04000227 as DVK],
      [VirtualRA68_1, 0x04000227 as DVK],
      [VirtualMG75V2C12, 0x04000227 as DVK],
      [VirtualFE87V2_MuYan, 0x227 as DVK],
    ]),
    VirtualKey: 0xa8 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Browser Stop key', //停止
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300b7 as DVK],
      [VirtualHE3SEWireless, 0x0300b7 as DVK],
      [VirtualMars68, 0x0300b7 as DVK],
      [VirtualNa87ProWired, 0x10b7 as DVK],
      [VirtualHe6Ultra, 0x03ed0226 as DVK],
      [VirtualMg68Plus, 0x2226 as DVK],
      [VirtualMg75Max, 0x2226 as DVK],
      [VirtualMars75, 0x2226 as DVK],
      [VirtualRA68, 0x2226 as DVK],
      [VirtualMars75Pro, 0x2226 as DVK],
      [VirtualND68Pro, 0x2226 as DVK],
      [VirtualMer68Max, 0x2226 as DVK],
      [VirtualMer68SE_JT, 0x2226 as DVK],
      [VirtualND63Ultra, 0x2226 as DVK],
      [VirtualIrokFe87V2, 0x0093 as DVK],
      [VirtualIrokFe87V2IMC, 0x0093 as DVK],
      [VirtualMG63, 0x04000226 as DVK],
      [VirtualRA68_1, 0x04000226 as DVK],
      [VirtualMG75V2C12, 0x04000226 as DVK],
      [VirtualFE87V2_MuYan, 0x226 as DVK],
    ]),
    VirtualKey: 0xa9 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Browser Search key', //搜索
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030221 as DVK],
      [VirtualHE3SEWireless, 0x030221 as DVK],
      [VirtualMars68, 0x030221 as DVK],
      [VirtualNa87ProWired, 0x1221 as DVK],
      [VirtualHe6Ultra, 0x03ed0221 as DVK],
      [VirtualMg68Plus, 0x2021 as DVK],
      [VirtualMg75Max, 0x2021 as DVK],
      [VirtualMg68Plus, 0x2221 as DVK],
      [VirtualMars75, 0x2221 as DVK],
      [VirtualRA68, 0x2221 as DVK],
      [VirtualMars75Pro, 0x2221 as DVK],
      [VirtualMer68Max, 0x2221 as DVK],
      [VirtualMer68SE_JT, 0x2221 as DVK],
      [VirtualND63Ultra, 0x2221 as DVK],
      [VirtualIrokFe87V2, 0x0094 as DVK],
      [VirtualIrokFe87V2IMC, 0x0094 as DVK],
      [VirtualMG63, 0x04000221 as DVK],
      [VirtualRA68_1, 0x04000221 as DVK],
      [VirtualMG75V2C12, 0x04000221 as DVK],
      [VirtualFE87V2_MuYan, 0x221 as DVK],
    ]),
    VirtualKey: 0xaa as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  // {
  // 	Text: "Browser Favorites key",//收藏夹
  // 	Keys: new Map<DefineDevice, KK>(),
  // 	LKeys: new Map<DefineDevice, LK>(),
  // 	DVKs: new Map<DefineDevice, DVK>(
  // 		[
  // 			[VirtualHE3SEWired, 0x03022A as DVK],
  // 			[VirtualHE3SEWireless, 0x03022A as DVK],
  // 			[VirtualNa87ProWired, 0x122A as DVK]
  // 		]
  // 	),
  // 	VirtualKey: 0xAB as VK,
  // 	HID: 0x00 as VK, // 请根据实际 HID 值进行填充
  // 	Disable: false,
  // 	Zone: KeyZone.media,
  // },
  {
    Text: 'Browser Start and Home key', //主页,启动浏览器，网页
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030223 as DVK],
      [VirtualHE3SEWireless, 0x030223 as DVK],
      [VirtualMars68, 0x030223 as DVK],
      [VirtualNa87ProWired, 0x1223 as DVK],
      [VirtualHe6Ultra, 0x03ed0223 as DVK],
      [VirtualMg68Plus, 0x2223 as DVK],
      [VirtualMg75Max, 0x2223 as DVK],
      [VirtualMars75, 0x2223 as DVK],
      [VirtualRA68, 0x2223 as DVK],
      [VirtualMars75Pro, 0x2223 as DVK],
      [VirtualND68Pro, 0x2223 as DVK],
      [VirtualMer68Max, 0x2223 as DVK],
      [VirtualMer68SE_JT, 0x2223 as DVK],
      [VirtualND63Ultra, 0x2223 as DVK],
      [VirtualIrokFe87V2, 0x0095 as DVK],
      [VirtualIrokFe87V2IMC, 0x0095 as DVK],
      [VirtualMG63, 0x04000223 as DVK],
      [VirtualRA68_1, 0x04000223 as DVK],
      [VirtualMG75V2C12, 0x04000223 as DVK],
      [VirtualFE87V2_MuYan, 0x223 as DVK],
    ]),
    VirtualKey: 0xac as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Volume Mute key', //静音
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300e2 as DVK],
      [VirtualHE3SEWireless, 0x0300e2 as DVK],
      [VirtualMars68, 0x0300e2 as DVK],
      [VirtualNa87ProWired, 0x10e2 as DVK],
      [VirtualHe6Ultra, 0x03ed00e2 as DVK],
      [VirtualMg68Plus, 0x20e2 as DVK],
      [VirtualMg75Max, 0x20e2 as DVK],
      [VirtualND68Pro, 0x20e2 as DVK],
      [VirtualMars75, 0x20e2 as DVK],
      [VirtualRA68, 0x20e2 as DVK],
      [VirtualMars75Pro, 0x20e2 as DVK],
      [VirtualMer68Max, 0x20e2 as DVK],
      [VirtualMer68SE_JT, 0x20e2 as DVK],
      [VirtualND63Ultra, 0x20e2 as DVK],
      [VirtualIrokFe87V2, 0x0096 as DVK],
      [VirtualIrokFe87V2IMC, 0x0096 as DVK],
      [VirtualMG63, 0x040000e2 as DVK],
      [VirtualRA68_1, 0x040000e2 as DVK],
      [VirtualMG75V2C12, 0x040000e2 as DVK],
      [VirtualFE87V2_MuYan, 0xe2 as DVK],
    ]),
    VirtualKey: 0xad as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Volume Down key', //音量减
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300ea as DVK],
      [VirtualHE3SEWireless, 0x0300ea as DVK],
      [VirtualMars68, 0x0300ea as DVK],
      [VirtualNa87ProWired, 0x10ea as DVK],
      [VirtualHe6Ultra, 0x03ed00ea as DVK],
      [VirtualMg68Plus, 0x20ea as DVK],
      [VirtualMg75Max, 0x20ea as DVK],
      [VirtualMars75, 0x20ea as DVK],
      [VirtualRA68, 0x20ea as DVK],
      [VirtualMars75Pro, 0x20ea as DVK],
      [VirtualND68Pro, 0x20ea as DVK],
      [VirtualMer68Max, 0x20ea as DVK],
      [VirtualMer68SE_JT, 0x20ea as DVK],
      [VirtualND63Ultra, 0x20ea as DVK],
      [VirtualIrokFe87V2, 0x0097 as DVK],
      [VirtualIrokFe87V2IMC, 0x0097 as DVK],
      [VirtualMG63, 0x040000ea as DVK],
      [VirtualRA68_1, 0x040000ea as DVK],
      [VirtualMG75V2C12, 0x040000ea as DVK],
      [VirtualFE87V2_MuYan, 0xea as DVK],
    ]),
    VirtualKey: 0xae as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Volume Up key', //音量加
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300e9 as DVK],
      [VirtualHE3SEWireless, 0x0300e9 as DVK],
      [VirtualMars68, 0x0300e9 as DVK],
      [VirtualNa87ProWired, 0x10e9 as DVK],
      [VirtualHe6Ultra, 0x03ed00e9 as DVK],
      [VirtualMg68Plus, 0x20e9 as DVK],
      [VirtualMg75Max, 0x20e9 as DVK],
      [VirtualMars75, 0x20e9 as DVK],
      [VirtualRA68, 0x20e9 as DVK],
      [VirtualMars75Pro, 0x20e9 as DVK],
      [VirtualND68Pro, 0x20e9 as DVK],
      [VirtualMer68Max, 0x20e9 as DVK],
      [VirtualMer68SE_JT, 0x20e9 as DVK],
      [VirtualND63Ultra, 0x20e9 as DVK],
      [VirtualMG63, 0x040000e9 as DVK],
      [VirtualRA68_1, 0x040000e9 as DVK],
      [VirtualMG75V2C12, 0x040000e9 as DVK],
      [VirtualIrokFe87V2, 0x0098 as DVK],
      [VirtualIrokFe87V2IMC, 0x0098 as DVK],
      [VirtualFE87V2_MuYan, 0xe9 as DVK],
    ]),
    VirtualKey: 0xaf as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Next Track key', //媒体下一首
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300b5 as DVK],
      [VirtualHE3SEWireless, 0x0300b5 as DVK],
      [VirtualMars68, 0x0300b5 as DVK],
      [VirtualNa87ProWired, 0x10b5 as DVK],
      [VirtualHe6Ultra, 0x03ed00b5 as DVK],
      [VirtualMg68Plus, 0x20b5 as DVK],
      [VirtualMg75Max, 0x20b5 as DVK],
      [VirtualMars75, 0x20b5 as DVK],
      [VirtualRA68, 0x20b5 as DVK],
      [VirtualMars75Pro, 0x20b5 as DVK],
      [VirtualND68Pro, 0x20b5 as DVK],
      [VirtualMer68Max, 0x20b5 as DVK],
      [VirtualMer68SE_JT, 0x20b5 as DVK],
      [VirtualND63Ultra, 0x20b5 as DVK],
      [VirtualIrokFe87V2, 0x0099 as DVK],
      [VirtualIrokFe87V2IMC, 0x0099 as DVK],
      [VirtualMG63, 0x040000b5 as DVK],
      [VirtualRA68_1, 0x040000b5 as DVK],
      [VirtualMG75V2C12, 0x040000b5 as DVK],
      [VirtualFE87V2_MuYan, 0xb5 as DVK],
    ]),
    VirtualKey: 0xb0 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Previous Track key', //媒体上一首
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300b6 as DVK],
      [VirtualHE3SEWireless, 0x0300b6 as DVK],
      [VirtualMars68, 0x0300b6 as DVK],
      [VirtualNa87ProWired, 0x10b6 as DVK],
      [VirtualHe6Ultra, 0x03ed00b6 as DVK],
      [VirtualMg68Plus, 0x20b6 as DVK],
      [VirtualMg75Max, 0x20b6 as DVK],
      [VirtualMars75, 0x20b6 as DVK],
      [VirtualRA68, 0x20b6 as DVK],
      [VirtualMars75Pro, 0x20b6 as DVK],
      [VirtualND68Pro, 0x20b6 as DVK],
      [VirtualMer68Max, 0x20b6 as DVK],
      [VirtualMer68SE_JT, 0x20b6 as DVK],
      [VirtualND63Ultra, 0x20b6 as DVK],
      [VirtualIrokFe87V2, 0x009a as DVK],
      [VirtualIrokFe87V2IMC, 0x009a as DVK],
      [VirtualMG63, 0x040000b6 as DVK],
      [VirtualRA68_1, 0x040000b6 as DVK],
      [VirtualMG75V2C12, 0x040000b6 as DVK],
      [VirtualFE87V2_MuYan, 0xb6 as DVK],
    ]),
    VirtualKey: 0xb1 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Stop Media key', //媒体停止
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300b7 as DVK],
      [VirtualHE3SEWireless, 0x0300b7 as DVK],
      [VirtualMars68, 0x0300b7 as DVK],
      [VirtualNa87ProWired, 0x10b7 as DVK],
      [VirtualHe6Ultra, 0x03ed00b7 as DVK],
      [VirtualMg68Plus, 0x20b7 as DVK],
      [VirtualMg75Max, 0x20b7 as DVK],
      [VirtualMars75, 0x20b7 as DVK],
      [VirtualRA68, 0x20b7 as DVK],
      [VirtualMars75Pro, 0x20b7 as DVK],
      [VirtualND68Pro, 0x20b7 as DVK],
      [VirtualMer68Max, 0x20b7 as DVK],
      [VirtualMer68SE_JT, 0x20b7 as DVK],
      [VirtualND63Ultra, 0x20b7 as DVK],
      [VirtualIrokFe87V2, 0x009b as DVK],
      [VirtualIrokFe87V2IMC, 0x009b as DVK],
      [VirtualMG63, 0x040000b7 as DVK],
      [VirtualRA68_1, 0x040000b7 as DVK],
      [VirtualMG75V2C12, 0x040000b7 as DVK],
      [VirtualFE87V2_MuYan, 0xb7 as DVK],
    ]),
    VirtualKey: 0xb2 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Play/Pause Media key', //媒体播放/暂停
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x0300cd as DVK],
      [VirtualHE3SEWireless, 0x0300cd as DVK],
      [VirtualMars68, 0x0300cd as DVK],
      [VirtualNa87ProWired, 0x10cd as DVK],
      [VirtualHe6Ultra, 0x03ed00cd as DVK],
      [VirtualMg68Plus, 0x20cd as DVK],
      [VirtualMg75Max, 0x20cd as DVK],
      [VirtualMars75, 0x20cd as DVK],
      [VirtualRA68, 0x20cd as DVK],
      [VirtualMars75Pro, 0x20cd as DVK],
      [VirtualND68Pro, 0x20cd as DVK],
      [VirtualMer68Max, 0x20cd as DVK],
      [VirtualMer68SE_JT, 0x20cd as DVK],
      [VirtualND63Ultra, 0x20cd as DVK],
      [VirtualIrokFe87V2, 0x009c as DVK],
      [VirtualIrokFe87V2IMC, 0x009c as DVK],
      [VirtualMG63, 0x040000cd as DVK],
      [VirtualRA68_1, 0x040000cd as DVK],
      [VirtualMG75V2C12, 0x040000cd as DVK],
      [VirtualFE87V2_MuYan, 0xcd as DVK],
    ]),
    VirtualKey: 0xb3 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Start Mail key', //启动邮件客户端
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x03018a as DVK],
      [VirtualHE3SEWireless, 0x03018a as DVK],
      [VirtualMars68, 0x03018a as DVK],
      [VirtualNa87ProWired, 0x118a as DVK],
      [VirtualHe6Ultra, 0x03ed018a as DVK],
      [VirtualMg68Plus, 0x218a as DVK],
      [VirtualMg75Max, 0x218a as DVK],
      [VirtualMars75, 0x218a as DVK],
      [VirtualRA68, 0x218a as DVK],
      [VirtualMars75Pro, 0x218a as DVK],
      [VirtualND68Pro, 0x218a as DVK],
      [VirtualMer68Max, 0x218a as DVK],
      [VirtualMer68SE_JT, 0x218a as DVK],
      [VirtualND63Ultra, 0x218a as DVK],
      [VirtualIrokFe87V2, 0x009d as DVK],
      [VirtualIrokFe87V2IMC, 0x009d as DVK],
      [VirtualMG63, 0x0400018a as DVK],
      [VirtualRA68_1, 0x0400018a as DVK],
      [VirtualMG75V2C12, 0x0400018a as DVK],
      [VirtualFE87V2_MuYan, 0x018a as DVK],
    ]),
    VirtualKey: 0xb4 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'Select Media key', //启动媒体播放器
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030183 as DVK],
      [VirtualHE3SEWireless, 0x030183 as DVK],
      [VirtualMars68, 0x030183 as DVK],
      [VirtualNa87ProWired, 0x1183 as DVK],
      [VirtualHe6Ultra, 0x03ed0183 as DVK],
      [VirtualMg68Plus, 0x2183 as DVK],
      [VirtualMg75Max, 0x2183 as DVK],
      [VirtualMars75, 0x2183 as DVK],
      [VirtualRA68, 0x2183 as DVK],
      [VirtualMars75Pro, 0x2183 as DVK],
      [VirtualND68Pro, 0x2183 as DVK],
      [VirtualMer68Max, 0x2183 as DVK],
      [VirtualMer68SE_JT, 0x2183 as DVK],
      [VirtualND63Ultra, 0x2183 as DVK],
      [VirtualIrokFe87V2, 0x009e as DVK],
      [VirtualIrokFe87V2IMC, 0x009e as DVK],
      [VirtualMG63, 0x04000183 as DVK],
      [VirtualRA68_1, 0x04000183 as DVK],
      [VirtualMG75V2C12, 0x04000183 as DVK],
      [VirtualFE87V2_MuYan, 0x0183 as DVK],
    ]),
    VirtualKey: 0xb5 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'VK_LAUNCH_APP1', //启动计算机
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030194 as DVK],
      [VirtualHE3SEWireless, 0x030194 as DVK],
      [VirtualMars68, 0x030194 as DVK],
      [VirtualNa87ProWired, 0x1194 as DVK],
      [VirtualHe6Ultra, 0x03ed0194 as DVK],
      [VirtualMg68Plus, 0x2194 as DVK],
      [VirtualMg75Max, 0x2194 as DVK],
      [VirtualMars75, 0x2194 as DVK],
      [VirtualRA68, 0x2194 as DVK],
      [VirtualMars75Pro, 0x2194 as DVK],
      [VirtualND68Pro, 0x2194 as DVK],
      [VirtualMer68Max, 0x2194 as DVK],
      [VirtualMer68SE_JT, 0x2194 as DVK],
      [VirtualND63Ultra, 0x2194 as DVK],
      [VirtualIrokFe87V2, 0x009f as DVK],
      [VirtualIrokFe87V2IMC, 0x009f as DVK],
      [VirtualMG63, 0x04000194 as DVK],
      [VirtualRA68_1, 0x04000194 as DVK],
      [VirtualMG75V2C12, 0x04000194 as DVK],
      [VirtualFE87V2_MuYan, 0x0194 as DVK],
    ]),
    VirtualKey: 0xb6 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
  {
    Text: 'VK_LAUNCH_APP2', //计算器
    Keys: new Map<DefineDevice, KK>(),
    LKeys: new Map<DefineDevice, LK>(),
    DVKs: new Map<DefineDevice, DVK>([
      [VirtualHE3SEWireless_24g, 0x030192 as DVK],
      [VirtualHE3SEWireless, 0x030192 as DVK],
      [VirtualMars68, 0x030192 as DVK],
      [VirtualNa87ProWired, 0x1192 as DVK],
      [VirtualHe6Ultra, 0x03ed0192 as DVK],
      [VirtualMg68Plus, 0x2192 as DVK],
      [VirtualMg75Max, 0x2192 as DVK],
      [VirtualMars75, 0x2192 as DVK],
      [VirtualRA68, 0x2192 as DVK],
      [VirtualMars75Pro, 0x2192 as DVK],
      [VirtualND68Pro, 0x2192 as DVK],
      [VirtualMer68Max, 0x2192 as DVK],
      [VirtualMer68SE_JT, 0x2192 as DVK],
      [VirtualND63Ultra, 0x2192 as DVK],
      [VirtualIrokFe87V2, 0x00a0 as DVK],
      [VirtualIrokFe87V2IMC, 0x00a0 as DVK],
      [VirtualMG63, 0x04000192 as DVK],
      [VirtualRA68_1, 0x04000192 as DVK],
      [VirtualMG75V2C12, 0x04000192 as DVK],
      [VirtualFE87V2_MuYan, 0x0192 as DVK],
    ]),
    VirtualKey: 0xb7 as VK,
    HID: 0x00 as VK, // 请根据实际 HID 值进行填充
    Disable: false,
    Zone: KeyZone.media,
  },
]

// IROK FeV2 C18（FE87 V2 单模 机械键盘）与 C38（VirtualIrokFe87V2，三模有线）共用 PCB / 固件，
// KK / DVK 行为完全一致，且无 2.4G 变体；这里集中镜像，避免在每个条目都重复一遍。
// 如果将来 C18 与 C38 出现硬件级差异，再在对应条目内显式拆分。
keys.forEach((key) => {
  const dvk = key.DVKs.get(VirtualIrokFe87V2)
  if (dvk !== undefined && !key.DVKs.has(VirtualIrokFe87V2C18)) {
    key.DVKs.set(VirtualIrokFe87V2C18, dvk)
  }
  const kk = key.Keys.get(VirtualIrokFe87V2)
  if (kk !== undefined && !key.Keys.has(VirtualIrokFe87V2C18)) {
    key.Keys.set(VirtualIrokFe87V2C18, kk)
  }
  const lk = key.LKeys.get(VirtualIrokFe87V2)
  if (lk !== undefined && !key.LKeys.has(VirtualIrokFe87V2C18)) {
    key.LKeys.set(VirtualIrokFe87V2C18, lk)
  }
})

interface MirrorDeviceKeyOptions {
  keys?: boolean
  dvks?: boolean
  lkeys?: boolean
}

const mirrorDeviceKeys = (from: DefineDevice, to: DefineDevice, options: MirrorDeviceKeyOptions) => {
  keys.forEach((key) => {
    if (options.dvks) {
      const dvk = key.DVKs.get(from)
      if (dvk !== undefined && !key.DVKs.has(to)) {
        key.DVKs.set(to, dvk)
      }
    }

    if (options.keys) {
      const kk = key.Keys.get(from)
      if (kk !== undefined && !key.Keys.has(to)) {
        key.Keys.set(to, kk)
      }
    }

    if (options.lkeys) {
      const lk = key.LKeys.get(from)
      if (lk !== undefined && !key.LKeys.has(to)) {
        key.LKeys.set(to, lk)
      }
    }
  })
}

// Device key mirror rules. Add new fully-compatible device variants below.
mirrorDeviceKeys(VirtualIrokFe87V2, VirtualIrokFe87V2C18, { keys: true, dvks: true, lkeys: true })
